import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";

import axios, { post } from "axios";
import PostAddIcon from "@mui/icons-material/PostAdd";
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import CloseIcon from "@mui/icons-material/Close";
import UploadIcon from '@mui/icons-material/Upload';
import PersonIcon from '@mui/icons-material/Person';
import LocalMallSharpIcon from '@mui/icons-material/LocalMallSharp';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CiExport } from "react-icons/ci";
import {
  Card,
  CardHeader,
  CardTitle,
  CardText,
  Input,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  CardBody,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import {
  postMethod,
} from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import { API_BASE_URL, WEB_BASE_URL } from "../../../../_services/constant";
import { Divider, Grid, Button, Tooltip } from "@material-ui/core";
import ReactDatatable from "@ashvin27/react-datatable";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { addDays } from "date-fns";
import moment from "moment";
import { DateRangePicker } from "react-date-range";
import { DateTimePicker, KeyboardDateTimePicker } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";

import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DeleteIcon from "@material-ui/icons/Delete";
import Chart from "react-apexcharts";
import "../../../../_assets/css/flip.css";
import generatePDF, { Margin, Resolution } from "react-to-pdf";
import Extra from "./Extra";
import Design from "./Design";
import Whatsapp from "./Whatsapp";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import FullScreenLoader from "./FullScreenLoader";
import NotificationBell from "./NotificationBell";
import ServiceAuto from "./AutombileService/ServiceAuto";
import SubService from "./AutombileService/SubService";
import CustomRedeem from "./external_component/CustomRedeem";
import { MDBIcon } from "mdbreact";
import SalesCard from "./SalesCard";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  countTooltip: {
    fontSize: "14px",
    fontWeight: 700,
    padding: "8px 12px",
  },
});
const countStyle = {
  position: "absolute",
  top: "-15px",
  right: "-10px",
  backgroundColor: "red",
  color: "white",
  borderRadius: "50%",
  padding: "5px",
  minWidth: "20px",
  minHeight: "15px",
  textAlign: "center",
};

const buttonStyle = {
  position: "relative",
  borderRadius: "10px",
  right: "20px",
  backgroundColor: "#e8dfc5",
  color: "blue",
  border: "none",
  cursor: "pointer",
};

// function ProductCard({ item, index }) {
//   const [isFlipped, setIsFlipped] = useState(false);

//   const handleFlip = () => {
//     setIsFlipped(!isFlipped);
//   };

//   const imageSrc =
//     item?.isImageUrl == 1 || item?.image_path?.startsWith("http")
//       ? item?.image_path
//       : (item?.url_image || "") + (item?.image_path || "");

//   const formattedDateTime =
//     item.datetime != "" && item.datetime != null
//       ? moment(item.datetime.replace(" ", "T")).format("DD/MM/yyyy HH:mm")
//       : null;

//   const [cartDate, cartTime] = formattedDateTime
//     ? formattedDateTime.split(" ")
//     : ["", ""];

//   return (
//     <div className="col-sm-3" key={index}>
//       <div
//         className={`product-card ${isFlipped ? "flipped" : ""}`}
//         onClick={handleFlip}
//       >
//         <div className="card-inner">
//           <div className="card-front">
//             <div className="image-container">
//               <img
//                 src={imageSrc}
//                 alt={index}
//                 onError={(e) => {
//                   e.target.src = "/no-image.png";
//                 }}
//               />
//             </div>
//             <div className="text-container">
//               <p className="cart-card-category">
//                 {item.category_id}
//               </p>
//               {formattedDateTime ? (
//                 <div className="cart-card-date">
//                   <span>{cartDate}</span>
//                   <span>{cartTime}</span>
//                 </div>
//               ) : null}
//             </div>
//           </div>
//           <div
//             className="card-back"
//             style={{
//               display: isFlipped ? "flex" : "none",
//             }}
//           >
//             <div className="cart-card-details">
//               <p className="cart-card-details-title">Additional Details</p>
//               <ul>
//                 <li>
//                   <span>Name</span>
//                   <b>{item.customer_name || "N/A"}</b>
//                 </li>
//                 <li>
//                   <span>Phone</span>
//                   <b>{item.mobile || "N/A"}</b>
//                 </li>
//                 <li>
//                   <span>Staff</span>
//                   <b>{item.staff_id || "N/A"}</b>
//                 </li>
//                 <li>
//                   <span>Interest</span>
//                   <b>{item.interest || "N/A"}</b>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

function ProductCard({ item, index }) {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const imageSrc =
    item?.isImageUrl == 1 || item?.image_path?.startsWith("http")
      ? item?.image_path
      : (item?.url_image || "") + (item?.image_path || "");

  const formattedDateTime =
    item.datetime != "" && item.datetime != null
      ? moment(item.datetime.replace(" ", "T")).format("DD/MM/yyyy HH:mm")
      : null;

  const [cartDate, cartTime] = formattedDateTime
    ? formattedDateTime.split(" ")
    : ["", ""];

  const hasRemark =
    item?.remarks != null && String(item.remarks).trim() !== "";

  const hasAmount =
    item?.amount != null && String(item.amount).trim() !== "";

  return (
    <div className="col-sm-3" key={index}>
      <div
        className={`product-card ${isFlipped ? "flipped" : ""}`}
        onClick={handleFlip}
      >
        <div className="card-inner">
          <div className="card-front">
            <div className="image-container">
              <img
                src={imageSrc}
                alt={index}
                onError={(e) => {
                  e.target.src = "/no-image.png";
                }}
              />
            </div>

            <div className="text-container">
              <p className="cart-card-category">
                {item.category_id}
              </p>

              {formattedDateTime ? (
                <div className="cart-card-date">
                  <span>{cartDate}</span>
                  <span>{cartTime}</span>
                </div>
              ) : null}

              {/* Remark */}
              {hasRemark && (
                <div className="cart-card-remark">
                  {item.remarks}
                </div>
              )}

              {/* Amount */}
              {hasAmount && (
                <div className="cart-card-amount">
                  ₹ {item.amount}
                </div>
              )}
            </div>
          </div>

          <div
            className="card-back"
            style={{
              display: isFlipped ? "flex" : "none",
            }}
          >
            <div className="cart-card-details">
              <p className="cart-card-details-title">
                Additional Details
              </p>

              <ul>
                <li>
                  <span>Name</span>
                  <b>{item.customer_name || "N/A"}</b>
                </li>

                <li>
                  <span>Phone</span>
                  <b>{item.mobile || "N/A"}</b>
                </li>

                <li>
                  <span>Staff</span>
                  <b>{item.staff_id || "N/A"}</b>
                </li>

                <li>
                  <span>Interest</span>
                  <b>{item.interest || "N/A"}</b>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const downloadPdfDocument = (rootElementId, name) => {
  const input = document.getElementById(rootElementId);
  html2canvas(input).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    pdf.addImage(imgData, "JPEG", 0, 0);
    pdf.save(name);
  });
};

export default function BranchDashboard(props) {
  document.body.classList.add("custom_dashboard");
  const classes = useStyles();
  const [load, setLoad] = React.useState(false);
  const [branchEncryptID, setBranchEncryptID] = React.useState(
    localStorage.getItem("jwl_branchEncrypt_id")
  );
  const [copiedIndex, setCopiedIndex] = useState(null);

  const links = [
    {
      label: "Exhibition Link",
      path: "e",
      icon: "fa-globe",
      tone: "blue",
      description: "Share your exhibition catalog with customers",
    },
    {
      label: "Trial Link",
      path: "t",
      icon: "fa-flask",
      tone: "purple",
      description: "Allow customers to try your products",
    },
    {
      label: "General Link",
      path: "g",
      icon: "fa-link",
      tone: "green",
      description: "General product information link",
    },
    {
      label: "Upload Design",
      path: "d",
      icon: "fa-cloud-upload",
      tone: "orange",
      description: "Upload new product designs and files",
    },
    {
      label: "Update Your Details",
      path: "u",
      icon: "fa-edit",
      tone: "cyan",
      description: "Update business and contact information",
    },
    {
      label: "Video Call Request",
      path: "v",
      icon: "fa-video-camera",
      tone: "pink",
      description: "Request a video call with our team",
    },
  ];
  const handleDownloadPDF = (id, name) => {
    const contentToConvert = document.getElementById(id);

    if (contentToConvert) {
      html2pdf()
        .from(contentToConvert)
        .toImg()
        .set({
          margin: 10,
          filename: name,
          html2canvas: { scale: 1 },
          // image: { type: 'jpeg', quality: 0.98 },
          jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "landscape",
          },
          image: { type: "jpeg", quality: 0.98 },
        })
        .outputPdf()
        .save();
    } else {
      alert("Content not found!");
    }
  };

  const [smsDetails, setSmsDetails] = React.useState({
    today_sms_count: "",
    total_sms_count: "",
  });
  const [figures, setFigures] = React.useState({
    available: "",
    check_in: "",
    e_store: "",
    exhibition: "",
    new_customers: "",
    new_check_in: "",
    new_e_store: "",
    new_exhibition: "",
    redeem: "",
    t_exhibition: "",
    total_cart: "",
    total_customers: "",
    total_visits: "",
    total_vist_customer_count: "",
    total_not_visit_customers: "",
    total_voucher: "",
    today_sms_count: "",
    total_sms_count: "",
    upload: "",
    wishlist: "",
    VideoCall: "",
    feedbacks: "",
    stock: "",
    stock_t: "",
    stock_a: "",
  });
  const { buttonLabel, className } = props;
  const [recentActivitys, setRecentActivitys] = React.useState([]);
  const [customerCart, setCustomerCart] = React.useState([]);
  const [vCalls, setVCalls] = React.useState([]);
  const [dobANDdoa, setDobANDdoa] = React.useState([]);
  const [occasionCount, setOccasionCount] = React.useState(0);
  const [vcallRemarks, setVcallRemarks] = React.useState([]);
  const [missCallRemarks, setMissCallRemarks] = React.useState([]);
  const [modalTotalCustomer, setModalTotalCustomer] = useState(false);
  const toggleTotalCustomer = () => setModalTotalCustomer(!modalTotalCustomer);
  const [modalTotalCustomerNew, setModalTotalCustomerNew] = useState(false);
  const toggleTotalCustomerNew = () =>
    setModalTotalCustomerNew(!modalTotalCustomerNew);

  const [modalCartDetails, setModalCartDetails] = useState(false);
  const [modalSaleDetails, setModalSaleDetails] = useState(false);
  const [WhatsAppMessage, setWhatsAppMessage] = useState("");
  const [WhatsAppMessageValidation, setWhatsAppMessageValidation] =
    useState(false);
  const toggleCartDetails = () => setModalCartDetails(!modalCartDetails);
  const toggleSaleDetails = () => setModalSaleDetails(!modalSaleDetails);

  const [modalCartDetailsNew, setModalCartDetailsNew] = useState(false);
  const toggleCartDetailsNew = () =>
    setModalCartDetailsNew(!modalCartDetailsNew);
  const [modalVoucherDetails, setModalVoucherDetails] = useState(false);
  const toggleModalVoucherDetails = () =>
    setModalVoucherDetails(!modalVoucherDetails);
  const [modalNotVisitingCustomer, setModalNotVisitingCustomer] =
    useState(false);
  const toggleNotVisitingCustomer = () =>
    setModalNotVisitingCustomer(!modalNotVisitingCustomer);
  const [
    modalNotVisitingCustomerDataRange,
    setModalNotVisitingCustomerDataRange,
  ] = useState(false);
  const toggleNotVisitingCustomerDataRange = () =>
    setModalNotVisitingCustomerDataRange(!modalNotVisitingCustomerDataRange);
  const [modalVideoCallRequest, setModalVideoCallRequest] = useState(false);
  const toggleVideoCallRequest = () =>
    setModalVideoCallRequest(!modalVideoCallRequest);
  const [modalVideoCallRequestDetails, setModalVideoCallRequestDetails] =
    useState(false);
  const toggleVideoCallRequestDetails = () =>
    setModalVideoCallRequestDetails(!modalVideoCallRequestDetails);
  const [modalMissCallRequest, setModalMissCallRequest] = useState(false);
  const toggleMissCallRequest = () =>
    setModalMissCallRequest(!modalMissCallRequest);
  const [modalMissCallRequestDetails, setModalMissCallRequestDetails] =
    useState(false);
  const toggleMissCallRequestDetails = () =>
    setModalMissCallRequestDetails(!modalMissCallRequestDetails);
  const [modalStock, setModalStock] = useState(false);
  const toggleStock = () => setModalStock(!modalStock);

  const [modalFeedback, setModalFeedback] = useState(false);
  const toggleFeedback = () => setModalFeedback(!modalFeedback);
  const [appointmentDate, appointmenthandleDateChange] = useState(
    moment(new Date())
  );

  const [missedDate, setMissedDate] = useState(moment(new Date()));
  const [remarksLoader, setRemarksLoader] = useState(false);
  const [remarksMissLoader, setRemarksMissLoader] = useState(false);
  const [productcountList, setProductcountList] = React.useState([]);
  const [productHistory, setProductHistory] = React.useState([]);
  const [openCategory, setOpenCategory] = useState(null);
  const [divBirthdayAndAnniversary, setDivBirthdayAndAnniversary] =
    useState(false);
  const toggleDivBirthdayAndAnniversary = () =>
    setDivBirthdayAndAnniversary(!divBirthdayAndAnniversary);

  const [modalDashboardDataRange, setModalDashboardDataRange] = useState(false);
  const [modelWhatsapp, setModelWhatsapp] = useState(false);
  const toggleDashboardDataRange = () =>
    setModalDashboardDataRange(!modalDashboardDataRange);

  const StockDivRef = useRef(null);
  const ImageBoxContainer = useRef();

  const imageRef = useRef(null);
  const executeScroll = () =>
    StockDivRef.current?.scrollIntoView({ behavior: "smooth" });
  //Table Objects
  const [totalCustomers, setTotalCustomers] = React.useState([]);
  const [filter_type, setFiltertype] = React.useState("");
  const [newCustomers, setNewCustomers] = React.useState([]);
  const [filter_type_new, setFilterTypeNew] = React.useState("");
  const [notVisitingCustomers, setNotVisitingCustomers] = React.useState([]);
  const [customerNoSaleList, setCustomerNoSaleList] = useState([]);
  const [customerNoSaleCount, setCustomerNoSaleCount] = useState(0);
  const [notVisitingActiveTab, setNotVisitingActiveTab] = useState("not_visiting");
  const [filter_type_no_visit, setFilterTypeNotVisit] = React.useState("");
  const [videoCallRequest, setVideoCallRequest] = React.useState([]);
  const [filter_type_vcall, setFilterTypeVCall] = React.useState("");
  const [missCallRequest, setMissCallRequest] = React.useState([]);
  const [filter_type_miss, setFilterTypeMiss] = React.useState("");
  const [productsInCart, setProductsInCart] = React.useState([]);
  const [activeVouchers, setActiveVouchers] = React.useState([]);
  const [filter_type_voucher, setFilterTypeVoucher] = React.useState("");
  const [browseStock, setBrowseStock] = React.useState([]);
  const [CustomerGraph, setCustomerGraph] = React.useState([]);
  const [SubCategoryList, setSubCategoryList] = React.useState({});

  const [DownloadReady, setDownloadReady] = React.useState(false);
  const [DownloadLink, setDownloadLink] = React.useState("");
  const [salesPdfDownloading, setSalesPdfDownloading] = React.useState(false);
  const [FilteredCartId, setFilteredCartId] = React.useState(0);
  const [FilteredCartInterest, setFilteredCartInterest] = React.useState(`all`);
  const [FilteredCartUpdatedInterest, setFilteredCartUpdatedInterest] =
    React.useState(`all`);
  const [loaderState, setLoaderState] = React.useState(false);
  const [SendList, setSendList] = React.useState([]);
  const [count_ap, setCount_ap] = React.useState(0);
  const [countPro_sale, setCountPro_sale] = React.useState(0);
  const [totalSpCount, setTotalSpCount] = React.useState(0);
  const [uniqueInvoiceCount, setUniqueInvoiceCount] = React.useState(0);
  const [totalSalesQuantity, setTotalSalesQuantity] = React.useState(0);
  const [totalSalesAmount, setTotalSalesAmount] = React.useState(0);
  const [showAllTiles, setShowAllTiles] = React.useState(false);
  const [customerPoint, setCustomerPoint] = React.useState([]);
  const [countPoint, setCountPoint] = React.useState(0);
  const [whtAppCredit, setWhtAppCredit] = React.useState(0);

  // setSubCategoryList
  //Date Range
  const [state, setState] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [showDate, setshowDate] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [dashboardShowDate, setDashboardShowDate] = useState(() => ({
    startDate: addDays(new Date(), -7),
    endDate: new Date(),
    key: "selection",
  }));

  // Update Video call Remarks

  const [remarksValidation, setRemarksValidation] = React.useState(false);
  const [updateVcall, setUpdateVcall] = React.useState({
    tran_id: "",
    status: "",
    accept_date: "",
    accept_time: "",
    remarks: "",
  });

  // Update Miss Call Remarks
  const [remarksMissValidation, setRemarksMissValidation] =
    React.useState(false);
  const [updateMiss, setUpdateMiss] = React.useState({
    tran_id: "",
    status: "",
    accept_date: "",
    accept_time: "",
    remarks: "",
  });

  // Update Cart Remarks
  const [remarksCartLoader, setRemarksCartLoader] = useState(false);
  const [modalCartRequestDetails, setModalCartRequestDetails] = useState(false);
  const toggleCartRequestDetails = () =>
    setModalCartRequestDetails(!modalCartRequestDetails);
  const [cartRemarks, setCartRemarks] = React.useState([]);
  const [remarksCartValidation, setRemarksCartValidation] =
    React.useState(false);

  const [updateCart, setUpdateCart] = React.useState({
    tran_id: "",
    from: "",
    status: "",
    appointment_date: "",
    accept_date: "",
    accept_time: "",
    remarks: "",
    updated_interest: "",
  });

  const [staffList, setStaffList] = useState([]);
  const [uploadedFile, setUploadedFile] = useState({});

  const getStaffList = () => {
    postMethod("api/customervisit/StaffList").then((res) => {
      // console.log(res.data);
      let all_data_staff = {};
      res.data.map((item, index) => {
        all_data_staff[item.staff_id] = item.name;
      });
      setStaffList(all_data_staff);
    });
  };

  //   useEffect(() => {
  //     const startDateVar = addDays(new Date(), -7);
  //     const endDateVar = new Date();

  //     setDashboardShowDate([
  //       {
  //         startDate: startDateVar,
  //         endDate: endDateVar,
  //         key: "selection",
  //       },
  //     ]);

  //     setshowDate({
  //       startDate: startDateVar.toLocaleDateString("en-US"),
  //       endDate: endDateVar.toLocaleDateString("en-US"),
  //     });

  //     getStaffList();

  //     setLoad(true);
  //     getFigureDetials();
  //     smsBalance();
  //     dashboard_figures();
  //     getData();
  //     setLoad(false);
  //     dashboard_cartFun();

  // }, []);

  // Get Table data
  const getData = (queryString = "") => {
    let url = "api/masters/product/subcategory/web-browse/?" + queryString;
    postMethod(url, {}).then((res) => {
      let dataCat = {};
      // alert(JSON.stringify(res.Data));
      res.Data.map((item) => {
        dataCat[item.category_id] = item.category_name;
      });
      setSubCategoryList(dataCat);
    });
  };

  const getFigureDetials = () => {
    dashboard_figures();
    birthdayANDanniversary();
    browse_ProductCategoryCountList();
    browse_customers_chart();
    browse_ProductHistory();
    recentActivityFun();
  };

  const get_appointment_notification = () => {
    postMethod("api/customervisit/check_today_notificaton")
      .then((data) => {
        setCount_ap(data.data[0]["check_appointment"]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    get_appointment_notification();
    getFigureDetials();
    serviceCountData();
    serviceDueNotification();
  }, [dashboardShowDate]);

  const dashboard_figures = () => {
    postMethod("api/masters/dashboard/figures", {
      from_date: moment(dashboardShowDate.startDate).format("yyyy-MM-DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy-MM-DD"),
    }).then((dataD) => {
      var data = dataD.data[0];
      // alert(JSON.stringify(dataD.data[0]))
      setFigures({
        ...figures,
        new_customers: data.new_customers,
        total_visits: data.total_customer_visits,
        total_vist_customer_count: data.total_vist_customer_count,
        total_cart: data.total_cart,
        total_customers: data.total_customers,
        total_not_visit_customers: data.total_notVisitCustomer,
        total_voucher: data.total_voucher,
        VideoCall: data.vCall,
        missedCall: data.missedCall,
        stock: data.stock,
        stock_t: data.stock_transfer,
        stock_a: data.stock_accept,
        feedbacks: data.total_customer_reviews,
      });
    });

    postMethod("api/masters/dashboard/retailer/customer_no_sale_report", {
      from_date: moment(dashboardShowDate.startDate).format("YYYY/MM/DD"),
      to_date: moment(dashboardShowDate.endDate).format("YYYY/MM/DD"),
    })
      .then((res) => {
        if (res?.data && Array.isArray(res.data)) {
          setCustomerNoSaleCount(res.data.length);
        }
      })
      .catch(() => { });

    postMethod("api/masters/dashboard/retailer/sales_cart", {
      from_date: moment(dashboardShowDate.startDate).format("yyyy-MM-DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy-MM-DD"),
    })
      .then((data) => {
        if (data?.data && Array.isArray(data.data)) {
          setCountPro_sale(data.data?.[0]?.today_sales_count ?? 0);
          setTotalSpCount(data.data.length);
          const seenInvoices = new Set();
          let totalAmt = 0;
          let totalQty = 0;
          data.data.forEach((item, index) => {
            const invoiceKey =
              item.entry_no ||
              item.invoice_no ||
              item.invoice_id ||
              `row_${index}`;

            if (!seenInvoices.has(invoiceKey)) {
              seenInvoices.add(invoiceKey);
              totalAmt += parseFloat(item.final_amount) || 0;
            }

            const q = parseFloat(item.quantity ?? item.qty);
            totalQty += !isNaN(q) ? q : 1;
          });
          setUniqueInvoiceCount(seenInvoices.size);
          setTotalSalesQuantity(totalQty);
          setTotalSalesAmount(totalAmt);
          setGrid(data.data);
        }
      })
      .catch(() => { });
  };

  const recentActivityFun = () => {
    postMethod("api/masters/dashboard/recentActivity", {
      from_date: moment().subtract(1, "days").format("YYYY/MM/DD"),
      to_date: moment().format("YYYY/MM/DD"),
    }).then((data) => {
      setRecentActivitys(data.data);
    });
  };

  const smsBalance = () => {
    postMethod("api/masters/dashboard/BalanceSMS", {}).then((data) => {
      setSmsDetails({
        ...smsDetails,
        total_sms_count: data.data.totalSMS,
        today_sms_count: data.data.TodaySent,
      });
    });
  };

  const dashboard_cartFun = () => {
    postMethod("api/masters/dashboard/browse_cart", {
      from_date: moment(dashboardShowDate.startDate).format("YYYY/MM/DD"), // Corrected the date format
      to_date: moment(dashboardShowDate.endDate).format("YYYY/MM/DD"), // Corrected the date format
    }).then((data) => {
      var cate_counts = {};
      for (let item of data.data) {
        const categoryKey = item.category_id || "Unknown";
        const categoryLabel =
          SubCategoryList[categoryKey] ||
          item.category_name ||
          item.subcategory_name ||
          item.sub_category_name ||
          (categoryKey === "null" ? "Unknown" : categoryKey);

        cate_counts[categoryKey] = cate_counts[categoryKey] || {
          label: categoryLabel,
          count: 0,
        };
        cate_counts[categoryKey].count = cate_counts[categoryKey].count + 1;
      }

      let x_axis = [];
      let y_axis = [];
      for (const value of Object.values(cate_counts)) {
        x_axis.push(value.label);
        y_axis.push(value.count);
      }
      setCustomerGraph({ x_axis: x_axis, y_axis: y_axis });

      let filtered_cart_data = data.data.map((item, index) => {
        item.appointment =
          item.accept_date && item.accept_time
            ? moment(item.accept_date + "T" + item.accept_time).format(
              "DD/MM/yyyy HH:mm"
            )
            : "";

        if (FilteredCartId > 0 && item.category_id == FilteredCartId) {
          item.category_id = SubCategoryList[item.category_id] || "";
          item.staff_id = staffList[item.staff_id] || "";
          return item;
        } else if (FilteredCartId <= 0) {
          item.category_id = SubCategoryList[item.category_id] || "";
          item.staff_id = staffList[item.staff_id] || "";
          return item;
        }
      });

      let filteredArray = filtered_cart_data.filter(
        (element) => element !== undefined
      );

      let filtered_cart_data_2 = filteredArray.filter((item, index) => {
        if (
          FilteredCartInterest !== "all" &&
          item.interest === FilteredCartInterest
        ) {
          return item;
        } else if (FilteredCartInterest === "all") {
          return item;
        }
      });

      const filteredArray_new = filtered_cart_data_2.filter(
        (element) => element !== undefined
      );

      let filtered_cart_data_3 = filteredArray_new.filter((item, index) => {
        if (
          FilteredCartUpdatedInterest !== "all" &&
          item.updated_interest === FilteredCartUpdatedInterest
        ) {
          return item;
        } else if (FilteredCartUpdatedInterest === "all") {
          return item;
        }
      });

      const filteredArray_new1 = filtered_cart_data_3.filter(
        (element) => element !== undefined
      );

      setProductsInCart(filteredArray_new1);
    });
  };

  useEffect(() => {
    const startDateVar = addDays(new Date(), -7);
    const endDateVar = new Date();

    setDashboardShowDate((prev) => ({
      ...prev,
      startDate: startDateVar,
      endDate: endDateVar,
    }));

    setshowDate({
      startDate: startDateVar.toLocaleDateString("en-US"),
      endDate: endDateVar.toLocaleDateString("en-US"),
    });
    // Other function calls
    getData();
    getStaffList();
    setLoad(true);
    getFigureDetials();
    smsBalance();
    dashboard_figures();
    setLoad(false);
    dashboard_cartFun();
  }, []);

  useEffect(() => {
    browse_customers();
  }, [filter_type]);
  useEffect(() => {
    browse_customers_new();
  }, [filter_type_new]);
  useEffect(() => {
    browse_customers_not_visit();
  }, [filter_type_no_visit]);
  useEffect(() => {
    browse_vouchers();
  }, [filter_type_voucher]);

  useEffect(() => {
    if (Object.keys(SubCategoryList).length > 0) {
      dashboard_cartFun();
    }
  }, [SubCategoryList]);

  useEffect(() => {
    browse_vCall();
  }, [filter_type_vcall]);

  useEffect(() => {
    browse_missCall();
  }, [filter_type_miss]);

  const browse_customers = async () => {
    postMethod("api/masters/dashboard/browse_customer_visits", {
      type: filter_type,
      from_date: moment(dashboardShowDate.startDate).format("yyyy/MM/DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy/MM/DD"),
    }).then((data) => {
      setTotalCustomers(data.data);
    });
  };

  const browse_ProductCategoryCountList = () => {
    postMethod("api/masters/dashboard/productCategorysCountList", {}).then(
      (data) => {
        setProductcountList(data.data);
      }
    );
  };

  const browse_ProductHistory = () => {
    postMethod("api/masters/dashboard/productHistory", {}).then((data) => {
      if (data.data) setProductHistory(data.data);
    });
  };

  const browse_customers_new = () => {
    postMethod("api/masters/dashboard/newCutomers", {
      type: filter_type_new,
      from_date: moment(dashboardShowDate.startDate).format("yyyy/MM/DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy/MM/DD"),
    }).then((data) => {
      setNewCustomers(data.data);
    });
  };


  const browse_customers_not_visit = () => {
    const fromFormatted = moment(showDate.startDate).isValid()
      ? moment(showDate.startDate).format("YYYY/MM/DD")
      : showDate.startDate;
    const toFormatted = moment(showDate.endDate).isValid()
      ? moment(showDate.endDate).format("YYYY/MM/DD")
      : showDate.endDate;

    Promise.allSettled([
      postMethod("api/masters/dashboard/notVisitingCustomers", {
        from_date: showDate.startDate,
        to_date: showDate.endDate,
        type: filter_type_no_visit,
      }),
      postMethod("api/masters/dashboard/retailer/customer_no_sale_report", {
        from_date: fromFormatted,
        to_date: toFormatted,
      }),
    ]).then(([res1, res2]) => {
      const data1 =
        res1.status === "fulfilled" && res1.value?.data
          ? res1.value.data
          : [];
      const data2 =
        res2.status === "fulfilled" && res2.value?.data
          ? res2.value.data
          : [];

      setNotVisitingCustomers(Array.isArray(data1) ? data1 : []);
      setCustomerNoSaleList(Array.isArray(data2) ? data2 : []);
      if (res2.status === "fulfilled" && Array.isArray(data2)) {
        setCustomerNoSaleCount(data2.length);
      }
    });
  };

  const notVisitngCustomerDateChange = (startDate, endDate) => {
    const fromFormatted = moment(startDate).isValid()
      ? moment(startDate).format("YYYY/MM/DD")
      : startDate;
    const toFormatted = moment(endDate).isValid()
      ? moment(endDate).format("YYYY/MM/DD")
      : endDate;

    Promise.allSettled([
      postMethod("api/masters/dashboard/notVisitingCustomers", {
        from_date: startDate,
        to_date: endDate,
      }),
      postMethod("api/masters/dashboard/retailer/customer_no_sale_report", {
        from_date: fromFormatted,
        to_date: toFormatted,
      }),
    ]).then(([res1, res2]) => {
      const data1 =
        res1.status === "fulfilled" && res1.value?.data
          ? res1.value.data
          : [];
      const data2 =
        res2.status === "fulfilled" && res2.value?.data
          ? res2.value.data
          : [];

      setNotVisitingCustomers(Array.isArray(data1) ? data1 : []);
      setCustomerNoSaleList(Array.isArray(data2) ? data2 : []);
      if (res2.status === "fulfilled" && Array.isArray(data2)) {
        setCustomerNoSaleCount(data2.length);
      }
    });
  };

  const browse_vouchers = () => {
    postMethod("api/masters/dashboard/activeVouchers", {
      type: filter_type_voucher,
      from_date: moment(dashboardShowDate.startDate).format("yyyy/MM/DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy/MM/DD"),
    }).then((data) => {
      setActiveVouchers(data.data);
    });
  };

  const browse_vCall = () => {
    postMethod("api/masters/dashboard/videoCallRequest", {
      status: filter_type_vcall,
      from_date: moment(dashboardShowDate.startDate).format("yyyy/MM/DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy/MM/DD"),
    }).then((data) => {
      setVideoCallRequest(data.data);
    });
  };

  const browse_missCall = () => {
    postMethod("api/masters/dashboard/missCallRequest", {
      status: filter_type_miss,
      from_date: moment(dashboardShowDate.startDate).format("yyyy/MM/DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy/MM/DD"),
    }).then((data) => {
      setMissCallRequest(data.data);
    });
  };

  const birthdayANDanniversary = () => {
    postMethod("api/masters/dashboard/dobAndDoa", {}).then((data) => {
      // setOccasionCount(data.data[0].occasion_count);
      setOccasionCount(data.data?.[0]?.occasion_count ?? 0);
      setDobANDdoa(data.data);
    });
  };

  const browse_stocks = () => {
    postMethod("api/masters/dashboard/stock", {}).then((data) => {
      setBrowseStock(data.data);
    });
  };
  const browse_feedbacks = () => {
    postMethod("api/masters/dashboard/feedback", {
      from_date: moment(dashboardShowDate.startDate).format("yyyy/MM/DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy/MM/DD"),
    }).then((data) => {
      setBrowseStock(data.data);
    });
  };

  const browse_customers_chart = () => {
    var param = {
      from_date: moment(dashboardShowDate.startDate).format("yyyy/MM/DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy/MM/DD"),
    };
    postMethod("api/masters/dashboard/customer_graph_new", param).then(
      (data) => {
        var dataD = data.data;

        // console.log(dataD);
        setCustomerCart(dataD);
      }
    );
  };

  // const checkActivityDate = (date) => {
  //   var today = new Date().setHours(0, 0, 0, 0);
  //   var _date = date.replace("/T|Z/g", "");
  //   _date = new Date(_date).setHours(0, 0, 0, 0);
  //   if (today === _date) {
  //     return moment(_date).format("hh:mm");
  //   } else {
  //     return moment(_date).format("DD/MM/YYYY hh:MM");
  //   }
  // };
  // -------------------------------Total Visit start----------------------------

  const getTargettotalElement = () =>
    document.getElementById("data_list_visit_table");

  const export_array_visit = () => {
    let arr =
      "Name,Mobile,Type,Gender,D.O.B,D.O.A,Category,Visit Count,Points,Date\r\n";
    let csvContent = "data:text/csv;charset=utf-8," + arr;

    totalCustomers.forEach(function (rowArray) {
      var row = `${rowArray.full_name},${rowArray.mobile},${rowArray.type},${rowArray.gender},${rowArray.dob},${rowArray.doa},${rowArray.category},${rowArray.visit_count}, ${rowArray.total_points}, ${rowArray.date}`;
      csvContent += row + "\r\n";
    });

    var encodedUri = encodeURI(csvContent);
    setDownloadLink(encodedUri);
    setDownloadReady(true);
  };

  // -------------------------------Total Visit end------------------------

  // ---------------Total newCustomer------------------------
  const getTargettotalElement1 = () =>
    document.getElementById("data_list_visit_table1");

  const export_array_visit1 = () => {
    let arr =
      "Name,Mobile,Type,Gender,D.O.B,D.O.A,Category,Visit Count,Points,Date\r\n";
    let csvContent = "data:text/csv;charset=utf-8," + arr;

    newCustomers.forEach(function (rowArray) {
      var row = `${rowArray.full_name},${rowArray.mobile},${rowArray.type},${rowArray.gender},${rowArray.dob},${rowArray.doa},${rowArray.category},${rowArray.visit_count},${rowArray.total_points},${rowArray.date}`;
      csvContent += row + "\r\n";
    });

    var encodedUri = encodeURI(csvContent);
    setDownloadLink(encodedUri);
    setDownloadReady(true);
  };

  // ---------------Toatal newCustomer-----------------------

  // ---------------non Visiting Customer---------------------
  const getTargettotalElement2 = () =>
    document.getElementById("data_list_visit_table2");

  const export_array_visit2 = () => {
    if (notVisitingActiveTab === "no_sale") {
      let arr =
        "Name,Mobile,Type,Gender,Category,D.O.B,D.O.A,Visits,Last Visit,Last Sale,Sales Bills,Total Sale Amt,Last Bill Amt,Last Invoice,Points\r\n";
      let csvContent = "data:text/csv;charset=utf-8," + arr;

      customerNoSaleList.forEach(function (r) {
        const name = r["NAME"] || "";
        const mob = r["MOBILE"] || "";
        const type = r["TYPE"] || "";
        const gender = r["GENDER"] || "";
        const cat = r["CUSTOMER CATEGORY"] || "";
        const dob = r["DOB"] ? moment(r["DOB"]).format("YYYY-MM-DD") : "";
        const doa = r["DOA"] ? moment(r["DOA"]).format("YYYY-MM-DD") : "";
        const visits = r["TOTAL VISIT"] ?? r["VISITS"] ?? 0;
        const lastVisit = r["LAST VISIT"]
          ? moment(r["LAST VISIT"]).format("YYYY-MM-DD HH:mm")
          : "";
        const lastSale = r["LAST SALE"]
          ? moment(r["LAST SALE"]).format("YYYY-MM-DD HH:mm")
          : "";
        const salesBills = r["TOTAL SALES BILLS"] ?? 0;
        const totalSaleAmt =
          r["TOTAL SALE AMONT"] ?? r["TOTAL SALE AMOUNT"] ?? 0;
        const lastBillAmt = r["LAST BILL AMOUNT"] ?? 0;
        const lastEntryNo = r["LAST ENTRY NO"] || "";
        const points = r["TOTAL POINTS"] ?? 0;

        const row = `"${name}","${mob}","${type}","${gender}","${cat}","${dob}","${doa}",${visits},"${lastVisit}","${lastSale}",${salesBills},${totalSaleAmt},${lastBillAmt},"${lastEntryNo}",${points}`;
        csvContent += row + "\r\n";
      });

      var encodedUri = encodeURI(csvContent);
      setDownloadLink(encodedUri);
      setDownloadReady(true);
      return;
    }

    let arr =
      "Name,Mobile,Type,Gender,D.O.B,D.O.A,Category,Visit Count,Points,Date\r\n";
    let csvContent = "data:text/csv;charset=utf-8," + arr;

    const dataToExport = notVisitingCustomers;

    dataToExport.forEach(function (rowArray) {
      const name = rowArray.full_name || rowArray.customer_name || rowArray.name || "";
      const mob = rowArray.mobile || rowArray.customer_mobile || "";
      const type = rowArray.type || rowArray.sales_type || rowArray.customer_type || "";
      const gender = rowArray.gender || "";
      const dob = rowArray.dob || "";
      const doa = rowArray.doa || "";
      const category = rowArray.category_name || rowArray.category || "";
      const visitCount = rowArray.visit_count ?? rowArray.total_visits ?? 0;
      const totalPoints = rowArray.total_points ?? rowArray.points ?? 0;
      const lastVisit = rowArray.last_visit_date || rowArray.date || rowArray.datetime || "";
      const row = `${name},${mob},${type},${gender},${dob},${doa},${category},${visitCount},${totalPoints},${lastVisit}`;
      csvContent += row + "\r\n";
    });

    var encodedUri = encodeURI(csvContent);
    setDownloadLink(encodedUri);
    setDownloadReady(true);
  };

  // -----------------COUNT WHATSAPPMESSAGE---------
  const [countWht, setCountWht] = useState(0);
  const [branch_type, setBranch_type] = React.useState(
    localStorage.getItem("branch_type")
  );
  useEffect(() => {
    postMethod("api/customervisit/get_whtsapp_credit_count", {}).then(
      (data) => {
        setCountWht(data.data[0]["countWht"]);
        setWhtAppCredit(data.data[0]["whatsapp_credit"]);
      }
    );
  }, []);
  // -----------------------------------------------


  // ---------------non visiting Customer---------------------

  //Table Config
  const config = {
    page_size: 10,
    length_menu: [10, 5, 20, 50],
  };

  //Table Columns
  const columns_TotalCustomer = [
    {
      key: "full_name",
      text: "Name",
      align: "left",
      sortable: true,
      width: "300px",
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },
    {
      key: "type",
      text: "Type",
      sortable: true,
      align: "left",
      cell: (record) => {
        return <Fragment>{record.type.toLowerCase()}</Fragment>;
      },
    },
    {
      key: "gender",
      text: "Gender",
      sortable: true,
      align: "left",
    },
    {
      key: "dob",
      text: "D.O.B",
      sortable: true,
      align: "left",
      width: "100px",
    },
    {
      key: "doa",
      text: "D.O.A",
      sortable: true,
      align: "left",
      width: "100px",
    },
    {
      key: "category_name",
      text: "Category",
      sortable: true,
      align: "left",
    },
    {
      key: "visit_count",
      text: "Visit Count",
      sortable: true,
      align: "left",
      cell: (record) => {
        return <Fragment>{"" + record.visit_count}</Fragment>;
      },
    },
    {
      key: "total_points",
      text: "Points",
      sortable: true,
      align: "left",
      cell: (record) => {
        return <Fragment>{"" + record.total_points}</Fragment>;
      },
    },
    {
      key: "date",
      text: "Date",
      sortable: true,
      align: "left",
      cell: (record) => {
        return (
          <Fragment>
            {moment(record.customer_check_out).format("DD/MM/YYYY HH:mm")}
          </Fragment>
        );
      },
    },
  ];

  //Table Columns Non visit
  const columns_NonVistiTotalCustomer = [
    {
      key: "full_name",
      text: "Name",
      align: "left",
      sortable: true,
      cell: (record) => {
        const name = record.full_name || record.customer_name || record.name || "-";
        const mob = record.mobile || record.customer_mobile;
        return (
          <Fragment>
            <a href="#" onClick={() => mob && getCustomerDetails(mob)}>
              {name}
            </a>
          </Fragment>
        );
      },
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
      cell: (record) => record.mobile || record.customer_mobile || "-",
    },
    {
      key: "type",
      text: "Type",
      sortable: true,
      align: "left",
      cell: (record) => record.type || record.sales_type || record.customer_type || "-",
    },
    {
      key: "gender",
      text: "Gender",
      sortable: true,
      align: "left",
      cell: (record) => record.gender || "-",
    },
    {
      key: "dob",
      text: "D.O.B",
      sortable: true,
      align: "left",
      width: "100px",
    },
    {
      key: "doa",
      text: "D.O.A",
      sortable: true,
      align: "left",
      width: "100px",
    },
    {
      key: "category_name",
      text: "Category",
      sortable: true,
      align: "left",
      cell: (record) => record.category_name || "-",
    },
    {
      key: "visit_count",
      text: "visit count",
      sortable: true,
      align: "left",
      cell: (record) => {
        return <Fragment>{"" + (record.visit_count ?? record.total_visits ?? 0)}</Fragment>;
      },
    },

    {
      key: "total_points",
      text: "Points",
      sortable: true,
      align: "left",
      cell: (record) => {
        return <Fragment>{"" + (record.total_points ?? record.points ?? 0)}</Fragment>;
      },
    },

    {
      key: "date",
      text: "Last Visit",
      sortable: true,
      align: "left",
      cell: (record) => {
        const lastVisit = record.last_visit_date || record.date || record.datetime;
        return (
          <Fragment>
            {lastVisit == null
              ? "No visit"
              : moment(lastVisit).format("DD/MM/YYYY HH:mm")}
          </Fragment>
        );
      },
    },
  ];

  // Table Columns Customer No Sale Report (New API)
  const columns_CustomerNoSaleReport = [
    {
      key: "NAME",
      text: "Name",
      align: "left",
      sortable: true,
      cell: (record) => {
        const name = record["NAME"] || record["full_name"] || "-";
        const mob = record["MOBILE"] || record["mobile"];
        return (
          <Fragment>
            <a href="#" onClick={() => mob && getCustomerDetails(mob)}>
              {name}
            </a>
          </Fragment>
        );
      },
    },
    {
      key: "MOBILE",
      text: "Mobile",
      align: "left",
      sortable: true,
      cell: (record) => record["MOBILE"] || record["mobile"] || "-",
    },
    {
      key: "TYPE",
      text: "Type",
      sortable: true,
      align: "left",
      cell: (record) => record["TYPE"] || record["type"] || "-",
    },
    {
      key: "GENDER",
      text: "Gender",
      sortable: true,
      align: "left",
      cell: (record) => record["GENDER"] || record["gender"] || "-",
    },
    {
      key: "CUSTOMER CATEGORY",
      text: "Category",
      sortable: true,
      align: "left",
      cell: (record) =>
        record["CUSTOMER CATEGORY"] || record["category_name"] || "-",
    },
    {
      key: "DOB",
      text: "D.O.B",
      sortable: true,
      align: "left",
      cell: (record) => {
        const dob = record["DOB"] || record["dob"];
        return dob ? moment(dob).format("DD/MM/YYYY") : "-";
      },
    },
    {
      key: "DOA",
      text: "D.O.A",
      sortable: true,
      align: "left",
      cell: (record) => {
        const doa = record["DOA"] || record["doa"];
        return doa ? moment(doa).format("DD/MM/YYYY") : "-";
      },
    },
    {
      key: "TOTAL VISIT",
      text: "Total Visits",
      sortable: true,
      align: "center",
      cell: (record) => (
        <Fragment>
          {"" +
            (record["TOTAL VISIT"] ??
              record["VISITS"] ??
              record["visit_count"] ??
              0)}
        </Fragment>
      ),
    },
    {
      key: "LAST VISIT",
      text: "Last Visit",
      sortable: true,
      align: "left",
      cell: (record) => {
        const lastVisit = record["LAST VISIT"] || record["last_visit_date"];
        return (
          <Fragment>
            {lastVisit
              ? moment(lastVisit).format("DD/MM/YYYY HH:mm")
              : "-"}
          </Fragment>
        );
      },
    },
    {
      key: "LAST SALE",
      text: "Last Sale",
      sortable: true,
      align: "left",
      cell: (record) => {
        const lastSale = record["LAST SALE"];
        return (
          <Fragment>
            {lastSale
              ? moment(lastSale).format("DD/MM/YYYY HH:mm")
              : "-"}
          </Fragment>
        );
      },
    },
    {
      key: "TOTAL SALES BILLS",
      text: "Sales Bills",
      sortable: true,
      align: "center",
      cell: (record) => (
        <Fragment>{"" + (record["TOTAL SALES BILLS"] ?? 0)}</Fragment>
      ),
    },
    {
      key: "TOTAL SALE AMONT",
      text: "Total Sale Amt",
      sortable: true,
      align: "right",
      cell: (record) => {
        const amt =
          record["TOTAL SALE AMONT"] ?? record["TOTAL SALE AMOUNT"] ?? 0;
        return `₹${Number(amt).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
    },
    {
      key: "LAST BILL AMOUNT",
      text: "Last Bill Amt",
      sortable: true,
      align: "right",
      cell: (record) => {
        const amt = record["LAST BILL AMOUNT"] ?? 0;
        return `₹${Number(amt).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
    },
    {
      key: "LAST ENTRY NO",
      text: "Last Invoice",
      sortable: true,
      align: "left",
      cell: (record) => record["LAST ENTRY NO"] || "-",
    },
    {
      key: "BILL PREVIEW",
      text: "Bill View",
      align: "center",
      sortable: false,
      cell: (record) => {
        const billUrl =
          record["BILL PREVIEW"] ||
          record["bill_preview"] ||
          record["bill_pdf_url"];
        if (!billUrl) return "-";
        return (
          <button
            type="button"
            className="btn btn-sm btn-outline-theme p-1"
            onClick={() => window.open(billUrl, "_blank")}
            title="View Bill"
          >
            <i className="fa fa-eye"></i>
          </button>
        );
      },
    },
    {
      key: "TOTAL POINTS",
      text: "Points",
      sortable: true,
      align: "center",
      cell: (record) => (
        <Fragment>{"" + (record["TOTAL POINTS"] ?? 0)}</Fragment>
      ),
    },
  ];

  //Table Columns
  const columns_TotalCustomer_New = [
    {
      key: "full_name",
      text: "Name",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <a href="#" onClick={() => getCustomerDetails(record.mobile)}>
              {record.full_name}
            </a>
          </Fragment>
        );
      },
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },
    {
      key: "type",
      text: "Type",
      sortable: true,
      align: "left",
    },
    {
      key: "gender",
      text: "Gender",
      sortable: true,
      align: "left",
    },
    {
      key: "dob",
      text: "D.O.B",
      sortable: true,
      align: "left",
      width: "100px",
    },
    {
      key: "doa",
      text: "D.O.A",
      sortable: true,
      align: "left",
      width: "100px",
    },
    {
      key: "category_name",
      text: "Category",
      sortable: true,
      align: "left",
    },
    {
      key: "total_points",
      text: "Points",
      sortable: true,
      align: "left",
    },

    {
      key: "date",
      text: "Date",
      sortable: true,
      align: "left",
      cell: (record) => {
        return (
          <Fragment>
            {moment(record.datetime).format("DD/MM/YYYY HH:mm")}
          </Fragment>
        );
      },
    },
  ];

  //Table Cart
  const columns_Cart = [
    {
      key: "amount",
      text: "Name",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <a href="#" onClick={() => getCustomerDetails(record.mobile)}>
              {record.customer_name}
            </a>
          </Fragment>
        );
      },
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },

    {
      key: "type",
      text: "Type",
      align: "left",
      sortable: true,
      className: "text-nowrap",
      cell: (record) => {
        return (
          <Fragment>
            {record.type != "" && record.type != null
              ? record.added_from.toUpperCase()
              : null}
          </Fragment>
        );
      },
    },
    {
      key: "appointment_date",
      text: "Appoint Date",
      align: "left",
      sortable: true,
      className: "text-nowrap",
      cell: (record) => {
        return (
          <Fragment>
            {record.appointment_date ? (
              record.appointment_date.includes("1900") ? (
                ""
              ) : record.appointment_date ? (
                <>
                  <p style={{ padding: 0, margin: 0 }}>
                    {record.appointment_date.toString().split(" ")[0]}
                  </p>
                  <p style={{ padding: 0, margin: 0 }}>
                    {record.appointment_date.toString().split(" ")[1]}
                  </p>
                  {/* moment(record.appointment).format("DD/MM/yyyy HH:mm") */}
                </>
              ) : (
                " "
              )
            ) : (
              " "
            )}{" "}
          </Fragment>
        );
      },
    },

    {
      key: "remarks",
      text: "Remarks",
      sortable: true,
      align: "left",
      className: "text-wrap",
      cell: (record) => {
        return (
          <div
            style={{
              width: "200px",
              maxWidth: "200px",
              maxHeight: "80px",
              overflowY: "auto",
              overflowX: "hidden",
              whiteSpace: "normal",
              wordBreak: "break-word",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {record.remarks != "" && record.remarks != null
              ? record.remarks
              : null}
          </div>
        );
      },
    },
    {
      key: "amount",
      text: "Amount",
      sortable: true,
      align: "left",
    },
    {
      key: "staff_id",
      text: "Staff",
      sortable: true,
      align: "left",
    },

    // SubCategoryList
    {
      key: "category_id",
      text: "Category",
      sortable: true,
      align: "left",
      cell: (record) => {
        return <>{record.category_id || "N/A"}</>;
      },
    },

    {
      key: "customer_category",
      text: "Customer Category",
      sortable: true,
      align: "left",
      cell: (record) => {
        return <>{record.customer_category || "N/A"}</>;
      },
    },
    {
      key: "interest",
      text: "Interest",
      sortable: true,
      align: "left",
      cell: (record) => {
        return (
          <>
            {record.interest === "Yes" ? (
              <>
                Yes
                <img
                  style={{ height: "20px" }}
                  src="data:image/png;base64,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"
                ></img>
              </>
            ) : record.interest === "Requirement" ? (
              <>
                Requirement
                <img
                  style={{ height: "20px" }}
                  src="data:image/png;base64,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"
                ></img>
              </>
            ) : record.interest === "Follow Up" ? (
              <>
                Follow Up
                <img
                  style={{ height: "20px" }}
                  src="data:image/png;base64,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"
                ></img>
              </>
            ) :

              record.type === "Online" ? (
                <>
                  Requirement
                  <img
                    style={{ height: "20px" }}
                    src="data:image/png;base64,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"
                  ></img>

                </>
              )
                :
                (
                  <>
                    Follow Up
                    <img
                      style={{ height: "20px" }}
                      src="data:image/png;base64,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"
                    ></img>
                  </>
                )}
          </>
        );
      },
    },
    {
      key: "updated_interest",
      text: "Updated Interest",
      sortable: true,
      align: "left",
      cell: (record) => {
        return (
          <>
            {record.updated_interest === "Yes" ? (
              <>
                Yes
                <img
                  style={{ height: "20px" }}
                  src="data:image/png;base64,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"
                ></img>
              </>
            ) : record.updated_interest === "Requirement" ? (
              <>
                Requirement
                <img
                  style={{ height: "20px" }}
                  src="data:image/png;base64,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"
                ></img>
              </>
            ) : record.updated_interest === "Follow Up" ? (
              <>
                Follow Up
                <img
                  style={{ height: "20px" }}
                  src="data:image/png;base64,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"
                ></img>
              </>
            ) : (
              <></>
            )}
          </>
        );
      },
    },
    {
      key: "gdatetime_iolfgk",
      text: "Generate Date",
      sortable: true,
      align: "left",
      className: "text-nowrap",
      cell: (record) => {
        return (
          <Fragment>
            {record.datetime != "" && record.datetime != null ? (
              <>
                <p style={{ padding: 0, margin: 0 }}>
                  {
                    moment(record.datetime.replace(" ", "T"))
                      .format("DD/MM/yyyy HH:mm")
                      .toString()
                      .split(" ")[0]
                  }
                </p>
                <p style={{ padding: 0, margin: 0 }}>
                  {
                    moment(record.datetime.replace(" ", "T"))
                      .format("DD/MM/yyyy HH:mm")
                      .toString()
                      .split(" ")[1]
                  }
                </p>
              </>
            ) : null}
          </Fragment>
        );
      },
    },

    {
      key: "image",
      text: "image",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,

      cell: (record) => {
        const imagePath = record.image_path?.trim();

        const imageUrl =
          record.isImageUrl == 1 || imagePath?.startsWith("http")
            ? imagePath
            : record.url_image + imagePath;

        return (
          <Fragment>
            <img
              src={imageUrl}
              width="70px"
              height="70px"
              alt=""
              style={{ objectFit: "contain" }}
            />
          </Fragment>
        );
      },
    },
    {
      key: "status",
      text: "Status",
      sortable: true,
      align: "left",
    },
    {
      key: "datetime_jsgd",
      text: "Datetime",
      sortable: true,
      align: "left",
      className: "text-nowrap",
      cell: (record) => {
        return (
          <Fragment>
            {record.changedatetime != "" && record.changedatetime != null ? (
              <>
                <p style={{ padding: 0, margin: 0 }}>
                  {
                    moment(
                      record.changedatetime.split("T")[0] +
                      "T" +
                      record.changedatetime.split("T")[1].split(".")[0]
                    )
                      .format("DD/MM/yyyy HH:mm")
                      .toString()
                      .split(" ")[0]
                  }
                </p>
                <p style={{ padding: 0, margin: 0 }}>
                  {
                    moment(
                      record.changedatetime.split("T")[0] +
                      "T" +
                      record.changedatetime.split("T")[1].split(".")[0]
                    )
                      .format("DD/MM/yyyy HH:mm")
                      .toString()
                      .split(" ")[1]
                  }
                </p>
                {/* moment(record.changedatetime.split("T")[0]+'T'+(record.changedatetime.split('T')[1]).split('.')[0]).format("DD/MM/yyyy HH:mm")  */}
              </>
            ) : null}{" "}
          </Fragment>
        );
      },
    },

    ...(branch_type !== "2-Vehicle"
      ? [
        {
          key: "product_name",
          text: "Product Name",
          align: "left",
          sortable: true,
          className: "text-nowrap",
        },
        {
          key: "product_code",
          text: "Code",
          align: "left",
          sortable: true,
        },
        {
          key: "subcategory_name",
          text: "SubCategory",
          align: "left",
          sortable: true,
        },
      ]
      : []),

    {
      key: "total_points",
      text: "Points",
      sortable: true,
      align: "left",
      cell: (record) => {
        return <Fragment>{"" + record.total_points}</Fragment>;
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className="btn btn-link btn-sm"
              onClick={() => getCartRemarks(record)}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-indent"></i>
            </button>
            {record.table_type === "customer_upload" ||
              record.table_type === "customer_design" ? (
              <button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  deleteAction(record.tran_id);
                }}
              >
                <DeleteIcon />
              </button>
            ) : (
              <></>
            )}
            <a
              href={"http://api.whatsapp.com/send?phone=+91" + record.mobile}
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="28px"
                height="28px"
              >
                <path
                  fill="#fff"
                  d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
                />
                <path
                  fill="#fff"
                  d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
                />
                <path
                  fill="#cfd8dc"
                  d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
                />
                <path
                  fill="#40c351"
                  d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
                />
                <path
                  fill="#fff"
                  fill-rule="evenodd"
                  d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
          </Fragment>
        );
      },
    },
  ];

  // ----sales-----



  const viewPdf = (fileName) => {
    if (!fileName) return;

    const pdfUrl = `${API_BASE_URL}bills/${fileName}`;
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  };
  // ----------------------------------
  const columns_Sales = [

    {

      key: "customer_name",
      text: "Name",
      align: "left",
      sortable: true,
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },
    {
      key: "sales_type",
      text: "Type",
      align: "left",
      sortable: true,
    },
    {
      key: "product_code",
      text: "Product Code",
      align: "left",
      sortable: true,
    },

    {
      key: "product_name",
      text: "ProductName",
      align: "left",
      sortable: true,
    },

    {
      key: "category_name",
      text: "Product Category",
      align: "left",
      sortable: true,
    },

    {
      key: "subcategory_name",
      text: "Product Subcategory",
      align: "left",
      sortable: true,
    },

    {
      key: "quantity",
      text: "Quantity",
      align: "left",
      sortable: true,
    },

    {
      key: "gender",
      text: "Shope For",
      align: "left",
      sortable: true,
    },
    {
      key: "extra_charge_name",
      text: "Extra Charge Name",
      align: "left",
      sortable: true,
    },
    {
      key: "extra_charge_amount",
      text: "Extra Charge Amount",
      align: "right",
      sortable: true,
    },
    {
      key: "note",
      text: "Note",
      align: "right",
      sortable: true,
    },
    {
      key: "tax",
      text: "Tax",
      align: "left",
      sortable: false,
      cell: (record) => {
        let tax_val = 0;

        const sgst = parseFloat(record.SGST) || 0;
        const cgst = parseFloat(record.CGST) || 0;
        const igst = parseFloat(record.IGST) || 0;

        if (sgst && cgst) {
          tax_val = sgst + cgst;
        } else if (igst) {
          tax_val = igst;
        }

        return <Fragment>{tax_val}</Fragment>;
      }
    },
    {
      key: "image",
      text: "Image",
      align: "left",
      sortable: false,
      cell: (record) => {
        if (!record.image_path) return "No Image";

        const imageSrc =
          record.isImageUrl === true
            ? record.image_path
            : (record.url_image || "") + record.image_path;

        return (
          <img
            src={imageSrc}
            width="30"
            height="50"
            alt="product"
            style={{ objectFit: "cover", borderRadius: 4 }}
            onError={(e) => {
              e.target.src = "/no-image.png";
            }}
          />
        );
      }
    },
    {
      key: "total_discount",
      text: "Discount",
      align: "left",
      sortable: true,
    },
    {
      key: "final_amount",
      text: "Paid Amount",
      align: "left",
      sortable: true,
    },
    {
      key: "entry_no",
      text: "Invoice No",
      align: "left",
      sortable: true,
    },
    {
      key: "size_length",
      text: "Size",
      align: "left",
      sortable: true,
    },
    {
      key: "material",
      text: "Material",
      align: "left",
      sortable: true,
    },
    {
      key: "staff_name",
      text: "Staff Name",
      align: "left",
      sortable: true,
    },
    {
      key: "remarks",
      text: "Remark ",
      align: "left",
      sortable: true,
    },
    {
      key: "datetime",
      text: "Date ",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {record.datetime != "" && record.datetime != null
              ? moment(record.datetime.split(".")[0]).format("DD/MM/yyyy HH:mm")
              : null}
          </Fragment>
        );
      }
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            {record.bill_pdf && (
              <button
                className="btn btn-link btn-sm"
                title="View Bill"
                onClick={() => viewPdf(record.bill_pdf)}
              >
                <i className="fa fa-eye"></i>
              </button>
            )}
          </Fragment>
        );
      },
    }



  ]


  // ----end------

  //VCall
  const columns_VCall = [
    {
      key: "name",
      text: "Name",
      align: "left",
      sortable: true,
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },
    {
      key: "accept_date",
      text: "Appoint Date",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {record.accept_date != "" && record.accept_date != null
              ? moment(
                record.accept_date.split("T")[0] + "T" + record.accept_time
              ).format("DD/MM/yyyy HH:mm")
              : null}{" "}
          </Fragment>
        );
      },
    },
    {
      key: "remarks",
      text: "Remarks",
      sortable: true,
      align: "left",
      className: "text-nowrap",
      cell: (record) => {
        return (
          <Fragment>
            {record.remarks != "" && record.remarks != null
              ? record.remarks.length > 10
                ? record.remarks.substring(0, 10) + "..."
                : record.remarks
              : null}
          </Fragment>
        );
      },
    },
    {
      key: "status",
      text: "Status",
      sortable: true,
      align: "left",
    },
    {
      key: "datetime",
      text: "Generate Date",
      sortable: true,
      align: "left",
      cell: (record) => {
        return (
          <Fragment>
            {record.datetime != "" && record.datetime != null
              ? moment(record.datetime.split(".")[0]).format("DD/MM/yyyy HH:mm")
              : null}
          </Fragment>
        );
      },
    },
    {
      key: "datetime",
      text: "Datetime",
      sortable: true,
      align: "left",
      cell: (record) => {
        return (
          <Fragment>
            {record.changedatetime != "" && record.changedatetime != null
              ? moment(record.changedatetime.split(".")[0]).format(
                "DD/MM/yyyy HH:mm"
              )
              : null}
          </Fragment>
        );
      },
    },

    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className="btn btn-link btn-sm"
              onClick={() => getRemarks(record)}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-indent"></i>
            </button>
            <a
              href={"http://api.whatsapp.com/send?phone=+91" + record.mobile}
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="28px"
                height="28px"
              >
                <path
                  fill="#fff"
                  d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
                />
                <path
                  fill="#fff"
                  d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
                />
                <path
                  fill="#cfd8dc"
                  d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
                />
                <path
                  fill="#40c351"
                  d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
                />
                <path
                  fill="#fff"
                  fill-rule="evenodd"
                  d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
          </Fragment>
        );
      },
    },
  ];

  //Miss Call
  const columns_MissCall = [
    {
      key: "full_name",
      text: "Name",
      align: "left",
      sortable: true,
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },
    {
      key: "status",
      text: "Status",
      align: "left",
      sortable: true,
    },
    {
      key: "Source",
      text: "Type",
      align: "left",
      sortable: true,
    },
    {
      key: "remarks",
      text: "Remarks",
      sortable: true,
      align: "left",
      className: "text-nowrap",
      cell: (record) => {
        return (
          <Fragment>
            {record.remarks != "" && record.remarks != null
              ? record.remarks.length > 10
                ? record.remarks.substring(0, 10) + "..."
                : record.remarks
              : null}
          </Fragment>
        );
      },
    },
    {
      key: "accept_date",
      text: "Appoint Date",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {record.accept_date != "" && record.accept_date != null
              ? moment(
                record.accept_date.split("T")[0] + "T" + record.accept_time
              ).format("DD/MM/yyyy HH:mm")
              : null}{" "}
          </Fragment>
        );
      },
    },
    {
      key: "datetime",
      text: "Generate Date",
      sortable: true,
      align: "left",
      className: "text-nowrap",
      cell: (record) => {
        return (
          <Fragment>
            {record.datetime != "" && record.datetime != null
              ? moment(record.datetime.replace(" ", "T")).format(
                "DD/MM/yyyy HH:mm"
              )
              : null}
          </Fragment>
        );
      },
    },
    {
      key: "datetime",
      text: "Datetime",
      sortable: true,
      align: "left",
      className: "text-nowrap",
      cell: (record) => {
        // debugger;
        return (
          <Fragment>
            {record.changedatetime != "" && record.changedatetime != null
              ? moment(record.changedatetime.replace(" ", "T")).format(
                "DD/MM/yyyy HH:mm"
              )
              : null}
          </Fragment>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className="btn btn-link btn-sm"
              onClick={() => getMissRemarks(record)}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-indent"></i>
            </button>
            <a
              href={"http://api.whatsapp.com/send?phone=+91" + record.mobile}
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="28px"
                height="28px"
              >
                <path
                  fill="#fff"
                  d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
                />
                <path
                  fill="#fff"
                  d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
                />
                <path
                  fill="#cfd8dc"
                  d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
                />
                <path
                  fill="#40c351"
                  d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
                />
                <path
                  fill="#fff"
                  fill-rule="evenodd"
                  d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
          </Fragment>
        );
      },
    },
  ];

  //Feedback
  const columns_Feedback = [
    {
      key: "full_name",
      text: "Name",
      align: "left",
      sortable: true,
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },
    {
      key: "stars",
      text: "Stars",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <span class="text-nowrap">
            {parseInt(record.stars) > 0 &&
              Array.apply(null, Array(parseInt(record.stars))).map((x, i) => {
                return <i key={i} class="fas fa-star text-warning"></i>;
              })}
          </span>
        );
      },
    },
    {
      key: "remarks",
      text: "Remarks",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {record.service1}
            {record.service2 != "" ? "," : ""}
            {record.service2}
            {record.service3 != "" ? "," : ""}
            {record.service3}
            {record.service4 != "" ? "," : ""}
            {record.service4}
            {record.service5 != "" ? "," : ""}
            {record.service5}
            {record.service6 != "" ? "," : ""}
            {record.service6}
          </Fragment>
        );
      },
    },
    {
      key: "remarks",
      text: "remarks",
      sortable: true,
      align: "left",
    },
    {
      key: "datetime",
      text: "Datetime",
      sortable: true,
      align: "left",
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <a
              href={"http://api.whatsapp.com/send?phone=+91" + record.mobile}
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="28px"
                height="28px"
              >
                <path
                  fill="#fff"
                  d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
                />
                <path
                  fill="#fff"
                  d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
                />
                <path
                  fill="#cfd8dc"
                  d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
                />
                <path
                  fill="#40c351"
                  d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
                />
                <path
                  fill="#fff"
                  fill-rule="evenodd"
                  d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
          </Fragment>
        );
      },
    },
  ];

  //voucher
  const columns_Voucher = [
    {
      key: "full_name",
      text: "Name",
      align: "left",
      sortable: true,
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },
    {
      key: "voucher_name",
      text: "Voucher Name",
      align: "left",
      sortable: true,
    },
    {
      key: "voucher_heading",
      text: "Voucher Heading",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <span>{record.voucher_heading}</span>
            <br />
            <span>({record.voucher_value})</span>
          </Fragment>
        );
      },
    },
    {
      key: "filter_start_date",
      text: "Start Date",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <span>{moment(record.filter_start_date).format("DD-MM-yyyy")}</span>
          </Fragment>
        );
      },
    },
    {
      key: "filter_end_date",
      text: "End Date",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <span>{moment(record.filter_end_date).format("DD-MM-yyyy")}</span>
          </Fragment>
        );
      },
    },
    {
      key: "from_table",
      text: "Status",
      align: "left",
      sortable: true,
    },
    {
      key: "entry_date",
      text: "Action Date",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <span>
              {moment(record.entry_date.replace(" ", "T").split(".")[0]).format(
                "DD-MM-yyyy HH:mm"
              )}
            </span>
          </Fragment>
        );
      },
    },
  ];

  //Stock
  const columns_Stocks = [
    {
      key: "entry_no",
      text: "ERntry no",
      align: "left",
      sortable: true,
    },
    {
      key: "date",
      text: "Date",
      align: "left",
      sortable: true,
    },
    {
      key: "to_branch",
      text: "To Branch",
      align: "left",
      sortable: true,
    },
    {
      key: "status",
      text: "Status",
      align: "left",
      sortable: true,
    },
    {
      key: "remarks",
      text: "Remarks",
      align: "left",
      sortable: true,
    },
  ];

  const getRemarks = (record) => {
    if (record.accept_date != null && record.accept_date != "") {
      setUpdateVcall({
        ...updateVcall,
        tran_id: record.tran_id,
        status: record.status,
        accept_date: record.accept_date,
        accept_time: record.accept_time,
        remarks: "",
      });
      appointmenthandleDateChange(
        moment(record.accept_date).format("yyyy-MM-DD") +
        " " +
        record.accept_time
      );
    } else {
      setUpdateVcall({
        ...updateVcall,
        tran_id: record.tran_id,
        status: record.status,
        accept_date: moment(new Date()).format().split("T")[0],
        accept_time: moment(new Date()).format().split("T")[1],
        remarks: "",
      });
      appointmenthandleDateChange(moment(new Date()));
      // console.log(record,"this is record")
      // setMissedDate(moment(record.datetime))
    }

    postMethod("api/transactions/customer/vcall/remarks", {
      tran_id: record.tran_id,
    }).then((data) => {
      setVcallRemarks(data.data);
      toggleVideoCallRequestDetails();
    });
  };
  const updateVcallEntry = () => {
    // if (updateVcall.remarks == "") {
    //   setRemarksValidation(true);
    // } else {
    toggleVideoCallRequestDetails();
    updateVcall.accept_time = updateVcall.accept_time.split(":00")[0];
    updateVcall.remarks = updateVcall.remarks.trim();
    postMethod("api/transactions/customer/vcall/update", updateVcall).then(
      (data) => {
        setVcallRemarks(data.data);
        setUpdateVcall({ ...updateVcall, remarks: "" });
        browse_vCall();
        setRemarksLoader(false);
      }
    );
    //}
  };

  const getMissRemarks = (record) => {
    if (record.accept_date != null && record.accept_date != "") {
      setUpdateMiss({
        ...updateMiss,
        tran_id: record.tran_id,
        status: record.status,
        accept_date: record.accept_date,
        accept_time: record.accept_time,
      });

      appointmenthandleDateChange(
        moment(record.accept_date).format("yyyy-MM-DD") +
        " " +
        record.accept_time
      );
    } else {
      setUpdateMiss({
        ...updateMiss,
        tran_id: record.tran_id,
        status: record.status,
        accept_date: moment(new Date()).format().split("T")[0],
        accept_time: moment(new Date()).format().split("T")[1],
      });

      appointmenthandleDateChange(moment(new Date()));
    }

    postMethod("api/transactions/customer/missCall/remarks", {
      tran_id: record.tran_id,
    }).then((data) => {
      setMissCallRemarks(data.data);
      toggleMissCallRequestDetails();
    });
  };
  const updateMissEntry = () => {
    // if (updateMiss.remarks == "") {
    //   setRemarksMissValidation(true);
    // } else {
    setRemarksMissLoader(true);
    toggleMissCallRequestDetails();
    updateMiss.accept_time = updateMiss.accept_time.split(":00")[0];
    updateMiss.remarks = updateMiss.remarks.trim();
    postMethod("api/transactions/customer/missCall/update", updateMiss).then(
      (data) => {
        setMissCallRemarks(data.data);
        setUpdateMiss({ ...updateMiss, remarks: "" });
        browse_missCall();
        setRemarksMissLoader(false);
      }
    );
    //}
  };

  const getCartRemarks = (record) => {
    if (record.accept_date != null && record.accept_date != "") {
      setUpdateCart({
        ...updateCart,
        tran_id: record.tran_id,
        from: record.type,
        status: record.status,
        appointment_date: moment(
          record.appointment_date,
          "DD/MM/YYYY HH:mm"
        ).format("YYYY-MM-DDTHH:mm:ssZ"),
        accept_date: record.accept_date,
        accept_time: record.accept_time,
        remarks: "",
        date: record.datetime,
        interest: record?.interest,
        updated_interest: record?.updated_interest,
        image: record?.url_image + "" + record?.image_path,
      });
      appointmenthandleDateChange(
        moment(record.accept_date).format("yyyy-MM-DD") +
        " " +
        record.accept_time
      );
    } else {
      setUpdateCart({
        ...updateCart,
        tran_id: record.tran_id,
        status: record.status,
        from: record.type,
        appointment_date: moment(
          record.appointment_date,
          "DD/MM/YYYY HH:mm"
        ).format("YYYY-MM-DDTHH:mm:ssZ"),
        accept_date: moment(new Date()).format().split("T")[0],
        accept_time: moment(new Date()).format().split("T")[1],
        remarks: "",
        date: record.datetime,
        interest: record?.interest,
        updated_interest: record?.updated_interest,
        image: record?.url_image + "" + record?.image_path,
      });
      appointmenthandleDateChange(moment(new Date()));
    }
    postMethod("api/transactions/customer/cart/remarks", {
      tran_id: record.tran_id,
      from: record.type,
    }).then((data) => {
      setCartRemarks(data.data);
      toggleCartRequestDetails();
    });
  };

  // -----------------------------------------CART UPDATE_________------------------------------------------------------------------------

  const [cartImg, setCartImg] = useState(null);
  const [imgPrev, setImgPrev] = useState(null);

  const setPreviewImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      // Set the selected image
      setCartImg(file);
      setUpdateCart({
        ...updateCart,
        image: file,
      });
      // Generate a preview URL for the selected image
      const previewURL = URL.createObjectURL(file);
      setImgPrev(previewURL);
    } else {
      setCartImg(file);
      setUpdateCart({
        ...updateCart,
        image: "",
      });
    }
  };

  const updateCartEntry = async () => {
    setRemarksCartLoader(true);
    updateCart.accept_time = updateCart.accept_time.split(":00")[0];
    updateCart.remarks = updateCart.remarks.trim();

    const formData = new FormData();
    formData.append("file", updateCart["image"]);
    formData.append("tran_id", updateCart["tran_id"]);
    formData.append("status", updateCart["status"]);
    formData.append("from", updateCart["from"]);
    formData.append("remarks", updateCart["remarks"]);
    formData.append("appointment_date", updateCart["appointment_date"]);
    formData.append("accept_date", updateCart["accept_date"]);
    formData.append("accept_time", updateCart["accept_time"]);
    formData.append("branch_id", localStorage.getItem("jwl_branch_id"));
    formData.append("updated_interest", updateCart["updated_interest"]);

    try {
      const response = await axios.post(
        API_BASE_URL + "api/transactions/customer/cart/update",
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "auth-token": localStorage.getItem("jwl_token"),
          },
        }
      );
    } catch (error) {
      console.error("Error uploading images:", error);
    }

    toggleCartRequestDetails();
    toggleCartDetails();
  };

  // ------------------//------------------//----------------//---------------//


  const trialSVG = () => {
    return (
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="20pt"
        height="20pt"
        viewBox="0 0 820.000000 819.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <metadata>
          Created by potrace 1.16, written by Peter Selinger 2001-2019
        </metadata>
        <g
          transform="translate(0.000000,819.000000) scale(0.100000,-0.100000)"
          fill="#239e27"
          stroke="none"
        >
          <path
            d="M534 7250 c-269 -39 -479 -248 -523 -521 -7 -42 -11 -640 -11 -1781
          l0 -1718 4035 0 4035 0 0 1743 c0 1704 0 1746 -20 1821 -28 112 -73 189 -160
          277 -58 58 -96 86 -160 118 -149 73 -74 70 -1657 71 l-1413 0 0 -775 0 -775
          570 0 c314 0 570 -3 570 -6 0 -10 -1750 -1749 -1764 -1752 -6 -1 -407 394
          -891 878 l-880 880 573 0 572 0 0 775 0 775 -1412 -1 c-777 -1 -1436 -5 -1464
          -9z"
          />
          <path
            d="M100 2515 l0 -185 260 0 260 0 0 -760 0 -759 183 -3 c100 -2 192 -2
          205 0 l22 3 0 760 0 759 260 0 260 0 0 185 0 185 -725 0 -725 0 0 -185z"
          />
          <path
            d="M2022 2649 c-34 -4 -72 -11 -82 -14 -20 -6 -20 -20 -20 -931 l0 -924
          205 0 205 0 0 370 0 370 119 0 c166 0 219 -21 276 -111 30 -47 45 -92 110
          -337 30 -114 62 -226 71 -249 l16 -43 214 0 c118 0 214 2 214 4 0 3 -5 17 -11
          33 -6 15 -44 150 -85 298 -41 149 -86 293 -99 321 -32 65 -94 136 -157 178
          l-48 33 47 20 c209 88 321 301 284 543 -17 110 -57 186 -141 263 -111 102
          -231 153 -420 176 -97 13 -604 12 -698 0z m638 -314 c76 -23 142 -92 160 -164
          31 -130 -32 -259 -154 -312 -43 -19 -73 -24 -193 -27 l-143 -4 0 267 0 268
          138 -6 c87 -3 157 -11 192 -22z"
          />
          <path d="M3730 1720 l0 -940 200 0 200 0 0 940 0 940 -200 0 -200 0 0 -940z" />
          <path
            d="M5095 2648 c-5 -14 -98 -325 -258 -863 -53 -176 -141 -472 -196 -657
          -56 -186 -101 -340 -101 -343 0 -3 96 -5 213 -5 l214 0 53 203 c29 111 57 221
          63 245 l11 42 266 -2 265 -3 75 -242 75 -243 228 0 c125 0 227 4 227 8 0 12
          -28 102 -210 682 -213 679 -350 1117 -362 1158 l-9 32 -275 0 c-211 0 -276 -3
          -279 -12z m378 -683 c48 -203 87 -374 87 -380 0 -6 -73 -9 -202 -8 -112 1
          -202 6 -202 10 1 4 33 112 72 238 38 127 86 297 107 378 21 81 41 144 45 140
          4 -4 46 -174 93 -378z"
          />
          <path
            d="M6620 1720 l0 -940 585 0 585 0 0 185 0 185 -372 2 -373 3 -2 750 -2
          750 -211 3 -210 2 0 -940z"
          />
        </g>
      </svg>
    );
  };

  const misscallSVG = () => {
    return (
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="20pt"
        height="20pt"
        viewBox="0 0 452.000000 452.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <metadata>
          Created by potrace 1.16, written by Peter Selinger 2001-2019
        </metadata>
        <g
          transform="translate(0.000000,452.000000) scale(0.100000,-0.100000)"
          fill="#ff0000"
          stroke="none"
        >
          <path
            d="M2636 3864 c-38 -38 -36 -95 3 -135 l29 -29 354 0 353 0 -557 -557
              -558 -558 -608 608 -608 607 -45 0 c-62 0 -99 -35 -99 -94 0 -41 1 -42 660
              -701 655 -656 660 -660 700 -660 40 0 45 5 650 610 l610 610 0 -352 0 -351 26
              -31 c22 -26 33 -31 70 -31 36 0 50 5 69 26 l25 27 0 488 0 487 -26 31 -26 31
              -498 0 -497 0 -27 -26z"
          />
          <path
            d="M1770 2159 c-681 -50 -1174 -202 -1462 -451 -109 -94 -135 -196 -124
              -488 7 -210 28 -374 54 -433 42 -94 127 -157 214 -157 25 0 141 20 259 45 456
              97 633 136 649 145 26 14 77 76 100 120 26 51 60 181 100 385 24 121 37 164
              52 177 27 24 183 72 298 93 123 22 433 31 568 16 192 -21 393 -74 437 -115 18
              -17 30 -62 63 -222 51 -243 72 -315 112 -377 54 -81 78 -88 705 -217 255 -53
              306 -58 359 -36 47 20 114 89 138 143 29 65 49 260 51 488 3 294 -13 342 -148
              450 -304 244 -781 385 -1470 435 -164 12 -789 11 -955 -1z m935 -189 c642 -46
              1091 -174 1356 -386 55 -44 68 -60 80 -101 25 -87 10 -510 -22 -611 -13 -41
              -39 -55 -87 -46 -128 22 -767 166 -777 174 -7 6 -18 23 -24 38 -11 28 -63 263
              -102 457 -25 128 -28 131 -144 186 -100 47 -218 82 -360 106 -170 28 -584 26
              -753 -5 -146 -26 -321 -82 -394 -126 l-53 -31 -56 -276 c-58 -282 -73 -328
              -112 -353 -28 -18 -784 -178 -806 -171 -49 15 -74 164 -75 450 -1 211 6 237
              78 302 223 203 712 346 1341 392 162 12 748 12 910 1z"
          />
        </g>
      </svg>
    );
  };

  // ------------------------------------------------
  const dateConvert = (date) => {
    const originalDate = new Date(date);

    const year = originalDate.getFullYear();
    const month = String(originalDate.getMonth() + 1).padStart(2, "0");
    const day = String(originalDate.getDate()).padStart(2, "0");
    const hours = String(originalDate.getHours()).padStart(2, "0");
    const minutes = String(originalDate.getMinutes()).padStart(2, "0");
    const seconds = String(originalDate.getSeconds()).padStart(2, "0");
    const ampm = originalDate.getHours() >= 12 ? "PM" : "AM";

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
  };


  const export_array = () => {
    let arr =
      "Name,Mobile,Product Name,Code,Type,Appoint Date,Remarks,Status,Category,Customer Category,Interest,Generate Date,Datetime\r\n";
    let csvContent = "data:text/csv;charset=utf-8," + arr;

    productsInCart.forEach(function (rowArray) {
      var row = `${rowArray.customer_name},${rowArray.mobile},${rowArray.product_name
        },${rowArray.product_code},${rowArray.type},${dateConvert(
          rowArray.appointment
        )},${rowArray.remarks},${rowArray.status},${SubCategoryList[rowArray.category_id]
        },${rowArray.customer_category},${rowArray.interest},${rowArray.updated_interest
        },${rowArray.datetime},${rowArray.changedatetime}`;
      let arr =
        "Name,Mobile,Product Name,Code,Type,Appoint Date,Remarks,Status,Category,Customer_Category,Staff,Interest,Generate_Date,Datetime\r\n";
      let csvContent = "data:text/csv;charset=utf-8," + arr;

      productsInCart.forEach(function (rowArray) {
        var row = `${rowArray.customer_name},${rowArray.mobile},${rowArray.product_name
          },${rowArray.product_code},${rowArray.type},${dateConvert(
            rowArray.appointment
          )},${rowArray.remarks},${rowArray.status},${rowArray.category_id},${rowArray.customer_category
          },${rowArray.staff_id},${rowArray.interest},${rowArray.datetime},${rowArray.changedatetime
          }`;
        csvContent += row + "\r\n";
      });

      var encodedUri = encodeURI(csvContent);
      setDownloadLink(encodedUri);
      setDownloadReady(true);

      // link.setAttribute("href", encodedUri);
      // link.setAttribute("download", "customers_data.csv");
      // Required for FF
    });
  };

  const ref = useRef();

  const options = {
    orientation: "portrait", // 'portrait' or 'landscape'
    unit: "mm", // 'mm', 'cm', 'in', or 'px'
    format: "a4", // 'a3', 'a4', 'a5', 'letter', or 'legal'
  };

  // const { savePDF } = generatePDF({
  //   content: () => ref.current,
  //   fileName: 'example.pdf',
  //   options,
  // });

  useEffect(() => {
    dashboard_cartFun();
  }, [FilteredCartId, FilteredCartInterest, FilteredCartUpdatedInterest]);

  const getTargetElementNew = () =>
    document.getElementById("data_list_table_new");
  // -------------------------------------------------------------
  // ----------------show information---------------------------

  const [customerDetails, setCustomerDetails] = React.useState({
    customer_id: "",
    full_name: "",
    mobile: "",
    type: "",
    gender: "",
    dob: "",
    doa: "",
    category_name: "",
    staff_id: "",
    profession: "",
    address: "",
    email: "",
    visit_count: "",
    date: "",
  });
  const [showDetails, setShowDetails] = useState(false);
  const toggleDetail = function () {
    setShowDetails(!showDetails);
  };

  function findMobileByNumber(mobileArray, targetNumber) {
    const result = mobileArray.find((obj) => obj.mobile === targetNumber);
    return result || null;
  }

  // -------------------fetch allCustomer Data.---------------

  const getCustomerDetails = (mobileNo) => {
    let temparam = {
      mobile: mobileNo,
    };
    postMethod("api/customervisit/getCustomerDetails", temparam).then(
      (dataD) => {
        var data = dataD.data;

        setCustomerDetails({
          full_name: data.full_name,
          mobile: data.mobile,
          total_visit: data.total_visit,
          last_visit: data.last_visit,
          gender: data.gender,
          dob: data.dob == null ? "N/A" : data.dob,
          doa: data.doa == null ? "N/A" : data.doa,
          ref_name: data.ref_name,
          ref_mobile: data.ref_mobile,
          category_name: data.category_name,
          area_name: data.area_name,
          staff_name: data.staff_name,
          profession: data.profession,
          address: data.address,
          branch_name: data.branch_name,
        });
        // getCustomerHistory(data.customer_id);
        // getCustomerUploadHistory(data.customer_id);
        // getCustomerExhibitionHistory(data.customer_id);
        // getCustomerWishlistHistory(data.customer_id);
        toggleDetail();
      }
    );
  };

  // -------------------------------------------------------------

  const deleteAction = (id) => {
    if (window.confirm("Are you sure? you want to delete this entry?")) {
      postMethod("api/masters/dashboard/browse_cart/delete", {
        tran_id: id,
      }).then((data) => {
        // console.log(data)
        dashboard_cartFun();
        alert("Deleted Successfully");
      });
      //
      // alert(id)
    }
  };

  const downloadListImages = async () => {
    setLoaderState(true);
    await generatePDF(getTargetElementNew, {
      filename: `Exported_data_${moment(dashboardShowDate.startDate).format(
        "DD-MM-YYYY"
      )}-${moment(dashboardShowDate.endDate).format("DD-MM-YYYY")}.pdf`,
      applyImageFit: true,
      page: {
        margin: 20,
        orientation: "landscape",
        format: "A4",
      },
    })
      .then(() => {
        setLoaderState(false);
        alert("Download Done");
      })
      .catch((err) => {
        setLoaderState(false);
        alert("Error: " + err);
      });
  };

  const generatePDFNew = async (
    array_row = [],
    name = "export.pdf",
    options = {}
  ) => {
    const {
      categoryLabel = "category_id",
      dateFormatter = (image) =>
        image.datetime
          ? moment(image.datetime.replace(" ", "T")).format("DD/MM/yyyy HH:mm")
          : "",
    } = options;
    const array = array_row.filter(
      (element) => element !== undefined && element.image_path
    );

    const pdf = new jsPDF("l", "mm", "a4"); // Landscape orientation, A4 size.

    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;
    const margin = 10;
    const gap = 6;
    const cardsPerRow = 4;
    const rowsPerPage = 2;
    const cardWidth =
      (pageWidth - 2 * margin - gap * (cardsPerRow - 1)) / cardsPerRow;
    const cardHeight =
      (pageHeight - 2 * margin - gap * (rowsPerPage - 1)) / rowsPerPage;
    const cardPadding = 4;
    const textAreaHeight = 18;
    const imageBoxWidth = cardWidth - cardPadding * 2;
    const imageBoxHeight = cardHeight - textAreaHeight - cardPadding * 2;

    const loadImageSize = (src) =>
      new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () =>
          resolve({
            width: img.naturalWidth || img.width || 1,
            height: img.naturalHeight || img.height || 1,
          });
        img.onerror = () => resolve({ width: 1, height: 1 });
        img.src = src;
      });

    for (let index = 0; index < array.length; index += 8) {
      if (index > 0) {
        pdf.addPage(); // Start a new page for each set of 8 array
      }
      const maxarray = Math.min(8, array.length - index);
      for (let i = 0; i < maxarray; i++) {
        const image = array[index + i];
        const col = i % 4;
        const row = Math.floor(i / 4);
        const x = margin + col * (cardWidth + gap);
        const y = margin + row * (cardHeight + gap);
        const imageUrl =
          image.isImageUrl == 1 ||
            image.isImageUrl === true ||
            image.image_path?.startsWith("http")
            ? image.image_path
            : `${image.url_image || ""}${image.image_path}`;
        const imageSize = await loadImageSize(imageUrl);
        const imageRatio = imageSize.width / imageSize.height;
        const boxRatio = imageBoxWidth / imageBoxHeight;
        const drawWidth =
          imageRatio > boxRatio ? imageBoxWidth : imageBoxHeight * imageRatio;
        const drawHeight =
          imageRatio > boxRatio ? imageBoxWidth / imageRatio : imageBoxHeight;
        const drawX = x + cardPadding + (imageBoxWidth - drawWidth) / 2;
        const drawY = y + cardPadding + (imageBoxHeight - drawHeight) / 2;
        const formattedDate = dateFormatter(image);
        const labelValue =
          typeof categoryLabel === "function"
            ? categoryLabel(image)
            : image[categoryLabel];

        pdf.setFillColor(255, 255, 255);
        pdf.setDrawColor(229, 233, 242);
        pdf.roundedRect(x, y, cardWidth, cardHeight, 2, 2, "FD");

        pdf.setFillColor(248, 250, 252);
        pdf.rect(
          x + cardPadding,
          y + cardPadding,
          imageBoxWidth,
          imageBoxHeight,
          "F"
        );

        try {
          pdf.addImage(
            imageUrl,
            "JPEG",
            drawX,
            drawY,
            drawWidth,
            drawHeight
          );
        } catch (error) {
          pdf.setFontSize(9);
          pdf.setTextColor(120, 120, 120);
          pdf.text("Image unavailable", x + cardPadding + 4, y + 30);
        }

        pdf.setDrawColor(238, 242, 247);
        pdf.line(
          x + cardPadding,
          y + cardHeight - textAreaHeight,
          x + cardWidth - cardPadding,
          y + cardHeight - textAreaHeight
        );
        pdf.setTextColor(31, 41, 55);
        pdf.setFontSize(10);
        pdf.setFont(undefined, "bold");
        pdf.text(
          String(labelValue || "N/A"),
          x + cardPadding,
          y + cardHeight - 11,
          { maxWidth: cardWidth - cardPadding * 2 }
        );
        pdf.setTextColor(107, 114, 128);
        pdf.setFontSize(8);
        pdf.setFont(undefined, "normal");
        pdf.text(formattedDate, x + cardPadding, y + cardHeight - 5, {
          maxWidth: cardWidth - cardPadding * 2,
        });
      }
    }

    // Save the PDF
    pdf.save(name);
  };

  const generateSalesDetailsPDF = async (
    array_row = [],
    name = "sales.pdf"
  ) => {
    const salesRows = array_row.filter(
      (item) => item !== undefined && item.image_path
    );
    const pdf = new jsPDF("l", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;
    const margin = 10;
    const gap = 6;
    const cardsPerRow = 4;
    const rowsPerPage = 2;
    const cardWidth =
      (pageWidth - 2 * margin - gap * (cardsPerRow - 1)) / cardsPerRow;
    const cardHeight =
      (pageHeight - 2 * margin - gap * (rowsPerPage - 1)) / rowsPerPage;
    const cardPadding = 4;
    const textAreaHeight = 27;
    const imageBoxWidth = cardWidth - cardPadding * 2;
    const imageBoxHeight = cardHeight - textAreaHeight - cardPadding * 2;

    const getSalesImageUrl = (item) => {
      const imagePath = item && item.image_path ? item.image_path : "";
      const imageBaseUrl = item && item.url_image ? item.url_image : "";
      if (imageBaseUrl) {
        return `${imageBaseUrl}${imagePath}`;
      }
      if (imagePath.startsWith("http") || imagePath.startsWith("data:")) {
        return imagePath;
      }
      return imagePath;
    };

    const loadSalesImage = (src) =>
      new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => resolve(null);
        img.src = src;
      });

    for (let index = 0; index < salesRows.length; index += 8) {
      if (index > 0) {
        pdf.addPage();
      }

      const pageRows = Math.min(8, salesRows.length - index);
      for (let i = 0; i < pageRows; i++) {
        const sale = salesRows[index + i];
        const col = i % cardsPerRow;
        const row = Math.floor(i / cardsPerRow);
        const x = margin + col * (cardWidth + gap);
        const y = margin + row * (cardHeight + gap);
        const imageUrl = getSalesImageUrl(sale);
        const image = await loadSalesImage(imageUrl);

        pdf.setFillColor(255, 255, 255);
        pdf.setDrawColor(229, 233, 242);
        pdf.roundedRect(x, y, cardWidth, cardHeight, 2, 2, "FD");

        pdf.setFillColor(248, 250, 252);
        pdf.rect(
          x + cardPadding,
          y + cardPadding,
          imageBoxWidth,
          imageBoxHeight,
          "F"
        );

        if (image) {
          const imageRatio =
            (image.naturalWidth || image.width || 1) /
            (image.naturalHeight || image.height || 1);
          const boxRatio = imageBoxWidth / imageBoxHeight;
          const drawWidth =
            imageRatio > boxRatio ? imageBoxWidth : imageBoxHeight * imageRatio;
          const drawHeight =
            imageRatio > boxRatio ? imageBoxWidth / imageRatio : imageBoxHeight;
          const drawX = x + cardPadding + (imageBoxWidth - drawWidth) / 2;
          const drawY = y + cardPadding + (imageBoxHeight - drawHeight) / 2;
          const imageFormat = imageUrl.toLowerCase().includes(".png")
            ? "PNG"
            : "JPEG";

          try {
            pdf.addImage(
              imageUrl,
              imageFormat,
              drawX,
              drawY,
              drawWidth,
              drawHeight
            );
          } catch (error) {
            pdf.setFontSize(9);
            pdf.setTextColor(120, 120, 120);
            pdf.text("Image unavailable", x + cardPadding + 4, y + 30);
            pdf.setTextColor(37, 99, 235);
            pdf.textWithLink("Open image", x + cardPadding + 4, y + 36, {
              url: imageUrl,
            });
          }
        } else {
          pdf.setFontSize(9);
          pdf.setTextColor(120, 120, 120);
          pdf.text("Image unavailable", x + cardPadding + 4, y + 30);
          pdf.setTextColor(37, 99, 235);
          pdf.textWithLink("Open image", x + cardPadding + 4, y + 36, {
            url: imageUrl,
          });
        }

        const formattedDate = sale.datetime
          ? moment(sale.datetime.split(".")[0].replace(" ", "T")).format(
            "DD/MM/YYYY HH:mm"
          )
          : "";
        const textX = x + cardPadding;
        const textTop = y + cardHeight - textAreaHeight + 7;

        pdf.setDrawColor(238, 242, 247);
        pdf.line(
          x + cardPadding,
          y + cardHeight - textAreaHeight,
          x + cardWidth - cardPadding,
          y + cardHeight - textAreaHeight
        );
        pdf.setTextColor(31, 41, 55);
        pdf.setFontSize(10);
        pdf.setFont(undefined, "bold");
        pdf.text(`Invoice No: ${sale.entry_no || "N/A"}`, textX, textTop, {
          maxWidth: cardWidth - cardPadding * 2,
        });
        pdf.setFontSize(8);
        pdf.setFont(undefined, "normal");
        pdf.setTextColor(75, 85, 99);
        pdf.text(`Product: ${sale.product_name || "N/A"}`, textX, textTop + 5, {
          maxWidth: cardWidth - cardPadding * 2,
        });
        pdf.text(
          `Category: ${sale.category_name || sale.subcategory_name || "N/A"}`,
          textX,
          textTop + 10,
          { maxWidth: cardWidth - cardPadding * 2 }
        );
        pdf.setTextColor(107, 114, 128);
        pdf.text(formattedDate, textX, textTop + 15, {
          maxWidth: cardWidth - cardPadding * 2,
        });
      }
    }

    pdf.save(name);
  };

  const downloadSalesPdf = async () => {
    if (salesPdfDownloading) {
      return;
    }

    setSalesPdfDownloading(true);
    try {
      await generateSalesDetailsPDF(
        salesDetailFilteredGrid,
        `Exported_sales_${moment(dashboardShowDate.startDate).format(
          "DD-MM-YYYY"
        )}-${moment(dashboardShowDate.endDate).format("DD-MM-YYYY")}.pdf`
      );
    } finally {
      setSalesPdfDownloading(false);
    }
  };

  const getSalesTaxValue = (record) => {
    const sgst = parseFloat(record.SGST) || 0;
    const cgst = parseFloat(record.CGST) || 0;
    const igst = parseFloat(record.IGST) || 0;

    if (sgst && cgst) {
      return sgst + cgst;
    }
    if (igst) {
      return igst;
    }
    return 0;
  };

  const downloadSalesTablePDF = async () => {
    const pdf = new jsPDF("l", "mm", "a3");
    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;
    const filename = `Exported_data_${moment(
      dashboardShowDate.startDate
    ).format("DD-MM-YYYY")}-${moment(dashboardShowDate.endDate).format(
      "DD-MM-YYYY"
    )}.pdf`;
    const columns = [
      { label: "Name", key: "customer_name", width: 22 },
      { label: "Mobile", key: "mobile", width: 21 },
      { label: "Type", key: "sales_type", width: 13 },
      { label: "Date", key: "datetime", width: 22 },
      { label: "Product Code", key: "product_code", width: 23 },
      { label: "Product", key: "product_name", width: 23 },
      { label: "Category", key: "category_name", width: 20 },
      { label: "Subcategory", key: "subcategory_name", width: 24 },
      { label: "Qty", key: "quantity", width: 10 },
      { label: "Shop For", key: "gender", width: 16 },
      { label: "Tax", key: "tax", width: 10 },
      { label: "Image", key: "image_path", width: 18 },
      { label: "Paid", key: "final_amount", width: 14 },
      { label: "Invoice", key: "entry_no", width: 17 },
      { label: "Size", key: "size_length", width: 13 },
      { label: "Material", key: "material", width: 17 },
      { label: "Staff", key: "staff_name", width: 16 },
      { label: "Remark", key: "remarks", width: 24 },
    ];
    const margin = 8;
    const rowHeight = 18;
    const headerHeight = 12;
    let y = 18;

    const fillPageBackground = () => {
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, pageWidth, pageHeight, "F");
    };

    const drawWhiteCell = (x, yPosition, width, height) => {
      pdf.setFillColor(255, 255, 255);
      pdf.rect(x, yPosition, width, height, "F");
      pdf.setDrawColor(225, 229, 235);
      pdf.rect(x, yPosition, width, height, "S");
    };

    const getCellText = (record, key) => {
      if (key === "tax") {
        return String(getSalesTaxValue(record));
      }
      if (key === "datetime" && record.datetime) {
        return moment(record.datetime.split(".")[0].replace(" ", "T")).format(
          "DD/MM/YYYY HH:mm"
        );
      }
      return record[key] === null || record[key] === undefined
        ? ""
        : String(record[key]);
    };

    const getSalesTableImageUrl = (record) => {
      const imagePath = record && record.image_path ? record.image_path : "";
      const imageBaseUrl = record && record.url_image ? record.url_image : "";

      if (imageBaseUrl) {
        return `${imageBaseUrl}${imagePath}`;
      }
      return imagePath;
    };

    const loadSalesTableImage = (src) =>
      new Promise((resolve) => {
        if (!src) {
          resolve(null);
          return;
        }

        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => resolve(null);
        img.src = src;
      });

    const drawHeader = () => {
      let x = margin;
      pdf.setFontSize(11);
      pdf.setFont(undefined, "bold");
      pdf.setTextColor(0, 0, 0);
      pdf.text("Sales Details", margin, 10);
      pdf.setFontSize(7);
      columns.forEach((column) => {
        drawWhiteCell(x, y, column.width, headerHeight);
        pdf.setTextColor(0, 0, 0);
        pdf.text(column.label, x + 1.5, y + 4.5, {
          maxWidth: column.width - 3,
        });
        x += column.width;
      });
      y += headerHeight;
    };

    fillPageBackground();
    drawHeader();

    for (let rowIndex = 0; rowIndex < grid.length; rowIndex++) {
      const record = grid[rowIndex];
      if (y + rowHeight > pageHeight - margin) {
        pdf.addPage();
        fillPageBackground();
        y = 18;
        drawHeader();
      }

      let x = margin;
      pdf.setFont(undefined, "normal");
      pdf.setFontSize(6.5);
      pdf.setTextColor(0, 0, 0);

      columns.forEach((column) => {
        drawWhiteCell(x, y, column.width, rowHeight);
        pdf.setTextColor(0, 0, 0);

        if (column.key === "image_path") {
          x += column.width;
          return;
        }

        const text = pdf.splitTextToSize(
          getCellText(record, column.key),
          column.width - 3
        );
        pdf.text(text.slice(0, 2), x + 1.5, y + 4, {
          maxWidth: column.width - 3,
        });
        x += column.width;
      });

      const imageColumnIndex = columns.findIndex(
        (column) => column.key === "image_path"
      );
      const imageX =
        margin +
        columns
          .slice(0, imageColumnIndex)
          .reduce((total, column) => total + column.width, 0);
      const imageUrl = getSalesTableImageUrl(record);
      const image = await loadSalesTableImage(imageUrl);

      if (image) {
        try {
          const imageSize = rowHeight - 4;
          pdf.addImage(image, "PNG", imageX + 2, y + 2, imageSize, imageSize);
        } catch (error) {
          pdf.setTextColor(0, 0, 0);
          pdf.text("Image", imageX + 1.5, y + 6, {
            maxWidth: columns[imageColumnIndex].width - 3,
          });
        }
      }

      y += rowHeight;
    }

    pdf.save(filename);
  };

  const downloadCartTablePDF = async () => {
    const pdf = new jsPDF("l", "mm", "a3");
    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;
    const filename = `Exported_data_${moment(
      dashboardShowDate.startDate
    ).format("DD-MM-YYYY")}-${moment(dashboardShowDate.endDate).format(
      "DD-MM-YYYY"
    )}.pdf`;
    const columns = [
      { label: "Name", key: "customer_name", width: 22 },
      { label: "Mobile", key: "mobile", width: 21 },
      { label: "Type", key: "type", width: 14 },
      { label: "Appoint Date", key: "appointment_date", width: 20 },
      { label: "Remarks", key: "remarks", width: 34 },
      { label: "Amount", key: "amount", width: 18 },
      { label: "Staff", key: "staff_id", width: 14 },
      { label: "Category", key: "category_id", width: 16 },
      { label: "Customer Category", key: "customer_category", width: 22 },
      { label: "Interest", key: "interest", width: 16 },
      { label: "Updated Interest", key: "updated_interest", width: 18 },
      { label: "Generate Date", key: "datetime", width: 20 },
      { label: "Image", key: "image_path", width: 18 },
      { label: "Status", key: "status", width: 14 },
      { label: "Datetime", key: "changedatetime", width: 20 },
      { label: "Product Name", key: "product_name", width: 22 },
      { label: "Code", key: "product_code", width: 16 },
      { label: "SubCategory", key: "subcategory_name", width: 18 },
      { label: "Points", key: "total_points", width: 12 },
    ];
    const margin = 8;
    const minRowHeight = 16;
    const headerHeight = 12;
    let y = 18;

    const fillPageBackground = () => {
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, pageWidth, pageHeight, "F");
    };

    const drawWhiteCell = (x, yPosition, width, height) => {
      pdf.setFillColor(255, 255, 255);
      pdf.rect(x, yPosition, width, height, "F");
      pdf.setDrawColor(225, 229, 235);
      pdf.rect(x, yPosition, width, height, "S");
    };

    const formatCartDate = (dateValue) => {
      if (!dateValue || String(dateValue).includes("1900")) {
        return "";
      }

      const normalizedDate = String(dateValue).replace(" ", "T");
      const formattedDate = moment(normalizedDate).format("DD/MM/YYYY HH:mm");
      return formattedDate === "Invalid date" ? String(dateValue) : formattedDate;
    };

    const getCellText = (record, key) => {
      if (key === "type") {
        return record.type ? String(record.added_from || "").toUpperCase() : "";
      }
      if (key === "appointment_date") {
        return formatCartDate(record.appointment_date || record.appointment);
      }
      if (key === "datetime") {
        return formatCartDate(record.datetime);
      }
      if (key === "changedatetime") {
        return formatCartDate(record.changedatetime);
      }
      if (key === "amount") {
        if (record.amount === null || record.amount === undefined || record.amount === "") {
          return "";
        }
        const num = Number(record.amount);
        return isNaN(num) ? String(record.amount) : `${num.toLocaleString("en-IN")}`;
      }
      return record[key] === null || record[key] === undefined
        ? ""
        : String(record[key]);
    };

    const getCartImageUrl = (record) => {
      const imagePath = record && record.image_path ? record.image_path.trim() : "";
      if (!imagePath) {
        return "";
      }
      if (record.isImageUrl == 1 || imagePath.startsWith("http")) {
        return imagePath;
      }
      return `${record.url_image || ""}${imagePath}`;
    };

    const loadCartImage = (src) =>
      new Promise((resolve) => {
        if (!src) {
          resolve(null);
          return;
        }

        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => resolve(null);
        img.src = src;
      });

    const drawHeader = () => {
      let x = margin;
      pdf.setFontSize(11);
      pdf.setFont(undefined, "bold");
      pdf.setTextColor(0, 0, 0);
      pdf.text("Cart Details", margin, 10);
      pdf.setFontSize(7);
      columns.forEach((column) => {
        drawWhiteCell(x, y, column.width, headerHeight);
        pdf.setTextColor(0, 0, 0);
        pdf.text(column.label, x + 1.5, y + 4.5, {
          maxWidth: column.width - 3,
        });
        x += column.width;
      });
      y += headerHeight;
    };

    fillPageBackground();
    drawHeader();

    for (let rowIndex = 0; rowIndex < productsInCart.length; rowIndex++) {
      const record = productsInCart[rowIndex];

      // Calculate dynamic row height based on full text of remarks & other fields
      let maxLines = 1;
      columns.forEach((col) => {
        if (col.key === "image_path") return;
        const rawText = getCellText(record, col.key);
        if (rawText) {
          pdf.setFontSize(6.5);
          const splitLines = pdf.splitTextToSize(rawText, col.width - 3);
          if (splitLines.length > maxLines) {
            maxLines = splitLines.length;
          }
        }
      });
      const currentRowHeight = Math.max(minRowHeight, maxLines * 3.2 + 5);

      if (y + currentRowHeight > pageHeight - margin) {
        pdf.addPage();
        fillPageBackground();
        y = 18;
        drawHeader();
      }

      let x = margin;
      pdf.setFont(undefined, "normal");
      pdf.setFontSize(6.5);
      pdf.setTextColor(0, 0, 0);

      columns.forEach((column) => {
        drawWhiteCell(x, y, column.width, currentRowHeight);
        pdf.setTextColor(0, 0, 0);

        if (column.key === "image_path") {
          x += column.width;
          return;
        }

        const text = pdf.splitTextToSize(
          getCellText(record, column.key),
          column.width - 3
        );
        pdf.text(text, x + 1.5, y + 4, {
          maxWidth: column.width - 3,
        });
        x += column.width;
      });

      const imageColumnIndex = columns.findIndex(
        (column) => column.key === "image_path"
      );
      const imageX =
        margin +
        columns
          .slice(0, imageColumnIndex)
          .reduce((total, column) => total + column.width, 0);
      const imageUrl = getCartImageUrl(record);
      const image = await loadCartImage(imageUrl);

      if (image) {
        try {
          const imageSize = Math.min(currentRowHeight - 4, 14);
          const imgY = y + (currentRowHeight - imageSize) / 2;
          pdf.addImage(image, "PNG", imageX + 2, imgY, imageSize, imageSize);
        } catch (error) {
          pdf.setTextColor(0, 0, 0);
          pdf.text("Image", imageX + 1.5, y + 6, {
            maxWidth: columns[imageColumnIndex].width - 3,
          });
        }
      }

      y += currentRowHeight;
    }

    pdf.save(filename);
  };

  const SendWhatsapp = () => {
    const array = productsInCart.filter((element) => element !== undefined);
    setSendList(array);
    setModalCartDetails(false);
    setModelWhatsapp(true);
    // console.log(array);
  };

  const SendWhatsappAPI = () => {
    // console.log(SendList);
    // console.log(WhatsAppMessage);
    alert("Sending Scheduled successfully!");
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  async function maintobase64(file) {
    return await toBase64(file);
  }
  function getFileExtensionFromBase64(base64String) {
    const matches = base64String.match(/^data:image\/([a-zA-Z]+);base64,/);
    if (matches && matches.length > 1) {
      return matches[1];
    }
    return null;
  }
  function createGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  const handleSubmitUploadForm = () => {
    let file = document.getElementById("updateImage");
    let files = file.files;
    let formData = new FormData();
    let openUploadValues = {};
    if (files.length > 0) {
      for (var j = 0; j < files.length; j++) {
        let file_name = "image-" + createGuid();
        let ext = getFileExtensionFromBase64(uploadedFile);
        openUploadValues.image_path = file_name + "." + ext;
        formData.append("files", files[j], file_name);
      }
    }

    postMethod("api/customervisit/insertCustomerUpload", openUploadValues).then(
      (data) => {
        if (files.length > 0) {
          uploadImageFunc(formData);
        }
        setUploadedFile({});
      }
    );
  };
  const uploadImageFunc = (formData) => {
    const url = API_BASE_URL + `api/customervisit/UploadCustomerImage`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "auth-token": localStorage.getItem("jwl_token"),
      },
    };

    post(url, formData, config).then(
      (response) => {
        // console.log(response);
      },
      (error) => {
        // setSuccess(true);
      }
    );
  };

  // ------------pie chart-----------



  // --------------------------------
  const get_ApoointmentData = () => {
    const today = moment().format("DD/MM/YYYY");
    const filtered_ap = productsInCart.filter(
      (item) =>
        moment(item.appointment_date, "DD/MM/YYYY HH:mm:ss").format(
          "DD/MM/YYYY"
        ) === today
    );
    setProductsInCart(filtered_ap);
  };




  // -------Export BirthDay and Aniversary---

  const getTargetElementBA = () => document.getElementById("data_list_tableBA");

  const export_arrayBA = () => {
    let arr = "Name,Mobile,Category,Date,Type\r\n";
    let csvContent = "data:text/csv;charset=utf-8," + arr;

    dobANDdoa.forEach(function (rowArray) {
      var row = `${rowArray.full_name},${rowArray.mobile},${rowArray.category_name ? rowArray.category_name : ""
        },${moment(rowArray.occasion_date).format("DD/MM/yyyy")},${rowArray.dob == "true"
          ? "Birthday"
          : rowArray.doa == "true"
            ? "Anniversary"
            : rowArray.sp_bdy == "true"
              ? "Spouse's Birthday"
              : " "
        }`;
      csvContent += row + "\r\n";
    });

    var encodedUri = encodeURI(csvContent);
    setDownloadLink(encodedUri);
    setDownloadReady(true);
  };

  // --------


  // --------------sales---------

  const export_array_sales = () => {
    const header = [
      "Name",
      "Mobile",
      "Type",
      "ProductCode",
      "ProductName",
      "Product Category",
      "Product Subcategory",
      "Shope For",
      "PaidAmount",
      "Invoice No.",
      "Size",
      "Material",
      "Tax",
      "Staff Name",
      "Remark"
    ];

    const rows = grid.map((row) => [
      row.customer_name,
      row.mobile,
      row.sales_type,
      row.product_code,
      row.product_name,
      row.category_name,
      row.subcategory_name,
      row.gender,
      row.subtotal_after_discount,
      row.entry_no,
      row.size_length,
      row.material,
      row.tax,
      row.staff_name,
      row.remarks
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [header, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);

    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "sales_data.csv");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  // ---------------------------

  // -----------customer_point--------------

  const [pointModal, setPointModal] = useState(false);

  const togglePoint = () => {
    setPointModal(!pointModal);
  };

  useEffect(() => {
    postMethod("api/customervisit/notification/customer_point", {
      from_date: moment(dashboardShowDate.startDate).format("yyyy-MM-DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy-MM-DD"),
    })
      .then((data) => {
        setCustomerPoint(data.data);
        // setCountPoint(data.data[0].count_check);
        setCountPoint(data.data?.[0]?.count_check ?? 0);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dashboardShowDate]);

  const columns_cust_Point = [
    {
      key: "full_name",
      text: "Name",
      align: "left",
      sortable: true,
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },

    {
      key: "type",
      text: "Type",
      align: "left",
      sortable: true,
      cell: (record) => {
        let color;

        if (record.type === "Expired") {
          color = "red";
        } else if (record.type === "Redeem") {
          color = "blue";
        } else {
          color = "green";
        }

        return (
          <Fragment>
            <div style={{ color }}>
              {record.type}
            </div>
          </Fragment>
        );
      },
    },


    {
      key: "category_name",
      text: "Category",
      align: "left",
      sortable: true,
    },
    {
      key: "staff_name",
      text: "Staff",
      align: "left",
      sortable: true,
    },

    {
      key: "remark",
      text: "Remark",
      align: "left",
      sortable: true,
    },

    {
      key: "points",
      text: "Point",
      align: "left",
      sortable: true,
    },

    {
      key: "date_time",
      text: "Datetime",
      sortable: true,
      align: "left",
      className: "text-nowrap",
      cell: (record) => {
        const formatDateTime = (datetime) => {
          if (!datetime) return null;
          const [datePart, timePartWithMs] = datetime.split("T");
          const timePart = timePartWithMs?.split(".")[0];
          const formatted = moment(`${datePart}T${timePart}`).format("DD/MM/yyyy HH:mm").split(" ");
          return (
            <>
              <p style={{ padding: 0, margin: 0 }}>{formatted[0]}</p>
              <p style={{ padding: 0, margin: 0 }}>{formatted[1]}</p>
            </>
          );
        };

        const isRedType = record.type === "Expired";
        return (
          <Fragment>
            {isRedType && formatDateTime(record.expire_date)}
            {!isRedType && formatDateTime(record.date_time)}
          </Fragment>
        );
      }
    }


  ];

  // -----------------------------

  // -----------customer_service--------------
  const [serviceNum, setServiceNum] = useState(0);
  const [doneService, setDoneService] = useState(0);
  const [todayInterestYes, setTodayInterestYes] = useState(0);

  const serviceCountData = () => {
    postMethod("api/customervisit/Done/service", {
      from_date: moment(dashboardShowDate.startDate).format("yyyy-MM-DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy-MM-DD"),
    })
      .then((data) => {
        setServiceNum(data.data[0].interest_yes_count);
        setDoneService(data.data[0].done_service_count);
        setTodayInterestYes(data.data[0].today_interest_yes_count);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //------------------------------------------
  const [customerService, setCustomerService] = useState({});
  const [serviceCount, setServiceCount] = useState("0");
  const [todayServiceCount, setTodayServiceCount] = useState("0");
  const [serviceModal, setServiceModal] = useState(false);
  const [filteredCustomerService, setFilteredCustomerService] = useState([]);
  const [statusFilter, setStatusFilter] = useState("All");
  const [nextServiceToday, setNextServiceToday] = useState(false);

  const toggleService = () => {
    setServiceModal(!serviceModal);
  };

  useEffect(() => {
    postMethod("api/customervisit/details/customer_service", {
      from_date: moment(dashboardShowDate.startDate).format("yyyy-MM-DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy-MM-DD"),
    })
      .then((data) => {
        setCustomerService(data.data);
        // setServiceCount(data.data[0].count_check);
        setServiceCount(data.data?.[0]?.count_check ?? 0);
        setFilteredCustomerService(data.data);
        setTodayServiceCount(data.data[0].today_services);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dashboardShowDate]);

  useEffect(() => {
    filterByStatusAndNextServiceDate();
  }, [statusFilter, nextServiceToday, customerService]);

  const filterByStatusAndNextServiceDate = () => {
    let filteredData = customerService;
    if (statusFilter !== "All") {
      filteredData = filteredData.filter(
        (record) => record.status === statusFilter
      );
    }
    if (nextServiceToday) {
      const todayDate = moment().format("YYYY-MM-DD");
      filteredData = filteredData.filter(
        (record) =>
          moment(record.next_service).format("YYYY-MM-DD") === todayDate
      );
    }
    setFilteredCustomerService(filteredData);
  };

  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const toggleNextServiceToday = () => {
    setNextServiceToday(!nextServiceToday);
  };

  const columns_cust_service = [
    {
      key: "full_name",
      text: "Name",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <a href="#" onClick={() => getCustomerDetails(record.mobile)}>
              {record.full_name}
            </a>
          </Fragment>
        );
      },
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },

    {
      key: "type",
      text: "Type",
      align: "left",
      sortable: true,
    },
    {
      key: "category",
      text: "Category",
      align: "left",
      sortable: true,
    },
    {
      key: "sub_category",
      text: "Model",
      align: "left",
      sortable: true,
    },

    {
      key: "staff",
      text: "Staff",
      align: "left",
      sortable: true,
    },

    {
      key: "remark",
      text: "Remark",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {
              record.remark ? record.remark : ""
            }
          </Fragment>
        );
      },
    },
    {
      key: "color",
      text: "Color",
      align: "left",
      sortable: true,
    },

    {
      key: "kms",
      text: "KMS",
      align: "left",
      sortable: true,
    },
    {
      key: "vichle_number",
      text: "Vichle",
      align: "left",
      sortable: true,
    },
    {
      key: "last_service_date",
      text: "Last Service",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {moment(record.last_service_date).format("DD/MM/YYYY") ===
              "01/01/1900"
              ? " "
              : moment(record.last_service_date).format("DD/MM/YYYY")}
          </Fragment>
        );
      },
    },
    {
      key: "next_service",
      text: "Next Service",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {moment(record.next_service).format("DD/MM/YYYY")}
          </Fragment>
        );
      },
    },
    {
      key: "status",
      text: "Status",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {record.status === "Pending..." ||
              record.status === "pending..." ? (
              <h6 style={{ color: "orange" }}>{record.status}</h6>
            ) : record.status === "Due" ? (
              <h6 style={{ color: "blue" }}>{record.status}</h6>
            ) : record.status === "OverDue" ? (
              <h6 style={{ color: "grey" }}>{record.status}</h6>
            ) : record.status === "Done" ? (
              <h6 style={{ color: "green" }}>{record.status}</h6>
            ) : record.status === "Reject" ? (
              <h6 style={{ color: "red" }}>{record.status}</h6>
            ) : (
              ""
            )}
          </Fragment>
        );
      },
    },
    {
      key: "payment",
      text: "Payment",
      align: "left",
      sortable: true,
    },

    {
      key: "points",
      text: "Point",
      align: "left",
      sortable: true,
    },

    {
      key: "date",
      text: "Date",
      align: "left",
      sortable: true,
      cell: (record) => {
        return <Fragment>{moment(record.date).format("DD/MM/YYYY")}</Fragment>;
      },
    },

    {
      key: "Add Service",
      text: "Add Service",
      className: "action",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <Button
              className="btn btn-info"
              onClick={() => openAddService(record.trancv_id)}
            >
              <PostAddIcon />
            </Button>
          </Fragment>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <Row>
              <Col>
                <Button
                  className="btn btn-sm"
                  style={{ backgroundColor: "orange" }}
                  onClick={() => getServiceCartDetails(record.trancv_id)}
                >
                  <i className="fa fa-indent" style={{ color: "white" }}></i>
                </Button>
              </Col>
              <Col>
                <Button
                  className="btn btn-danger btn-sm"
                  onClick={() => deleteActionService(record.trancv_id)}
                >
                  <DeleteIcon />
                </Button>
              </Col>
            </Row>
          </Fragment>
        );
      },
    },
  ];

  // -----------Add More Service____________________________________
  const [modalAddMoreService, setModalAddMoreServicde] = useState(false);
  const toggleAddMoreService = () =>
    setModalAddMoreServicde(!modalAddMoreService);

  const [vichleId, setVichleId] = useState(null);
  const [nxtservice, setNxtService] = useState("");

  const [customerData, setCustomerData] = useState({
    tran_id: "",
    customer_id: "",
    name: "",
    mobile: "",
    category: "",
    modal: "",
    staff: "",
    color: "",
    remark: "",
    payment: "",
    datetime: "",
    kms: "",
    image: "",
    last_service: "",
    next_service_date: "",
  });

  const openAddService = (id) => {
    setVichleId(id);
    postMethod("api/customervisit/get_customer_vichle/Service_details", { id })
      .then((data) => {
        const d = data.data[0];
        setCustomerData({
          ...customerData,
          tran_id: d.tran_id,
          name: d.full_name,
          customer_id: d.customer_id,
          mobile: d.mobile,
          category: d.category,
          modal: d.sub_category,
          staff: d.staff,
          remark: d.remarks,
          payment: d.payment,
          color: d.color,
          remark: d.remark,
          datetime: d.datetime,
          image: d.image,
          kms: d.kms,
          vichle: d.vichle_number,
          last_service: d.last_service_date,
          next_service_date: d.next_service,
          date: d.date,
        });
      })
      .catch((err) => {
        console.log(err);
      });
    toggleAddMoreService();
  };

  const getServiceDateFormat1 = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    return formattedDate;
  };

  // -----------end _______________________________________________________________

  // -----------------------------------------CART SERVICE UPDATE_________------------------------------------------------------------------------

  const [modalUpdateService, setModalUpdateServicde] = useState(false);
  const toggleUpdateService = () => setModalUpdateServicde(!modalUpdateService);

  const [vichleDetails, setVichleDetails] = useState({
    trans_id: "",
    customer_id: "",
    mobile: "",
    category: "",
    model: "",
    full_name: "",
    vichle_number: "",
    kms: "",
    type: "",
    staff: "",
    color: "",
    payment: "",
    last_service: "",
    next_service: "",
    image: "",
    remark: "",
    status: "",
    trancv_id: "",
  });

  const getServiceDateFormat = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    return formattedDate;
  };

  const getServiceCartDetails = (id) => {
    postMethod("api/customervisit/get_Single/service_data", {
      trancv_id: id,
    }).then((data) => {
      const datas = data.data[0];
      // alert("teting \n :: "+ JSON.stringify(datas));
      setVichleDetails({
        ...vichleDetails,
        customer_id: datas.customer_id,
        mobile: datas.mobile,
        category: datas.category,
        model: datas.sub_category,
        full_name: datas.full_name,
        vichle_number: datas.vichle_number,
        kms: datas.kms,
        type: datas.type,
        staff: datas.staff,
        color: datas.color,
        payment: datas.payment,
        last_service: datas.last_service_date,
        next_service: datas.next_service,
        image: datas.image,
        remark: datas.remark,
        status: datas.status,
        trancv_id: id,
        date: datas.date,
      });
    });
    toggleUpdateService();
  };

  const handleUploadService = (e) => {
    // alert("test :: "+ e.target.value);
    setVichleDetails({
      ...vichleDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleIntegerForm = (e) => {
    const value = e.target.value;

    // Check if the value is a valid integer
    if (!Number.isInteger(Number(value))) {
      alert("it should be a whole number.");
      setVichleDetails({
        ...vichleDetails,
        [e.target.name]: "",
      });
      return;
    }
    // Proceed with setting the state if the value is a valid number
    setVichleDetails({
      ...vichleDetails,
      [e.target.name]: value,
    });
  };

  const [serviceImage, setServiceImage] = useState(null);
  const [serviceImgPreview, setServiceImgPreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      // Set the selected image
      setServiceImage(file);

      // Generate a preview URL for the selected image
      const previewURL = URL.createObjectURL(file);
      setServiceImgPreview(previewURL);
    }
  };

  const updateServiceCartEntry = async () => {
    const formData = new FormData();
    formData.append("file", serviceImage);
    formData.append("mobile", vichleDetails.mobile);
    formData.append("customer_id", vichleDetails.customer_id);
    formData.append("full_name", vichleDetails.full_name);
    formData.append("staff_name", vichleDetails.staff);
    formData.append("color", vichleDetails.color);
    formData.append("payment", vichleDetails.payment);
    formData.append("last_service", vichleDetails.last_service);
    formData.append("next_service", vichleDetails.next_service);
    formData.append("category", vichleDetails.category);
    formData.append("model", vichleDetails.model);
    formData.append("kms", vichleDetails.kms);
    formData.append("status", vichleDetails.status);
    formData.append("vichle_number", vichleDetails.vichle_number);
    formData.append("bb_id", localStorage.getItem("jwl_branch_id"));
    formData.append("remark", vichleDetails.remark);
    formData.append("trancv_id", vichleDetails.trancv_id);

    try {
      const response = await axios.post(
        API_BASE_URL + "api/customervisit/update_product_service",
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "auth-token": localStorage.getItem("jwl_token"),
          },
        }
      );
    } catch (error) {
      console.error("Error uploading images:", error);
    }
  };

  const handleFormUpdateService = () => {
    updateServiceCartEntry();
    toggleUpdateService();
    setVichleDetails({
      ...vichleDetails,
      trans_id: "",
      customer_id: "",
      mobile: "",
      category: "",
      model: "",
      full_name: "",
      vichle_number: "",
      kms: "",
      type: "",
      staff: "",
      color: "",
      payment: "",
      status: "",
      last_service: "",
      next_service: "",
      image: "",
      remark: "",
      trancv_id: "",
    });
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  // ------------------------------------------

  const deleteActionService = (id) => {
    postMethod("api/customervisit/delete_service", {
      trancv_id: id,
    }).then((data) => {
      alert("Deleted Successfully");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    });
  };

  // ---------------------------------------------------------------------
  // Function to filter customerService data by today's date
  function filterByTodayDate() {
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
    const filteredData = customerService.filter(
      (service) => service.nextDate === today
    );
    alert(filteredData);
    return filteredData;
  }
  // --------------------------

  // ----------------------------
  const [modalServiceNoti, setModalServiceNoti] = useState(false);
  const toggleServiceNoti = () => setModalServiceNoti(!modalServiceNoti);
  const [serviceDueCount, setServiceDueCount] = useState(0);
  const [serviceNoti, setServiceNoti] = useState({});
  const serviceDueNotification = () => {
    postMethod("api/customervisit/due/service_notification", {
      from_date: moment(dashboardShowDate.startDate).format("yyyy-MM-DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy-MM-DD"),
    })
      .then((data) => {
        const datasn = data.data;
        // alert("---"+ JSON.stringify(data.data[0]));
        setServiceNoti(data.data);
        // setServiceDueCount(datasn[0].due_count);
        setServiceDueCount(datasn?.[0]?.due_count ?? 0);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const columns_service_noti = [
    {
      key: "full_name",
      text: "Name",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <a href="#" onClick={() => getCustomerDetails(record.mobile)}>
              {record.full_name}
            </a>
          </Fragment>
        );
      },
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },

    {
      key: "type",
      text: "Type",
      align: "left",
      sortable: true,
    },
    {
      key: "category",
      text: "Category",
      align: "left",
      sortable: true,
    },
    {
      key: "sub_category",
      text: "Model",
      align: "left",
      sortable: true,
    },

    {
      key: "staff",
      text: "Staff",
      align: "left",
      sortable: true,
    },

    {
      key: "remark",
      text: "Remark",
      align: "left",
      sortable: true,
    },
    {
      key: "color",
      text: "Color",
      align: "left",
      sortable: true,
    },

    {
      key: "kms",
      text: "KMS",
      align: "left",
      sortable: true,
    },
    {
      key: "vichle_number",
      text: "Vichle",
      align: "left",
      sortable: true,
    },
    {
      key: "last_service_date",
      text: "Last Service",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {moment(record.last_service_date).format("DD/MM/YYYY") ===
              "01/01/1900"
              ? " "
              : moment(record.last_service_date).format("DD/MM/YYYY")}
          </Fragment>
        );
      },
    },

    {
      key: "status",
      text: "Status",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            {record.status === "Pending..." ||
              record.status === "pending..." ? (
              <h6 style={{ color: "orange" }}>{record.status}</h6>
            ) : record.status === "Due" ? (
              <h6 style={{ color: "blue" }}>{record.status}</h6>
            ) : record.status === "OverDue" ? (
              <h6 style={{ color: "grey" }}>{record.status}</h6>
            ) : record.status === "Done" ? (
              <h6 style={{ color: "green" }}>{record.status}</h6>
            ) : record.status === "Reject" ? (
              <h6 style={{ color: "red" }}>{record.status}</h6>
            ) : (
              ""
            )}
          </Fragment>
        );
      },
    },
  ];


  // -------------------
  const [gridParam, setGridParam] = useState({});

  const [grid, setGrid] = React.useState([]);
  useEffect(() => {
    setLoad(true);
    postMethod("api/masters/dashboard/retailer/sales_cart", {
      from_date: moment(dashboardShowDate.startDate).format("yyyy-MM-DD"),
      to_date: moment(dashboardShowDate.endDate).format("yyyy-MM-DD"),
    }).then((data) => {
      // setCountPro_sale(data.data[0].today_sales_count);
      setCountPro_sale(data.data?.[0]?.today_sales_count ?? 0);
      setTotalSpCount(data.data.length);
      const list = data.data || [];
      const seenInvoices = new Set();
      let totalAmt = 0;
      let totalQty = 0;
      list.forEach((item, index) => {
        const invoiceKey =
          item.entry_no ||
          item.invoice_no ||
          item.invoice_id ||
          `row_${index}`;

        if (!seenInvoices.has(invoiceKey)) {
          seenInvoices.add(invoiceKey);
          totalAmt += parseFloat(item.final_amount) || 0;
        }

        const q = parseFloat(item.quantity ?? item.qty);
        totalQty += !isNaN(q) ? q : 1;
      });
      setUniqueInvoiceCount(seenInvoices.size);
      setTotalSalesQuantity(totalQty);
      setTotalSalesAmount(totalAmt);
      setGrid(data.data);
      setLoad(false);
    });
  }, [modalSaleDetails, dashboardShowDate]);

  // ----------Todays Sales

  const get_TodaysSalesData = () => {
    const filtered_ap1 = grid.filter((item) =>
      moment(item.datetime).isSame(moment(), "day")
    );

    setGrid(filtered_ap1);
  };


  const [salesFilterValue, setSalesFilterValue] = useState("");

  const filteredSalesData = useMemo(() => {
    if (!grid || !Array.isArray(grid)) return [];
    if (!salesFilterValue || !salesFilterValue.trim()) return grid;
    const filter = salesFilterValue.toLowerCase().trim();
    return grid.filter((record) => {
      return columns_Sales.some((column) => {
        let val = record[column.key];
        if (column.key === "tax") {
          val = getSalesTaxValue(record);
        } else if (column.key === "datetime" && record.datetime) {
          val = moment(record.datetime.split(".")[0]).format("DD/MM/YYYY HH:mm");
        }
        if (val !== null && val !== undefined) {
          return val.toString().toLowerCase().includes(filter);
        }
        return false;
      });
    });
  }, [grid, salesFilterValue, columns_Sales]);

  const salesSummary = useMemo(() => {
    let totalSales = 0;
    let totalDiscount = 0;
    let totalTax = 0;

    const seenInvoices = new Set();

    filteredSalesData.forEach((item, index) => {
      const invoiceKey =
        item.entry_no ||
        item.invoice_no ||
        item.invoice_id ||
        `row_${index}`;

      if (!seenInvoices.has(invoiceKey)) {
        seenInvoices.add(invoiceKey);
        totalSales += parseFloat(item.final_amount) || 0;
        totalDiscount += parseFloat(item.total_discount) || 0;
        totalTax += getSalesTaxValue(item);
      }
    });

    return { totalSales, totalDiscount, totalTax };
  }, [filteredSalesData]);

  const [showSaleDetails, setShowSaleDetails] = useState(false);
  const [salesDetailSearch, setSalesDetailSearch] = useState("");
  const [cartDetailSearch, setCartDetailSearch] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  const toggleShowSaleDetails = () => {
    setShowSaleDetails(!showSaleDetails);
    setCurrentIndex(0); // reset slider when opened
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === grid.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? grid.length - 1 : prev - 1
    );
  };

  const currentItem = grid?.[currentIndex];

  const imageSrc =
    currentItem?.image_path
      ? currentItem.isImageUrl
        ? currentItem.image_path
        : `${currentItem.url_image || ""}${currentItem.image_path}`
      : null;

  const salesDetailFilteredGrid = grid.filter((item) => {
    const searchText = salesDetailSearch.trim().toLowerCase();
    if (!searchText) {
      return true;
    }

    return [
      item?.customer_name,
      item?.mobile,
      item?.product_name,
      item?.product_code,
      item?.category_name,
      item?.sub_category_name,
      item?.subcategory_name,
      item?.entry_no,
      item?.type,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(searchText);
  });

  const cartDetailFilteredProducts = productsInCart.filter((item) => {
    const searchText = cartDetailSearch.trim().toLowerCase();
    if (!searchText) {
      return true;
    }

    return [
      item?.customer_name,
      item?.mobile,
      item?.product_name,
      item?.product_code,
      item?.category_id,
      item?.category_name,
      item?.sub_category_name,
      item?.subcategory_name,
      item?.staff_id,
      item?.interest,
      item?.updated_interest,
      item?.datetime,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(searchText);
  });

  const productCategoryColors = ["#1a7cff", "#16c784", "#ff9f00", "#ff4d6d", "#7c3aed"];
  const productCategoryRowsRaw = Object.values(
    CustomerGraph?.x_axis?.reduce((rows, item, index) => {
      const label = item ? String(item).trim() : "Other";
      const labelKey = label.toLowerCase();
      const value = Number(CustomerGraph?.y_axis?.[index]) || 0;

      rows[labelKey] = rows[labelKey] || { label, value: 0 };
      rows[labelKey].value += value;
      return rows;
    }, {}) || {}
  );
  const realProductCategoryValues = new Set(
    productCategoryRowsRaw
      .filter((row) => row.label.toLowerCase() !== "other")
      .map((row) => row.value)
  );
  const productCategoryRows = productCategoryRowsRaw
    .filter(
      (row) =>
        row.label.toLowerCase() !== "other" ||
        !realProductCategoryValues.has(row.value)
    )
    .map((row, index) => ({
      ...row,
      color: productCategoryColors[index % productCategoryColors.length],
    }));
  const totalProductCategoryCount = productCategoryRows.reduce(
    (total, row) => total + row.value,
    0
  );
  const messageProgress =
    whtAppCredit > 0 ? Math.min((countWht / whtAppCredit) * 100, 100) : 0;
  const messagesRemaining = Math.max((Number(whtAppCredit) || 0) - countWht, 0);
  const productCategoryChartOptions = {
    chart: {
      toolbar: { show: false },
    },
    colors: productCategoryRows.map((row) => row.color),
    dataLabels: {
      enabled: true,
      formatter: (_value, opts) =>
        productCategoryRows[opts.seriesIndex]?.value || "",
      style: {
        fontSize: "14px",
        fontWeight: 800,
        colors: ["#fff"],
      },
      dropShadow: { enabled: false },
    },
    labels: productCategoryRows.map((row) => row.label),
    legend: { show: false },
    plotOptions: {
      pie: {
        donut: {
          size: "56%",
          labels: {
            show: true,
            name: {
              show: true,
              offsetY: 18,
              color: "#778195",
              fontSize: "13px",
              fontWeight: 700,
            },
            value: {
              show: true,
              offsetY: -14,
              color: "#1f2937",
              fontSize: "34px",
              fontWeight: 800,
              formatter: () => totalProductCategoryCount,
            },
            total: {
              show: true,
              label: "Total Products",
              color: "#778195",
              fontSize: "13px",
              fontWeight: 700,
              formatter: () => totalProductCategoryCount,
            },
          },
        },
      },
    },
    stroke: {
      colors: ["#fff"],
      width: 2,
    },
    tooltip: {
      y: {
        formatter: (value) => `${value} products`,
      },
    },
  };

  // -------------------
  // -----------------------------
  return (
    <div>
      {load ? <Loader /> : null}
      <FullScreenLoader state={loaderState} />
      <div className="text-right">
        <button
          className="btn btn-danger pointerShow mb-3 ml-auto font-weight-bold"
          onClick={toggleDivBirthdayAndAnniversary}
          type="button"
        >
          Birthday and Anniversary ({occasionCount})
          <i class="fas fa-sort-down"></i>
        </button>
      </div>

      {/* Not Visiting Customers DateRange */}
      <Modal
        isOpen={modalDashboardDataRange}
        zIndex="99999"
        size={"xl"}
        backdrop="static"
        centered="true"
        className={className + " text-center"}
      >
        <ModalHeader>
          Data Range{" "}
          <i
            className="fa fa-close pull-right pointerShow"
            onClick={() => {
              toggleDashboardDataRange();
            }}
          ></i>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "400px", overflowY: "auto" }}>
          <Row>
            <Col sm="12">
              <DateRangePicker
                onChange={(item) => {
                  var startDate =
                    item.selection.startDate.toLocaleDateString("en-US");
                  var endDate =
                    item.selection.endDate.toLocaleDateString("en-US");
                  setState([item.selection]);
                  setDashboardShowDate({
                    ...dashboardShowDate,
                    startDate: startDate,
                    endDate: endDate,
                  });
                  // notVisitngCustomerDateChange(startDate,endDate)
                }}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={2}
                ranges={state}
                direction="horizontal"
              />
            </Col>
            <Col sm="12" className="text-right">
              {" "}
              <span
                className="badge-success pointerShow"
                onClick={() => {
                  toggleDashboardDataRange();
                  dashboard_cartFun();
                }}
              >
                Continue
              </span>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* Sedn WhatsAPP Message Model*/}
      <Modal
        isOpen={modelWhatsapp}
        zIndex="99999"
        size={"xl"}
        backdrop="static"
        centered="true"
        className={className + " text-center"}
      >
        <ModalHeader>
          Send Whatsapp
          <i
            className="fa fa-close pull-right pointerShow"
            onClick={() => {
              setModelWhatsapp(false);
            }}
          ></i>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "400px", overflowY: "auto" }}>
          <Row>
            <Col sm="12">
              <h3 className="my-1">Enter Whatsapp Message Below</h3>
            </Col>
            <Col sm="6" className="py-5">
              <h3>Choose Image</h3>
              <div className="row">
                <div className="col-md-12">
                  <input
                    id="updateImage"
                    innerRef={imageRef}
                    type="file"
                    multiple={true}
                    accept="image/*"
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        maintobase64(e.target.files[0]).then((data) => {
                          // console.log("Image Data")
                          // console.log(data);
                          setUploadedFile(data);
                        });
                        // }
                      } else {
                        e.target.value = null;
                      }
                    }}
                    name="Choose Image"
                  />
                </div>
                <div className="col-md-12">
                  <div className="previewImage mt-3">
                    <img
                      src={
                        Object.keys(uploadedFile).length > 0
                          ? uploadedFile
                          : "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081"
                      }
                    />
                  </div>
                </div>
              </div>
            </Col>
            <Col sm="6" className="py-5">
              <textarea
                required
                value={WhatsAppMessage}
                className="form-control h-auto  my-1 mx-1 px-2"
                name="remarks"
                // onClick={() => {
                //   setW(false);
                // }}
                onChange={(e) => setWhatsAppMessage(e.target.value)}
              />
              {WhatsAppMessageValidation ? (
                <Label className="text-danger">
                  WhatsAppMessage can not be blank.
                </Label>
              ) : null}
            </Col>
            <Col sm="12">
              <button
                className="btn btn-sm btn-success my-2"
                style={{
                  backgroundColor: "green",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  SendWhatsappAPI();
                }}
              >
                <i className="flaticon-whatsapp"></i> Send WhatsApp
              </button>
            </Col>
            <Col sm="12" className="text-right">
              <Table className="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Mobile</th>
                  </tr>
                </thead>
                <tbody>
                  {SendList.length > 0 ? (
                    SendList.map((row, i) => (
                      <tr>
                        <th scope="row">{i + 1}</th>
                        <td>{row.customer_name}</td>
                        <td>{row.mobile}</td>
                      </tr>
                    ))
                  ) : (
                    <td colSpan="4" className="text-center">
                      No Data
                    </td>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <Card className="shadow visit-figures-card">
        <CardHeader className="visit-figures-header">
          <div className="d-flex align-items-center">
            <span className="visit-figures-header-icon">
              <i className="fa fa-bar-chart"></i>
            </span>
            <h4 className="mb-0 font-weight-bold">Visit Figures</h4>
          </div>
          <div className="d-flex">
            {branch_type === "2-Vehicle" ? (
              <div className="d-flex align-items-center mr-3">
                <Button style={buttonStyle} onClick={toggleServiceNoti}>
                  <CircleNotificationsIcon style={{ fontSize: 28 }} />
                  <span style={countStyle}>{serviceDueCount}</span>
                </Button>
              </div>
            ) : (
              ""
            )}

            {branch_type !== "2-Vehicle" ? (
              <Tooltip title="Notification" arrow classes={{ tooltip: classes.countTooltip }}>

                <div className="d-flex align-items-center mr-3">

                  <NotificationBell
                    fromDate={moment(dashboardShowDate.startDate).format(
                      "YYYY/MM/DD"
                    )}
                    toDate={moment(dashboardShowDate.endDate).format(
                      "YYYY/MM/DD"
                    )}
                    encypt_id={branchEncryptID}
                  />

                </div>
              </Tooltip>

            ) : (
              ""
            )}
            <div className="d-flex align-items-center mr-3">
              <Tooltip title="Points Detail" arrow classes={{ tooltip: classes.countTooltip }}>
                <Button
                  className="btn btn-warning font-weight-bold"
                  style={{ height: "32px" }}
                  onClick={togglePoint}
                >
                  <MDBIcon fas icon="coins" style={{ color: "white" }} />
                  &nbsp; <sapn className="fw-bold" style={{ fontWeight: 800, fontSize: "18px" }}>{countPoint}</sapn>
                </Button>
              </Tooltip>
            </div>

            <div className="d-flex align-items-center mr-3">
              <Tooltip
                title={branch_type === "2-Vehicle" ? "Yes / Done" : "Transfer / Accept"}
                arrow
                classes={{ tooltip: classes.countTooltip }}
              >
                <Button
                  className="btn font-weight-bold"
                  style={{
                    height: "32px",
                    minWidth: "80px",
                    backgroundColor: "#fff",
                    color: "#000",
                    border: "1px solid #adb5bd",
                    fontWeight: 800,
                  }}
                >
                  {/* <MDBIcon fas icon="coins" style={{ color: "white" }} /> */}
                  &nbsp;{" "}
                  <sapn style={{ fontWeight: 800, fontSize: "18px" }}>
                    {branch_type === "2-Vehicle" ? (
                      <>
                        {serviceNum}
                        <span style={{ color: "#6c757d", margin: "0 12px" }}>
                          |
                        </span>
                        {doneService}
                      </>
                    ) : (
                      <>
                        {figures.stock_t}
                        <span style={{ color: "#6c757d", margin: "0 12px" }}>
                          |
                        </span>
                        {figures.stock_a}
                      </>
                    )}
                  </sapn>
                </Button>
              </Tooltip>
            </div>

            <div className="filter_date_range d-flex align-items-center mr-3">
              {/* <p className="mb-0 font-weight-bold">Filter Data</p> */}
              <div className="f_data_range" onClick={toggleDashboardDataRange}>
                <i className="far fa-calendar-alt mr-2"></i>{" "}
                {moment(dashboardShowDate.startDate).format("DD/MM/yyyy")} -{" "}
                {moment(dashboardShowDate.endDate).format("DD/MM/yyyy")}
              </div>
            </div>
            <a
              className="btn btn-danger font-weight-bold mt-1"
              style={{ height: "32px" }}
              href="/branch/customer/add"
            >
              Add Customer
            </a>
          </div>
        </CardHeader>
        <CardBody>
          <Row>
            <Col
              sm="6"
              md="3"
              className="pointerShow"
              onClick={() => {
                toggleTotalCustomer();
                browse_customers();
              }}
            >
              <Card
                body
                style={{
                  background: "linear-gradient(to bottom, #FFFFFF, #ffc2b3)",
                }}
              >
                <Row>
                  <Col sm="12">
                    <h4>Total Visits</h4>{" "}
                    <b>
                      {figures.total_visits}({figures.total_vist_customer_count}
                      )
                    </b>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col
              sm="6"
              md="3"
              className="pointerShow"
              onClick={() => {
                toggleTotalCustomerNew();
                browse_customers_new();
              }}
            >
              <Card
                body
                style={{
                  background: "linear-gradient(to bottom, #FFFFFF,  #f9f2ec)",
                }}
              >
                <Row>
                  <Col sm="12" className="">
                    <h4>Total New Customer</h4> <b>{figures.new_customers}</b>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col
              sm="6"
              md="3"
              className="pointerShow"
              onClick={() => {
                toggleCartDetails();
                dashboard_cartFun();
              }}
            >
              <Card
                body
                style={{
                  background: "linear-gradient(to bottom, #FFFFFF, #cce6ff)",
                }}
              >
                <Row>
                  <Col sm="12" className="">
                    <h4>Cart / Lead</h4> <b>{figures.total_cart}</b>
                  </Col>
                </Row>
                <span style={countStyle}>{count_ap}</span>
              </Card>
            </Col>
            {/*---Sales--*/}

            <Col
              sm="6"
              md="3"
              className="pointerShow"
              onClick={() => {
                toggleSaleDetails();
                dashboard_cartFun();
              }}
            >
              <Card
                body
                style={{
                  background: "linear-gradient(to bottom, #FFFFFF, #cce6ff)",
                }}
              >
                <Row>
                  <Col sm="12" className="">
                    <h4>Sales / Quantity</h4>{" "}
                    <b>
                      {uniqueInvoiceCount} / {totalSalesQuantity}
                    </b>
                  </Col>
                </Row>
                <span style={countStyle}>{countPro_sale}</span>
              </Card>
            </Col>

            {/* ------- Remaining Tiles (Toggleable) ------- */}
            {showAllTiles && (
              <>
                <Col
                  sm="6"
                  md="3"
                  className="pointerShow"
                  onClick={() => {
                    toggleModalVoucherDetails();
                    browse_vouchers();
                  }}
                >
                  <Card
                    body
                    style={{
                      background: "linear-gradient(to bottom,#FFFFFF, #ffe6ee)",
                    }}
                  >
                    <Row>
                      <Col sm="12" className="">
                        <h4>Vouchers</h4> <b>{figures.total_voucher}</b>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col
                  sm="6"
                  md="3"
                  className="pointerShow"
                  onClick={() => {
                    toggleNotVisitingCustomer();
                    browse_customers_not_visit();
                  }}
                >
                  <Card
                    body
                    style={{
                      background: "linear-gradient(to bottom, #FFFFFF, #f5ccff)",
                    }}
                  >
                    <Row>
                      <Col sm="12" className="">
                        <h4>No Response</h4>{" "}
                        <b>
                          {customerNoSaleCount > 0
                            ? `${figures.total_not_visit_customers} / ${customerNoSaleCount}`
                            : figures.total_not_visit_customers}
                        </b>
                      </Col>
                    </Row>
                  </Card>
                </Col>

                {branch_type === "2-Vehicle" ? (
                  <Col
                    sm="6"
                    md="3"
                    className="pointerShow"
                    onClick={() => {
                      toggleService();
                      // browse_customers_new();
                    }}
                  >
                    <Card
                      body
                      style={{
                        background: "linear-gradient(to bottom, #FFFFFF,  #ffebcc)",
                      }}
                    >
                      <Row>
                        <Col sm="12" className="">
                          <h4>Service</h4> <b>{serviceCount}</b>
                        </Col>
                      </Row>
                      <span style={countStyle}>{todayInterestYes}</span>
                    </Card>
                  </Col>
                ) : (
                  <Col
                    sm="6"
                    md="3"
                    className="pointerShow"
                    onClick={() => {
                      toggleVideoCallRequest();
                      browse_vCall();
                    }}
                  >
                    <Card
                      body
                      style={{
                        background: "linear-gradient(to bottom, #FFFFFF,  #ffebcc)",
                      }}
                    >
                      <Row>
                        <Col sm="12" className="">
                          <h4>Video call requests</h4> <b>{figures.VideoCall}</b>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                )}

                <Col
                  sm="6"
                  md="3"
                  className="pointerShow"
                  onClick={() => {
                    toggleMissCallRequest();
                    browse_missCall();
                  }}
                >
                  <Card
                    body
                    style={{
                      background: "linear-gradient(to bottom, #FFFFFF, #d6f5d6)",
                    }}
                  >
                    <Row>
                      <Col sm="12">
                        <h4>Missed call </h4>
                        <b>
                          {branch_type === "2-Vehicle"
                            ? figures.missedCall + "/" + figures.VideoCall
                            : figures.missedCall}
                        </b>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </>
            )}

            {/* Toggle Button under first 4 tiles */}
            <Col xs="12" className="text-center mt-2 mb-1">
              <Button
                color="light"
                className="btn-sm px-4 py-1 font-weight-bold shadow-sm"
                style={{
                  borderRadius: "20px",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#ffffff",
                  color: "#495057",
                  fontSize: "13px",
                  cursor: "pointer",
                  transition: "all 0.2s ease"
                }}
                onClick={() => setShowAllTiles(!showAllTiles)}
              >
                <i
                  className={`fa ${
                    showAllTiles ? "fa-chevron-up" : "fa-chevron-down"
                  } mr-2 text-primary`}
                ></i>
                {showAllTiles ? "Show Less" : "Show More"}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Row>
        <Col md="6" sm="12" className="mb-3">
          <Card className="shadow h-100 customer-visits-card">
            <CardBody>
              <div className="customer-visits-header">
                <div className="d-flex align-items-center">
                  <span className="customer-visits-header-icon">
                    <i className="fa fa-line-chart"></i>
                  </span>
                  <h4 className="mb-0 font-weight-bold">Customer Visits</h4>
                </div>
              </div>
              <div className="mixed-chart">
                {customerCart.length > 0 && (
                  <Chart
                    options={{
                      chart: {
                        id: "basic-bar",
                      },
                      xaxis: {
                        categories: customerCart[0].xaxis,
                      },
                    }}
                    series={[
                      {
                        name: "Customer Visits",
                        data:
                          customerCart.find((item) => item.visits)?.visits ??
                          customerCart[1]?.visits ??
                          [],
                      },
                      {
                        name: "Exhibition",
                        data:
                          customerCart.find((item) => item.exhibition)
                            ?.exhibition ??
                          customerCart[2]?.exhibition ??
                          [],
                      },
                      {
                        name: "E-Store",
                        data:
                          customerCart.find((item) => item.estore)?.estore ??
                          customerCart[3]?.estore ??
                          [],
                      },
                      {
                        name: "Retailers",
                        data:
                          customerCart.find(
                            (item) =>
                              item.retailer ||
                              item.retailers ||
                              item.retailer_visits
                          )?.retailer ??
                          customerCart.find((item) => item.retailers)
                            ?.retailers ??
                          customerCart.find((item) => item.retailer_visits)
                            ?.retailer_visits ??
                          customerCart[4]?.retailer ??
                          customerCart[4]?.retailers ??
                          (customerCart[0]?.xaxis
                            ? customerCart[0].xaxis.map(() => 0)
                            : []),
                      },
                    ]}
                    type="line"
                    width="100%"
                  />
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col sm="12" md="6" className="mb-3">
          <Card className="shadow h-100 recent-activity-card">
            <CardBody>
              <div className="recent-activity-header">
                <div className="d-flex align-items-center">
                  <span className="recent-activity-header-icon">
                    <i className="fa fa-history"></i>
                  </span>
                  <h4 className="mb-0 font-weight-bold">Recent Activity</h4>
                </div>
              </div>
              <div className="recentTableHeight table-responsive">
                {/* {alert(JSON.stringify(recentActivitys))} */}
                <Table>
                  <tbody>
                    {recentActivitys.length > 0 ? (
                      recentActivitys.map((row, i) => (

                        <tr>
                          <th scope="row">
                            <span className="recent_customer">
                              {row.customer_type.substr(0, 1).toUpperCase()}
                            </span>
                            <span>
                              {row.full_name == null ? "Member" : row.full_name}
                            </span>
                            <span>
                              (
                              {row.type == "Get Voucher"
                                ? "Get " + row.details
                                : row.type == "Get Voucher"
                                  ? "Redeem " + row.details
                                  : row.type == "visit"
                                    ? row.customer_type.toUpperCase()
                                    : row.type.toUpperCase()
                              }
                              )
                            </span>
                            <span
                              className={
                                row.type == "New Customer"
                                  ? "text-success"
                                  : "text-warning"
                              }
                            >
                              {row.mobile}
                            </span>
                            {row.dob == "true" ? (
                              <i className="fa fa-birthday-cake fa-lg text-red m-2"></i>
                            ) : (
                              ""
                            )}
                            {row.doa == "true" ? (
                              <i className="fa fa-birthday-cake fa-lg text-red m-2"></i>
                            ) : (
                              ""
                            )}
                            {row.sp_bdy == "true" ? (
                              <i className="fa fa-birthday-cake fa-lg text-red m-2"></i>
                            ) : (
                              ""
                            )}
                            {row.trial == "true" ? (
                              <i className=" m-2">{trialSVG()}</i>
                            ) : (
                              ""
                            )}
                            {row.vcall == "true" ? (
                              <i className="fa fa-video fa-lg  m-2"></i>
                            ) : (
                              ""
                            )}
                            {row.wish == "true" ? (
                              <i className="fa fa-heart fa-lg text-red  m-2"></i>
                            ) : (
                              ""
                            )}
                            {row.missCall == "true" ? (
                              <i className="m-2">{misscallSVG()}</i>
                            ) : (
                              ""
                            )}
                            {row.type == "Service" ? (
                              <ConstructionOutlinedIcon style={{ color: "red" }} />

                            ) : (
                              ""
                            )}
                            {row.type == "Upload" ? (
                              <UploadIcon style={{ color: "green" }} />

                            ) : (
                              ""
                            )}
                            {row.type == "Profile" ? (
                              <PersonIcon style={{ color: "green" }} />

                            ) : (
                              ""
                            )}
                            {row.type == "Sale" ? (
                              <LocalMallSharpIcon className="text-success" />

                            ) : (
                              ""
                            )}



                            <span
                              style={{ fontSize: 12 }}
                              className="float-right text-muted"
                            >
                              {/* {console.log((row.datetime).split("T")[0])} */}
                              {moment(row.datetime.split("T")[0]).format(
                                "DD/MM/YYYY"
                              )}{" "}
                              {row.time}
                              {/* {console.log(row.datetime)} */}
                            </span>
                          </th>
                        </tr>
                      ))
                    ) : (
                      <td className="text-center color-red">No Data</td>
                    )}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col md="6" sm="12" className="mb-0">
          <Card className="shadow product-category-overview-card">
            <CardBody>
              <div className="product-category-overview-header">
                <div className="d-flex align-items-center">
                  <span className="product-category-overview-icon">
                    <i className="fa fa-pie-chart"></i>
                  </span>
                  <h4 className="mb-0 font-weight-bold">
                    Product Category Overview
                  </h4>
                </div>
              </div>

              <div className="product-category-chart-row">
                <div className="product-category-donut">
                  <Chart
                    options={productCategoryChartOptions}
                    series={productCategoryRows.map((row) => row.value)}
                    type="donut"
                    width="100%"
                  />
                </div>
              </div>

              <div className="product-category-table-wrap">
                <table className="table mb-0 product-category-table">
                  <thead>
                    <tr>
                      <th scope="col">Category Name</th>
                      <th scope="col"># Count</th>
                      <th scope="col">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productCategoryRows.map((row, index) => (
                      <tr key={`${row.label}-${index}`}>
                        <td className="font-weight-bold">
                          <span
                            className="product-category-dot mr-3"
                            style={{ backgroundColor: row.color }}
                          ></span>
                          {row.label}
                        </td>
                        <td className="font-weight-bold">{row.value}</td>
                        <td className="font-weight-bold">
                          {totalProductCategoryCount
                            ? ((row.value / totalProductCategoryCount) * 100).toFixed(1)
                            : "0.0"}
                          %
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </CardBody>
          </Card>
          <Card className="shadow product-grid-card">
            <CardBody>
              <div className="product-grid-header">
                <div className="d-flex align-items-center">
                  <span className="product-grid-header-icon">
                    <i className="fa fa-th-large"></i>
                  </span>
                  <h4 className="mb-0 font-weight-bold">Product Grid</h4>
                </div>

                <span ref={StockDivRef} className="product-grid-count">
                  {`${productHistory?.[0]?.product_count || 0} (${productHistory?.[0]?.total_balance || 0}) Items`}
                </span>
              </div>

              <div className={classes.root}>
                {(productHistory?.[0]?.categorys || []).map((cat, index) => (
                  <div key={index} className="border p-2 mb-2">
                    <div
                      className="d-flex justify-content-between"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setOpenCategory(
                          openCategory === index ? null : index
                        )
                      }
                    >
                      <strong>{cat.category_name}</strong>
                      <span>
                        {`${cat.product_count}(${cat.balance_qty}) Items`}
                      </span>
                    </div>

                    {openCategory === index &&
                      cat.innerTable?.map((sub, i) => (
                        <div
                          key={i}
                          className="d-flex justify-content-between pl-4 pt-2"
                        >
                          <span>{sub.subcategory_name}</span>
                          <span>
                            {sub.product_count} ({sub.balance_qty})
                          </span>
                        </div>
                      ))}
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col md="6">

          <Card className="shadow links-figures-card">
            <CardBody>
              <div className="links-figures-header">
                <span className="links-figures-header-icon">
                  <i className="fa fa-link"></i>
                </span>
                <div>
                  <h4 className="mb-1 font-weight-bold">Links & Figures</h4>
                  <p className="mb-0">
                    Quick access to important actions and resources.
                  </p>
                </div>
              </div>
              <Row className="links-figures-grid">
                {links.map((item, index) => {
                  const url = `${WEB_BASE_URL}${item.path}?t=${branchEncryptID}`;
                  return (
                    <Col sm="6" className="mb-3" key={index}>
                      <div className="links-figures-tile">
                        <button
                          type="button"
                          className={`links-figures-icon links-figures-icon-${item.tone}`}
                          onClick={() =>
                            window.open(url, "_blank", "noopener,noreferrer")
                          }
                        >
                          <i className={`fa ${item.icon}`}></i>
                        </button>
                        <button
                          type="button"
                          className="links-figures-content"
                          onClick={() =>
                            window.open(url, "_blank", "noopener,noreferrer")
                          }
                        >
                          <span className="links-figures-title">
                            {item.label}
                          </span>
                          <span className="links-figures-description">
                            {item.description}
                          </span>
                        </button>
                        <CopyToClipboard
                          text={url}
                          onCopy={() => {
                            setCopiedIndex(index);
                            setTimeout(() => setCopiedIndex(null), 2000);
                          }}
                        >
                          <button
                            type="button"
                            className={`links-figures-copy ${copiedIndex === index ? "copied" : ""
                              }`}
                            title="Copy link"
                          >
                            <i className="fa fa-copy"></i>
                          </button>
                        </CopyToClipboard>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </CardBody>
          </Card>

          <Row>
            <Col sm="6">
              <Card className="shadow dashboard-summary-card message-summary-card">
                <CardBody>
                  <div className="dashboard-summary-header">
                    <div className="d-flex align-items-center">
                      <span className="dashboard-summary-icon message-icon">
                        <i className="fa fa-comments-o"></i>
                      </span>
                      <h4 className="mb-0 font-weight-bold">
                        Message Summary
                      </h4>
                    </div>
                  </div>
                  <div className="dashboard-summary-metrics">
                    <div>
                      <strong className="message-color">{countWht}</strong>
                      <span>Today</span>
                    </div>
                    <div className="dashboard-summary-divider"></div>
                    <div>
                      <strong className="message-color">{whtAppCredit}</strong>
                      <span>Total Limit</span>
                    </div>
                  </div>
                  <div className="message-progress-panel">
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="font-weight-bold">Progress</span>
                      <span className="font-weight-bold message-color">
                        {messageProgress.toFixed(0)}%
                      </span>
                    </div>
                    <div className="message-progress-track">
                      <span style={{ width: `${messageProgress}%` }}></span>
                    </div>
                    <p className="mb-0 text-center">
                      {messagesRemaining} messages remaining
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col sm="6">
              <Card
                className="shadow dashboard-summary-card feedback-summary-card"
                onClick={() => {
                  toggleFeedback();
                  browse_feedbacks();
                }}
              >
                <CardBody>
                  <div className="dashboard-summary-header">
                    <div className="d-flex align-items-center">
                      <span className="dashboard-summary-icon feedback-icon">
                        <i className="fa fa-star-o"></i>
                      </span>
                      <h4 className="mb-0 font-weight-bold">
                        Customer Feedback
                      </h4>
                    </div>
                  </div>
                  <div className="dashboard-summary-metrics">
                    <div>
                      <strong className="feedback-color">{figures.feedbacks}</strong>
                      <span>Feedback</span>
                    </div>
                  </div>
                  <div className="feedback-status-panel">
                    <i className="fa fa-smile-o"></i>
                    <p className="mb-0">
                      {figures.feedbacks === 0
                        ? "Great to have feedback."
                        : "Great! You have " + figures.feedbacks + " feedback."}
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row></Row>

      <Col
        sm="6"
        className={
          "shadow bday_table " +
          (divBirthdayAndAnniversary
            ? "BA-Notification-Active"
            : "BA-Notification-Deactive")
        }
      >
        <Row>
          <Col>
            <h4>Birthday and Anniversary</h4>
          </Col>
          <Col>
            <i
              onClick={toggleDivBirthdayAndAnniversary}
              className="fa fa-close pull-right pointerShow"
            ></i>
          </Col>
        </Row>
        <Row>
          {DownloadReady ? (
            <a
              href={DownloadLink}
              className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 mx-3"
              download="customers_data.csv"
              target="_blank"
            >
              <i className="flaticon2-download"></i> Click Here to Download
            </a>
          ) : (
            <span
              onClick={() => {
                export_arrayBA();
              }}
              className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 mx-3"
            >
              <CiExport />
              Export
            </span>
          )}
          <span
            onClick={() =>
              generatePDF(getTargetElementBA, {
                filename: `Exported_data_${moment(
                  dashboardShowDate.startDate
                ).format("DD-MM-YYYY")}-${moment(
                  dashboardShowDate.endDate
                ).format("DD-MM-YYYY")}.pdf`,
                page: {
                  margin: Margin.SMALL,
                  orientation: "landscape",
                  format: "A4",
                },
              })
            }
            className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 mx-3"
          >
            <i className="flaticon2-download"></i> Download PDF
          </span>
        </Row>
        <div className="table-responsive mt-1" id="data_list_tableBA">
          <Table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Category</th>
                <th>Date</th>
                <th>Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {dobANDdoa.length > 0 ? (
                dobANDdoa.map((row, i) => (
                  <tr>
                    <th scope="row">{i + 1}</th>
                    <td>{row.full_name}</td>
                    <td>{row.mobile}</td>
                    <td>{row.category_name}</td>
                    <td>{moment(row.occasion_date).format("DD/MM/yyyy")}</td>
                    <td>
                      {row.dob === "true" && <b>Birthday</b>}{" "}
                      {row.doa === "true" && <b>Anniversary</b>}{" "}
                      {row.sp_day === "true" && <b>Spouse's Birthday</b>}
                    </td>

                    <td>
                      <a
                        href={
                          "http://api.whatsapp.com/send?phone=+91" + row.mobile
                        }
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 48 48"
                          width="28px"
                          height="28px"
                        >
                          <path
                            fill="#fff"
                            d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
                          />
                          <path
                            fill="#fff"
                            d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
                          />
                          <path
                            fill="#cfd8dc"
                            d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
                          />
                          <path
                            fill="#40c351"
                            d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
                          />
                          <path
                            fill="#fff"
                            fill-rule="evenodd"
                            d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <td colSpan="4" className="text-center">
                  No Data
                </td>
              )}
            </tbody>
          </Table>
        </div>
      </Col>

      <Row>

      </Row>

      {/* Total Visits Modal */}
      <Modal
        isOpen={modalTotalCustomer}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={`${className || ""} dashboard-table-modal`}
      >
        <ModalHeader>
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
            <div className="d-flex align-items-center">
              <span className="font-weight-bold mr-3">Customers</span>
              <FormGroup className="mb-0">
                <select
                  className="form-control h-auto py-2 px-6"
                  onChange={(e) => {
                    setFiltertype(e.target.value);
                  }}
                  name="customer_type"
                  value={filter_type}
                  required
                >
                  <option value="">All</option>
                  <option value="general session">E-store</option>
                  <option value="exhibition">Exhibition</option>
                  <option value="visit">Visit</option>
                  <option value="retailer">Retailers</option>
                </select>
              </FormGroup>
            </div>

            <div className="d-flex align-items-center flex-wrap">
              {DownloadReady ? (
                <a
                  href={DownloadLink}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                  download="customers_data.csv"
                  target="_blank"
                >
                  <i className="flaticon2-download"></i> Click Here to Download
                </a>
              ) : (
                <span
                  onClick={() => {
                    export_array_visit();
                  }}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                >
                  <CiExport className="mr-2" size={18} strokeWidth={1.4} />
                  Export
                </span>
              )}
              <span
                onClick={() =>
                  generatePDF(getTargettotalElement, {
                    filename: `Exported_data_${moment(
                      dashboardShowDate.startDate
                    ).format("DD-MM-YYYY")}-${moment(
                      dashboardShowDate.endDate
                    ).format("DD-MM-YYYY")}.pdf`,
                    page: {
                      margin: Margin.SMALL,
                      orientation: "landscape",
                      format: "A4",
                    },
                  })
                }
                className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
              >
                <i className="flaticon2-download"></i> Download PDF
              </span>
              <div className="ml-3">
                <Extra custInfo={totalCustomers} className={className} />
              </div>
              <i
                className="fa fa-close pointerShow ml-3"
                onClick={() => {
                  toggleTotalCustomer();
                }}
              ></i>
            </div>
          </div>
        </ModalHeader>

        <ModalBody
          className="table-responsive"
          style={{ maxHeight: "450px", overflow: "hidden" }}
        >
          <div className="table-responsive" id="data_list_visit_table">
            {/* end */}

            <ReactDatatable
              config={config}
              records={totalCustomers}
              columns={columns_TotalCustomer}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* Total New Customer Modal */}
      <Modal
        isOpen={modalTotalCustomerNew}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
        style={{ width: "100%" }}
      >
        <ModalHeader>
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
            <div className="d-flex align-items-center">
              <span className="font-weight-bold mr-3">New Customers</span>
              <FormGroup className="mb-0">
                <select
                  className="form-control h-auto py-2 px-6"
                  onChange={(e) => {
                    setFilterTypeNew(e.target.value);
                  }}
                  name="customer_type_new"
                  value={filter_type_new}
                  required
                >
                  <option value="">All</option>
                  <option value="general session">E-store</option>
                  <option value="exhibition">Exhibition</option>
                  <option value="visit">Visit</option>
                  <option value="retailer">Retailers</option>
                </select>
              </FormGroup>
            </div>

            <div className="d-flex align-items-center flex-wrap">
              {DownloadReady ? (
                <a
                  href={DownloadLink}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                  download="customers_data.csv"
                  target="_blank"
                >
                  <i className="flaticon2-download"></i> Click Here to Download
                </a>
              ) : (
                <span
                  onClick={() => {
                    export_array_visit1();
                  }}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                >
                  <CiExport className="mr-2" size={18} strokeWidth={1.4} />
                  Export
                </span>
              )}
              <span
                onClick={() =>
                  generatePDF(getTargettotalElement1, {
                    filename: `Exported_data_${moment(
                      dashboardShowDate.startDate
                    ).format("DD-MM-YYYY")}-${moment(
                      dashboardShowDate.endDate
                    ).format("DD-MM-YYYY")}.pdf`,
                    page: {
                      margin: Margin.SMALL,
                      orientation: "landscape",
                      format: "A4",
                    },
                  })
                }
                className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
              >
                <i className="flaticon2-download"></i> Download PDF
              </span>
              <div className="ml-3">
                <Whatsapp custInfo={newCustomers} className={className} />
              </div>
              <i
                className="fa fa-close pointerShow ml-3"
                onClick={() => {
                  toggleTotalCustomerNew();
                }}
              ></i>
            </div>
          </div>
        </ModalHeader>
        <ModalBody
          className="dashboard-table-modal-body"
          style={{ overflow: "hidden" }}
        >
          <div className="table-responsive" id="data_list_visit_table1">
            <ReactDatatable
              config={config}
              records={newCustomers}
              columns={columns_TotalCustomer_New}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* Total Cart */}
      <Modal
        isOpen={modalCartDetails}
        zIndex="99999"
        size="xl"
        // fullscreen={true}
        backdrop="static"
        centered="true"
        className={`${className || ""} dashboard-table-modal`}
        style={{ width: "100%" }}

      >
        <ModalHeader>
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
            <span className="font-weight-bold mr-3">Cart Details</span>

            <div className="d-flex align-items-center flex-wrap">
              {DownloadReady ? (
                <a
                  href={DownloadLink}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                  download="customers_data.csv"
                  target="_blank"
                >
                  <i className="flaticon2-download"></i> Click Here to Download
                </a>
              ) : (
                <span
                  onClick={() => {
                    export_array();
                  }}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                >
                  <CiExport className="mr-2" size={18} strokeWidth={1.4} />
                  Export
                </span>
              )}
              <span
                onClick={downloadCartTablePDF}
                className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
              >
                <i className="flaticon2-download"></i> Download PDF
              </span>
              <button
                className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                onClick={() => {
                  toggleCartDetails();
                  toggleCartDetailsNew();
                }}
              >
                Detailed View
              </button>
              <Button
                className="ml-3"
                style={{
                  ...buttonStyle,
                  right: 0,
                  minWidth: "48px",
                  padding: "6px 12px",
                }}
                onClick={() => {
                  get_ApoointmentData();
                }}
              >
                <CircleNotificationsIcon style={{ fontSize: 28 }} />
                <span style={{ ...countStyle, top: "-10px", right: "-8px" }}>
                  {count_ap}
                </span>
              </Button>
              <div className="ml-3">
                <Whatsapp custInfo={productsInCart} className={className} />
              </div>
              <i
                className="fa fa-close pointerShow ml-3"
                onClick={() => {
                  toggleCartDetails();
                  setDownloadReady(false);
                }}
              ></i>
            </div>
          </div>
        </ModalHeader>
        <ModalBody
          className="dashboard-table-modal-body table-responsive total-cart-modal-body"
          style={{ overflow: "hidden" }}
        >
          <div className="table-responsive" id="cart_data_list_table">
            <div className="row total-cart-filter-row">
              {/* <div className="col-md-5">
                <label>
                  <b>
                    Date Range:{" "}
                    {moment(dashboardShowDate.startDate).format("DD/MM/YYYY")} -{" "}
                    {moment(dashboardShowDate.endDate).format("DD/MM/YYYY")}{" "}
                  </b>
                </label>
              </div> */}

              <div className="col-md-2">
                <label>
                  {" "}
                  <b>Product Category</b>
                </label>
                <select
                  className="form-control "
                  onChange={(e) => {
                    setFilteredCartId(e.target.value);
                  }}
                >
                  <option key={-1} value={0}>
                    All
                  </option>
                  {Object.entries(SubCategoryList).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <label>
                  {" "}
                  <b>Interest</b>
                </label>
                <select
                  className="form-control "
                  onChange={(e) => {
                    // alert(e.target.value)
                    setFilteredCartInterest(e.target.value);
                  }}
                >
                  <option key={-1} value={`all`}>
                    All
                  </option>
                  <option key={1} value="Yes">
                    Yes
                  </option>
                  <option key={2} value="Requirement">
                    Requirement
                  </option>
                  <option key={3} value="Follow Up">
                    Follow Up
                  </option>
                </select>
              </div>

              {/* ----------setFilteredCartUpdatedInterest */}

              {FilteredCartInterest === "Requirement" ||
                FilteredCartInterest === "Follow Up" ? (
                <div className="col-md-2">
                  <label>
                    <b>Updated Interest</b>
                  </label>
                  <select
                    className="form-control "
                    onChange={(e) => {
                      // alert(e.target.value)
                      setFilteredCartUpdatedInterest(e.target.value);
                    }}
                  >
                    <option key={-1} value={`all`}>
                      All
                    </option>
                    <option key={1} value="Yes">
                      Yes
                    </option>
                    <option key={2} value="Requirement">
                      Requirement
                    </option>
                    <option key={3} value="Follow Up">
                      Follow Up
                    </option>
                  </select>
                </div>
              ) : (
                ""
              )}
            </div>

            <ReactDatatable
              ref={ref}
              config={config}
              records={productsInCart}
              columns={columns_Cart}
            />
          </div>
        </ModalBody>
      </Modal>


      {/* Sale Details */}
      <Modal
        isOpen={modalSaleDetails}
        zIndex="99999"
        size="xl"
        // fullscreen={true}
        backdrop="static"
        centered="true"
        className={`${className || ""} dashboard-table-modal`}
        style={{ width: "100%" }}
      >
        <ModalHeader>
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
            <span className="font-weight-bold mr-3">Sales Details</span>

            <div className="d-flex align-items-center flex-wrap">
              {DownloadReady ? (
                <a
                  href={DownloadLink}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                  download="customers_data.csv"
                  target="_blank"
                >
                  <i className="flaticon2-download"></i> Click Here to Download
                </a>
              ) : (
                <span
                  onClick={() => {
                    export_array_sales();
                  }}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                >
                  <CiExport className="mr-2" size={18} strokeWidth={1.4} />
                  Export
                </span>
              )}
              <span
                onClick={downloadSalesTablePDF}
                className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
              >
                <i className="flaticon2-download"></i> Download PDF
              </span>
              <button
                className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                onClick={() => {
                  toggleShowSaleDetails();
                }}
              >
                Detailed View
              </button>
              <Button
                className="ml-3"
                style={{
                  ...buttonStyle,
                  right: 0,
                  minWidth: "48px",
                  padding: "6px 12px",
                }}
                onClick={() => {
                  get_TodaysSalesData();
                }}
              >
                <CircleNotificationsIcon style={{ fontSize: 28 }} />
                <span style={{ ...countStyle, top: "-10px", right: "-8px" }}>
                  {countPro_sale}
                </span>
              </Button>
              <div className="ml-3">
                <Whatsapp custInfo={grid} className={className} />
              </div>
              <i
                className="fa fa-close pointerShow ml-3"
                onClick={() => {
                  toggleSaleDetails();
                  setDownloadReady(false);
                }}
              ></i>
            </div>
          </div>
        </ModalHeader>
        <ModalBody
          className="dashboard-table-modal-body table-responsive sales-table-modal-body"
          style={{ overflow: "hidden" }}
        >
          <div className="table-responsive" id="sales_data_list_table">
            <style>{`
              #sales_data_list_table .table_filter {
                display: none !important;
              }
            `}</style>

            <div className="row align-items-center mb-3">
              <div className="col-md-3">
                <div
                  className="p-3 rounded text-white text-center"
                  style={{
                    background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <div style={{ fontSize: "12px", opacity: 0.85, fontWeight: "500" }}>
                    Total Sales
                  </div>
                  <div style={{ fontSize: "18px", fontWeight: "700" }}>
                    ₹{salesSummary.totalSales.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div
                  className="p-3 rounded text-white text-center"
                  style={{
                    background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <div style={{ fontSize: "12px", opacity: 0.85, fontWeight: "500" }}>
                    Total Discount
                  </div>
                  <div style={{ fontSize: "18px", fontWeight: "700" }}>
                    ₹{salesSummary.totalDiscount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div
                  className="p-3 rounded text-white text-center"
                  style={{
                    background: "linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <div style={{ fontSize: "12px", opacity: 0.85, fontWeight: "500" }}>
                    Total Tax
                  </div>
                  <div style={{ fontSize: "18px", fontWeight: "700" }}>
                    ₹{salesSummary.totalTax.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div
                  className="p-3 rounded text-center d-flex flex-column justify-content-center"
                  style={{
                    background: "#ffffff",
                    minHeight: "75px",
                  }}
                >
                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      type="text"
                      className="form-control"
                      style={{
                        paddingRight: "36px",
                        height: "38px",
                        fontSize: "13px",
                        borderRadius: "6px",
                      }}
                      placeholder="Search in records..."
                      value={salesFilterValue}
                      onChange={(e) => setSalesFilterValue(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn p-0"
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                        color: "#6c757d",
                        cursor: salesFilterValue ? "pointer" : "default",
                      }}
                      onClick={() => {
                        if (salesFilterValue) setSalesFilterValue("");
                      }}
                    >
                      <i className={`fa ${salesFilterValue ? "fa-times" : "fa-search"}`}></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <ReactDatatable
              key="sales-datatable-no-filter"
              ref={ref}
              config={{
                page_size: 10,
                length_menu: [10, 5, 20, 50],
                show_filter: false,
              }}
              records={filteredSalesData}
              columns={columns_Sales}
            />
          </div>
        </ModalBody>
      </Modal>



      {/* ----------endd------------ */}
      {/* Stocks*/}
      <Modal
        isOpen={modalStock}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          Stocks Details
          <i
            className="fa fa-close pull-right pointerShow"
            onClick={() => {
              browse_stocks();
              toggleStock();
            }}
          ></i>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "calc(100vh - 260px)", overflow: "hidden" }}>
          <ReactDatatable
            config={config}
            records={browseStock}
            columns={columns_Stocks}
          />
        </ModalBody>
      </Modal>

      {/* Feedbacks*/}
      <Modal
        isOpen={modalFeedback}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          Feedbacks
          <i
            className="fa fa-close pull-right pointerShow"
            onClick={() => {
              toggleFeedback();
            }}
          ></i>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "400px", overflow: "hidden" }}>
          <ReactDatatable
            config={config}
            records={browseStock}
            columns={columns_Feedback}
          />
        </ModalBody>
      </Modal>

      {/* Voucher Details */}
      <Modal
        isOpen={modalVoucherDetails}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          <Row>
            <Col sm="4">Voucher Details</Col>

            <Col sm="4">
              <FormGroup>
                <select
                  className="form-control h-auto py-2 px-6"
                  onChange={(e) => {
                    setFilterTypeVoucher(e.target.value);
                  }}
                  name="customer_type_voucher"
                  value={filter_type_voucher}
                  required
                >
                  <option value="">All</option>
                  <option value="Get">Get Voucher</option>
                  <option value="Redeem">Redeem Voucher</option>
                </select>
              </FormGroup>
            </Col>
            <Col sm="4">
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={() => {
                  toggleModalVoucherDetails();
                }}
              ></i>
            </Col>
          </Row>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "400px", overflow: "hidden" }}>
          <ReactDatatable
            config={config}
            records={activeVouchers}
            columns={columns_Voucher}
          />
        </ModalBody>
      </Modal>

      {/* Not Visiting Customers */}
      <Modal
        isOpen={modalNotVisitingCustomer}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader className="py-2 px-4 border-bottom">
          <div
            className="d-flex align-items-center justify-content-between w-100 flex-wrap"
            style={{ gap: "10px" }}
          >
            <div
              className="d-flex align-items-center flex-wrap"
              style={{ gap: "12px" }}
            >
              <h5 className="modal-title font-weight-bold mb-0 text-dark">
                No Response
              </h5>

              {/* Toggle Switch */}
              <div
                className="d-inline-flex align-items-center p-1 rounded"
                style={{
                  backgroundColor: "#f1f5f9",
                  border: "1px solid #cbd5e1",
                }}
              >
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={() => setNotVisitingActiveTab("not_visiting")}
                  style={{
                    backgroundColor:
                      notVisitingActiveTab === "not_visiting"
                        ? "#1e293b"
                        : "transparent",
                    color:
                      notVisitingActiveTab === "not_visiting"
                        ? "#ffffff"
                        : "#64748b",
                    fontWeight: "700",
                    fontSize: "12px",
                    borderRadius: "5px",
                    padding: "4px 12px",
                    border: "none",
                    transition: "all 0.15s ease",
                  }}
                >
                  No Response ({notVisitingCustomers.length})
                </button>
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={() => setNotVisitingActiveTab("no_sale")}
                  style={{
                    backgroundColor:
                      notVisitingActiveTab === "no_sale"
                        ? "#1e293b"
                        : "transparent",
                    color:
                      notVisitingActiveTab === "no_sale"
                        ? "#ffffff"
                        : "#64748b",
                    fontWeight: "700",
                    fontSize: "12px",
                    borderRadius: "5px",
                    padding: "4px 12px",
                    border: "none",
                    transition: "all 0.15s ease",
                  }}
                >
                  No Sale Report ({customerNoSaleList.length})
                </button>
              </div>
            </div>

            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <span
                className="btn btn-sm btn-outline-theme font-weight-bold py-1 px-3"
                onClick={() => {
                  toggleNotVisitingCustomerDataRange();
                }}
                style={{ cursor: "pointer", fontSize: "12px" }}
              >
                <i className="fa fa-calendar mr-1"></i>
                {moment(showDate.startDate).format("DD/MM/YYYY")} -{" "}
                {moment(showDate.endDate).format("DD/MM/YYYY")}
              </span>
              <button
                type="button"
                className="close ml-2"
                onClick={() => {
                  toggleNotVisitingCustomer();
                }}
                style={{ fontSize: "22px", outline: "none", cursor: "pointer" }}
              >
                &times;
              </button>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="p-3" style={{ maxHeight: "550px", overflow: "hidden" }}>
          {/* Action & Filter Toolbar Above Table */}
          <div
            className="d-flex align-items-center justify-content-between flex-wrap mb-3 px-1"
            style={{ gap: "10px" }}
          >
            <div
              className="d-flex align-items-center flex-wrap"
              style={{ gap: "10px" }}
            >
              {notVisitingActiveTab === "not_visiting" ? (
                <div className="d-flex align-items-center">
                  <span
                    className="text-muted mr-2"
                    style={{ fontSize: "12px", fontWeight: "600" }}
                  >
                    Filter:
                  </span>
                  <select
                    className="form-control form-control-sm py-1 px-2"
                    style={{
                      width: "130px",
                      height: "32px",
                      fontSize: "12px",
                      borderRadius: "6px",
                    }}
                    onChange={(e) => {
                      setFilterTypeNotVisit(e.target.value);
                    }}
                    name="customer_type_not_visiting"
                    value={filter_type_no_visit}
                  >
                    <option value="">All Types</option>
                    <option value="general session">E-store</option>
                    <option value="exhibition">Exhibition</option>
                    <option value="visit">Visit</option>
                    <option value="retailer">Retailers</option>
                  </select>
                </div>
              ) : (
                <span
                  className="badge badge-light py-2 px-3 text-secondary"
                  style={{ fontSize: "12px", fontWeight: "600" }}
                >
                  <i className="fa fa-info-circle mr-1 text-primary"></i> Customers
                  with no sales in selected period
                </span>
              )}
            </div>

            <div
              className="d-flex align-items-center flex-wrap"
              style={{ gap: "8px" }}
            >
              {DownloadReady ? (
                <a
                  href={DownloadLink}
                  className="btn btn-sm btn-outline-success font-weight-bold py-1 px-3"
                  download="customers_data.csv"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    fontSize: "12px",
                    height: "32px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <i className="flaticon2-download mr-1"></i> Download CSV
                </a>
              ) : (
                <button
                  type="button"
                  onClick={() => {
                    export_array_visit2();
                  }}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-1 px-3"
                  style={{
                    fontSize: "12px",
                    height: "32px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <CiExport className="mr-1" size={16} strokeWidth={1.4} />
                  Export CSV
                </button>
              )}
              <button
                type="button"
                onClick={() =>
                  generatePDF(getTargettotalElement2, {
                    filename: `Exported_data_${moment(
                      dashboardShowDate.startDate
                    ).format("DD-MM-YYYY")}-${moment(
                      dashboardShowDate.endDate
                    ).format("DD-MM-YYYY")}.pdf`,
                    page: {
                      margin: Margin.SMALL,
                      orientation: "landscape",
                      format: "A4",
                    },
                  })
                }
                className="btn btn-sm btn-outline-theme font-weight-bold py-1 px-3"
                style={{
                  fontSize: "12px",
                  height: "32px",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <i className="flaticon2-download mr-1"></i> PDF
              </button>
              <Whatsapp
                custInfo={
                  notVisitingActiveTab === "no_sale"
                    ? customerNoSaleList
                    : notVisitingCustomers
                }
                className={className}
              />
            </div>
          </div>

          <div className="table-responsive" id="data_list_visit_table2">
            <ReactDatatable
              config={config}
              records={
                notVisitingActiveTab === "no_sale"
                  ? customerNoSaleList
                  : notVisitingCustomers
              }
              columns={
                notVisitingActiveTab === "no_sale"
                  ? columns_CustomerNoSaleReport
                  : columns_NonVistiTotalCustomer
              }
            />
          </div>
        </ModalBody>
      </Modal>
      {/* Not Visiting Customers DateRange */}
      <Modal
        isOpen={modalNotVisitingCustomerDataRange}
        zIndex="99999"
        size={"xl"}
        backdrop="static"
        centered="true"
        className={className + " text-center"}
      >
        <ModalHeader>
          Data Range{" "}
          <i
            className="fa fa-close pull-right pointerShow"
            onClick={() => {
              toggleNotVisitingCustomerDataRange();
            }}
          ></i>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "450px", overflow: "hidden" }}>
          <Row>
            <Col sm="12">
              <DateRangePicker
                onChange={(item) => {
                  var startDate =
                    item.selection.startDate.toLocaleDateString("en-US");
                  var endDate =
                    item.selection.endDate.toLocaleDateString("en-US");
                  setState([item.selection]);
                  setshowDate({
                    ...showDate,
                    startDate: startDate,
                    endDate: endDate,
                  });
                  notVisitngCustomerDateChange(startDate, endDate);
                }}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={2}
                ranges={state}
                direction="horizontal"
              />
            </Col>
            <Col sm="12" className="text-right">
              {" "}
              <span
                className="badge-success pointerShow"
                onClick={() => {
                  toggleNotVisitingCustomerDataRange();
                }}
              >
                Continue
              </span>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* Miss Call */}
      <Modal
        isOpen={modalMissCallRequest}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          <Row>
            <Col sm="4">Miss Call Request</Col>

            <Col sm="4">
              <FormGroup>
                <select
                  className="form-control h-auto py-2 px-6"
                  onChange={(e) => {
                    setFilterTypeMiss(e.target.value);
                  }}
                  name="customer_type_missCall"
                  value={filter_type_miss}
                  required
                >
                  <option value="">All</option>
                  <option value="request">Request</option>
                  <option value="accept">Accept</option>
                  <option value="done">Done</option>
                </select>
              </FormGroup>
            </Col>
            <Col sm="4">
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={() => {
                  toggleMissCallRequest();
                }}
              ></i>
            </Col>
          </Row>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "450px", overflow: "hidden" }}>
          <ReactDatatable
            config={config}
            records={missCallRequest}
            columns={columns_MissCall}
          />
        </ModalBody>
      </Modal>

      {/* Video Call */}
      <Modal
        isOpen={modalVideoCallRequest}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          <Row>
            <Col sm="4">Video Call Request</Col>

            <Col sm="4">
              <FormGroup>
                <select
                  className="form-control h-auto py-2 px-6"
                  onChange={(e) => {
                    setFilterTypeVCall(e.target.value);
                  }}
                  name="customer_type_vCall"
                  value={filter_type_vcall}
                  required
                >
                  <option value="">All</option>
                  <option value="request">Request</option>
                  <option value="accept">Accept</option>
                  <option value="done">Done</option>
                </select>
              </FormGroup>
            </Col>
            <Col sm="4">
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={() => {
                  toggleVideoCallRequest();
                }}
              ></i>
            </Col>
          </Row>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "450px", overflow: "hidden" }}>
          <ReactDatatable
            config={config}
            records={videoCallRequest}
            columns={columns_VCall}
          />
        </ModalBody>
      </Modal>

      {/* Video Call */}
      <Modal
        isOpen={modalVideoCallRequestDetails}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          Video Call Details
          <i
            className="fa fa-close pull-right pointerShow"
            onClick={() => {
              toggleVideoCallRequestDetails();
            }}
          ></i>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "450px", overflowY: "auto" }}>
          <Row>
            <Col sm="4">
              <FormGroup>
                <Label>Video Call Datetime</Label>
                <DateTimePicker
                  size="small"
                  inputVariant="outlined"
                  ampm={false}
                  disablePast
                  format="DD/MM/yyyy hh:mm a"
                  value={appointmentDate}
                  disabled={
                    updateVcall.status.toUpperCase() == "DONE" ? true : false
                  }
                  onChange={(e) => {
                    setUpdateVcall({
                      ...updateVcall,
                      accept_date: moment(e).format().split("T")[0],
                      accept_time: moment(e).format().split("T")[1],
                    });
                    appointmenthandleDateChange(e);
                  }}
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label>Status</Label>
                <select
                  className="form-control h-auto py-2 px-6"
                  onChange={(e) => {
                    if (e.target.value == "done") {
                      if (window.confirm("Are you sure want to Done")) {
                        setUpdateVcall({
                          ...updateVcall,
                          status: e.target.value,
                        });
                      } else {
                        e.preventDefault();
                        return false;
                      }
                    } else {
                      setUpdateVcall({
                        ...updateVcall,
                        status: e.target.value,
                      });
                    }
                  }}
                  name="vCallStatus"
                  value={updateVcall.status}
                  required
                  disabled={
                    updateVcall.status.toUpperCase() == "DONE" ? true : false
                  }
                >
                  <option value="">--Select--</option>
                  <option value="accept">Accept</option>
                  <option value="done">Done</option>
                  <option value="request">Request</option>
                </select>
              </FormGroup>
            </Col>
            <Col sm="4"></Col>
          </Row>

          <div className="chat-text-body">
            {vcallRemarks.length > 0 ? (
              vcallRemarks.map((row, i) => (
                <div className="chat-container chat-darker">
                  <p>{row.remarks}</p>
                  <span className="time-right">{row.date}</span>
                </div>
              ))
            ) : (
              <div className="container text-center">
                <h4>No Remarks</h4>
              </div>
            )}
          </div>
          <Row className="mt-4">
            <Col sm="10">
              <textarea
                required
                value={updateVcall.remarks}
                className="form-control h-auto py-2 px-6"
                name="remarks"
                onClick={() => {
                  setRemarksValidation(false);
                }}
                onChange={(e) =>
                  setUpdateVcall({ ...updateVcall, remarks: e.target.value })
                }
              />
              {remarksValidation ? (
                <Label className="text-danger">Remark can not be blank.</Label>
              ) : null}
            </Col>
            <Col sm="2">
              {remarksLoader ? (
                <Button className="btn btn-info mt-3" type="button">
                  Updating..
                </Button>
              ) : (
                <Button
                  className="btn btn-success mt-3"
                  type="button"
                  onClick={() => {
                    updateVcallEntry();
                  }}
                >
                  Enter
                </Button>
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* Miss Call */}
      <Modal
        isOpen={modalMissCallRequestDetails}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          Miss Call Details
          <i
            className="fa fa-close pull-right pointerShow"
            onClick={() => {
              toggleMissCallRequestDetails();
            }}
          ></i>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "450px", overflowY: "auto" }}>
          <Row>
            <Col sm="4">
              <FormGroup>
                <Label>Miss Call Datetime</Label>
                <DateTimePicker
                  size="small"
                  inputVariant="outlined"
                  ampm={false}
                  disablePast
                  format="DD/MM/yyyy hh:mm a"
                  disabled={
                    updateMiss.status.toUpperCase() == "DONE" ? true : false
                  }
                  value={appointmentDate}
                  onChange={(e) => {
                    setUpdateMiss({
                      ...updateMiss,
                      accept_date: moment(e).format().split("T")[0],
                      accept_time: moment(e).format().split("T")[1],
                    });
                    appointmenthandleDateChange(e);
                  }}
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label>Status</Label>
                <select
                  className="form-control h-auto py-2 px-6"
                  onChange={(e) => {
                    // console.log(updateMiss.status.toUpperCase());
                    // console.log(e.target.value.toUpperCase());
                    // debugger;
                    if (updateMiss.status.toUpperCase() == "DONE") {
                      e.preventDefault();
                      return false;
                    } else if (e.target.value.toUpperCase() == "DONE") {
                      if (window.confirm("Are you sure want to Done")) {
                        setUpdateMiss({
                          ...updateMiss,
                          status: e.target.value,
                        });
                      }
                    } else {
                      setUpdateMiss({ ...updateMiss, status: e.target.value });
                    }
                  }}
                  name="vCallStatus"
                  value={updateMiss.status}
                  required
                  disabled={
                    updateMiss.status.toUpperCase() == "DONE" ? true : false
                  }
                >
                  <option value="">--Select--</option>
                  <option value="accept">Accept</option>
                  <option value="done">Done</option>
                  <option value="request">Request</option>
                </select>
              </FormGroup>
            </Col>
            <Col sm="4">
              {/* <Label>Miss Call Datetime</Label> */}
              {/* {console.log(updateMiss)} */}
              <p>{updateMiss.datetime}</p>
            </Col>
          </Row>

          <div className="chat-text-body">
            {missCallRemarks.length > 0 ? (
              missCallRemarks.map((row, i) => (
                <div className="chat-container chat-darker">
                  <p>{row.remarks}</p>
                  <span className="time-right">{row.date}</span>
                </div>
              ))
            ) : (
              <div className="container text-center">
                <h4>No Remarks</h4>
              </div>
            )}
          </div>
          <Row className="mt-4">
            <Col sm="10">
              <textarea
                required
                value={updateMiss.remarks}
                className="form-control h-auto py-2 px-6"
                name="remarks"
                onClick={() => {
                  setRemarksMissValidation(false);
                }}
                onChange={(e) =>
                  setUpdateMiss({ ...updateMiss, remarks: e.target.value })
                }
              />
              {remarksValidation ? (
                <Label className="text-danger">Remark can not be blank.</Label>
              ) : null}
            </Col>
            <Col sm="2">
              {remarksMissLoader ? (
                <Button className="btn btn-info mt-3" type="button">
                  Updating..
                </Button>
              ) : (
                <Button
                  className="btn btn-success mt-3"
                  type="button"
                  onClick={() => {
                    updateMissEntry();
                  }}
                >
                  Enter
                </Button>
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* Video Call */}
      <Modal
        isOpen={modalCartRequestDetails}
        zIndex="99999"
        size="xl"
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          <Grid container display={"flex"}>
            <Grid item xs={5}>
              <Typography style={{ fontSize: "18px", fontWeight: "500" }}>
                Cart Details
              </Typography>
            </Grid>
            <Grid item xs={3}>
              {updateCart?.interest === "Yes" ? (
                <>
                  Yes
                  <img
                    style={{ height: "20px" }}
                    src="data:image/png;base64,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"
                  ></img>
                </>
              ) : updateCart?.interest === "Requirement" ? (
                <>
                  Requirement
                  <img
                    style={{ height: "20px" }}
                    src="data:image/png;base64,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"
                  ></img>
                </>
              ) : updateCart?.interest === "Follow Up" ? (
                <>
                  Follow Up
                  <img
                    style={{ height: "20px" }}
                    src="data:image/png;base64,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"
                  ></img>
                </>
              ) : null}
            </Grid>

            <Grid item xs={3}>
              {updateCart.date != "" && updateCart.date != null ? (
                <h6 style={{ padding: 0, marginTop: "5px", color: "#a38384" }}>
                  {moment(updateCart.date)
                    .format("DD/MM/yyyy HH:mm")
                    .toString()}
                </h6>
              ) : (
                " "
              )}
            </Grid>

            <Grid item xs={1}>
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={() => {
                  setCartImg(null);
                  toggleCartRequestDetails();
                }}
              ></i>
            </Grid>
          </Grid>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "450px", overflowY: "auto" }}>
          <Row>
            <Col sm="4">
              <FormGroup>
                <Label>Cart Datetime</Label>
                <DateTimePicker
                  size="small"
                  inputVariant="outlined"
                  ampm={false}
                  disablePast
                  format="DD/MM/yyyy hh:mm a"
                  value={updateCart.appointment_date}
                  disabled={
                    updateCart.status.toUpperCase() == "DONE" ? true : false
                  }
                  onChange={(e) => {
                    let ap_date = moment(e).format("YYYY-MM-DD HH:mm:ss");
                    setUpdateCart({
                      ...updateCart,
                      appointment_date: ap_date,
                      accept_date: moment(e).format().split("T")[0],
                      accept_time: moment(e).format().split("T")[1],
                    });
                    appointmenthandleDateChange(e);
                  }}
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label>Status</Label>
                <select
                  className="form-control h-auto py-2 px-6"
                  onChange={(e) => {
                    if (e.target.value == "done") {
                      if (window.confirm("Are you want to Done")) {
                        setUpdateCart({
                          ...updateCart,
                          status: e.target.value,
                        });
                      } else {
                        e.preventDefault();
                        return false;
                      }
                    } else {
                      setUpdateCart({ ...updateCart, status: e.target.value });
                    }
                  }}
                  name="cartStatus"
                  value={updateCart.status}
                  disabled={
                    updateCart.status.toUpperCase() === "DONE" ? true : false
                  }
                  required
                >
                  <option value="">--Select--</option>
                  <option value="accept">Accept</option>
                  <option value="done">Done</option>
                  <option value="request">Request</option>
                </select>
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label>Interest</Label>
                <select
                  className="form-control h-auto py-2 px-6"
                  onChange={(e) =>
                    setUpdateCart({
                      ...updateCart,
                      updated_interest: e.target.value,
                    })
                  }
                  name="cartInterest"
                  value={updateCart?.updated_interest}
                // required
                >
                  <option value="">--Select--</option>
                  <option value="Follow Up">Follow Up</option>
                  <option value="Requirement">Requirement</option>
                  <option value="Yes">Yes</option>
                </select>
              </FormGroup>
            </Col>
          </Row>
          <Grid container display={"flex"} gap={2}>
            <Grid
              item
              xs={6}
              display={"flex"}
              justifyContent="center"
              alignItems="center"
            >
              <Input
                className="mt-2 image-cart"
                id="cart_image"
                type="file"
                name="Choose Image"
                onChange={(e) => setPreviewImage(e)}
              />
            </Grid>
            <Grid item xs={5}>
              {cartImg ? (
                <img src={imgPrev} height={"150px"} width={"150px"} />
              ) : updateCart?.image ? (
                <img src={updateCart?.image} height={"150px"} width={"150px"} />
              ) : null}
            </Grid>
          </Grid>

          <Card
            style={{
              width: "55rem",
              height: "10rem",
              zIndex: "2",
              overflow: "auto",
              marginTop: "8px",
            }}
          >
            <CardHeader className="font-weight-bold">Remarks</CardHeader>
            <ListGroup flush>
              {cartRemarks.length > 0 && cartRemarks[0].remarks != "" ? (
                cartRemarks.map((row, i) =>
                  row.remarks.length > 0 ? (
                    <ListGroupItem>
                      {row.remarks}{" "}
                      <span className="time-right">{row.date}</span>
                    </ListGroupItem>
                  ) : (
                    ""
                  )
                )
              ) : (
                <ListGroupItem style={{ color: "red" }}>
                  No Remarks
                </ListGroupItem>
              )}
            </ListGroup>
          </Card>

          <Row className="mt-4">
            <Col sm="10">
              <textarea
                value={updateCart.remarks}
                className="form-control h-auto py-2 px-6"
                name="remarks"
                onClick={() => {
                  setRemarksValidation(false);
                }}
                onChange={(e) =>
                  setUpdateCart({ ...updateCart, remarks: e.target.value })
                }
              />
              {remarksValidation ? (
                <Label className="text-danger">Remark can not be blank.</Label>
              ) : null}
            </Col>
            <Col sm="2">
              {remarksLoader ? (
                <Button className="btn btn-info mt-3" type="button">
                  Updating..
                </Button>
              ) : (
                <Button
                  className="btn btn-success mt-3"
                  type="button"
                  onClick={() => {
                    updateCartEntry();
                    alert("Updated");
                  }}
                >
                  Update
                </Button>
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={showDetails}
        zIndex="999999"
        size="xl"
        backdrop="static"
        centered="true"
        className="custom_modal"
        keepMounted
        fullWidth
        maxWidth="md"
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <ModalHeader>
          <Row style={{ marginBottom: "10px" }}>
            <Col sm="6">Customer Details</Col>
            <Col sm="6">
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={toggleDetail}
              ></i>
            </Col>
          </Row>
          <Row>
            <a
              className="btn btn-link btn-sm primary"
              href={
                "/branch/customer/add?id=" +
                window.btoa(customerDetails.customer_id)
              }
            >
              <i className="fa fa-edit"></i>Edit
            </a>
          </Row>
        </ModalHeader>

        <ModalBody style={{ maxHeight: "450px", overflowY: "auto" }}>
          <div className="dialog-border">
            <div className="container-fluid customerDetails">
              <div className="row">
                <div className="col-md-3">
                  <p className="text-dark mb-3">{"Name"}</p>
                  <h4 className="text-dark">
                    {customerDetails.full_name || "N/A"}
                  </h4>
                </div>
                <div className="col-md-3">
                  <p className="text-dark mb-3">{"Mobile"}</p>
                  <h4 className="text-dark">
                    {customerDetails.mobile || "N/A"}
                  </h4>
                </div>
                <div className="col-md-3">
                  <p className="text-dark mb-3">{"Gender"}</p>
                  <h4 className="text-dark">
                    {customerDetails.gender || "N/A"}
                  </h4>
                </div>
                <div className="col-md-3">
                  <p className="text-dark mb-3">{"Date Of Birth"}</p>
                  <h4 className="text-dark">{customerDetails.dob || "N/A"}</h4>
                </div>
              </div>
              <Divider className="my-3" />
              <div className="row">
                <div className="col-md-3">
                  <p className="text-dark mb-3">{"Date Of Anniversary"}</p>
                  <h4 className="text-dark">{customerDetails.doa || "N/A"}</h4>
                </div>
                <div className="col-md-3">
                  <p className="text-dark mb-3">{"Profession"}</p>
                  <h4 className="text-dark">
                    {customerDetails.profession || "N/A"}
                  </h4>
                </div>
                <div className="col-md-3">
                  <p className="text-dark mb-3">{"Address"}</p>
                  <h4 className="text-dark">
                    {customerDetails.address || "N/A"}
                  </h4>
                </div>

                <div className="col-md-3">
                  <p className="text-dark mb-3">{"Category Name"}</p>
                  <h4 className="text-dark">
                    {customerDetails.category_name || "N/A"}
                  </h4>
                </div>
              </div>
            </div>

            <Divider className="my-3" />

            <div className="row ml-1">
              <div className="col-md-3 ">
                <p className="text-dark mb-3">{"Total Visit"}</p>
                <h4 className="text-dark">
                  {customerDetails.visit_count || "N/A"}
                </h4>
              </div>
              <div className="col-md-3">
                <p className="text-dark mb-3">{"Last Visit"}</p>
                <h4 className="text-dark ">
                  {moment(customerDetails.date).format("DD/MM/YYYY HH:mm") ||
                    "N/A"}
                </h4>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 2,
            backgroundColor: "#fff",
          }}
        >
          <Button
            className="btn btn-danger"
            onClick={toggleDetail}
            color="secondary"
          >
            Close
          </Button>
          {/* <Button
            className="btn btn-primary"
            // onClick={toggleWhatsappMessageDetail}
            color="secondary"
          >
            Whatsapp History
          </Button> */}

          <Design mob={customerDetails.mobile} />
          <div>
            <CustomRedeem mobno={customerDetails.mobile} />
          </div>
        </ModalFooter>
      </Modal>
      {/* Total Cart New Design */}
      <Modal
        isOpen={modalCartDetailsNew}
        zIndex="99999"
        size="xl"
        fullscreen={true}
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
            <div className="d-flex align-items-center flex-wrap">
              <span className="font-weight-bold mr-3">Detailed Cart Details</span>
              <div
                className="input-group input-group-sm ml-2"
                style={{ width: "300px" }}
              >
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search cart..."
                  value={cartDetailSearch}
                  onChange={(e) => setCartDetailSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
                <div className="input-group-append">
                  <button
                    type="button"
                    className="btn btn-outline-theme"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <span
                onClick={
                  () =>
                    // downloadListImages()
                    generatePDFNew(
                      cartDetailFilteredProducts,
                      `Exported_data_${moment(dashboardShowDate.startDate).format(
                        "DD-MM-YYYY"
                      )}-${moment(dashboardShowDate.endDate).format(
                        "DD-MM-YYYY"
                      )}.pdf`
                    )
                  // downloadPdfDocument('data_list_table_new',`Exported_data_${moment(dashboardShowDate.startDate).format("DD-MM-YYYY")}-${moment(dashboardShowDate.endDate).format("DD-MM-YYYY")}.pdf`)
                }
                className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
              >
                <i className="flaticon2-download"></i> Download PDF
              </span>
              <i
                className="fa fa-close pointerShow ml-3"
                onClick={() => {
                  toggleCartDetailsNew();
                  setDownloadReady(false);
                }}
              ></i>
            </div>
          </div>
        </ModalHeader>
        <ModalBody
          className="table-responsive"
          style={{ maxHeight: "450px", overflowY: "auto" }}
        >
          <div className="table-responsive">
            <div className="row mb-4">
              {/* <div className="col-md-5">
                <label>
                  <b>
                    Date Range:{" "}
                    {moment(dashboardShowDate.startDate).format("DD/MM/YYYY")} -{" "}
                    {moment(dashboardShowDate.endDate).format("DD/MM/YYYY")}{" "}
                  </b>
                </label>
              </div> */}

              <div className="col-md-2">
                <label>
                  {" "}
                  <b>Product Category</b>
                </label>
                <select
                  className="form-control "
                  onChange={(e) => {
                    setFilteredCartId(e.target.value);
                  }}
                >
                  <option key={-1} value={0}>
                    All
                  </option>
                  {Object.entries(SubCategoryList).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <label>
                  {" "}
                  <b>Interest</b>
                </label>
                <select
                  className="form-control "
                  onChange={(e) => {
                    // alert(e.target.value)
                    setFilteredCartInterest(e.target.value);
                  }}
                >
                  <option key={-1} value={`all`}>
                    All
                  </option>
                  <option key={1} value="Yes">
                    Yes
                  </option>
                  <option key={2} value="Requirement">
                    Requirement
                  </option>
                  <option key={3} value="Follow Up">
                    Follow Up
                  </option>
                </select>
              </div>

              {/* ----------setFilteredCartUpdatedInterest */}

              {FilteredCartInterest == "Requirement" ||
                FilteredCartInterest == "Follow Up" ? (
                <div className="col-md-2">
                  <label>
                    <b>Updated Interest</b>
                  </label>
                  <select
                    className="form-control "
                    onChange={(e) => {
                      // alert(e.target.value)
                      setFilteredCartUpdatedInterest(e.target.value);
                    }}
                  >
                    <option key={-1} value={`all`}>
                      All
                    </option>
                    <option key={1} value="Yes">
                      Yes
                    </option>
                    <option key={2} value="Requirement">
                      Requirement
                    </option>
                    <option key={3} value="Follow Up">
                      Follow Up
                    </option>
                  </select>
                </div>
              ) : (
                ""
              )}
            </div>
            <div
              className="row total-cart-card-grid"
              id="data_list_table_new"
              ref={ImageBoxContainer}
            >
              {cartDetailFilteredProducts.map((item, index) => {
                if (item.image_path) {
                  return (
                    <ProductCard
                      item={item}
                      index={index}
                      key={index + "Item"}
                    />
                  );
                }
                return null; // Skip items without an image_path
              })}
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* ---------Service---------------- */}
      <Modal
        isOpen={serviceModal}
        zIndex="9999"
        size="xl"
        fullscreen={true}
        backdrop="static"
        centered="true"
        className={className}
      >
        <ModalHeader>
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
            <span className="font-weight-bold mr-3">Service Details</span>
            <div className="d-flex align-items-center flex-wrap">
              {DownloadReady ? (
                <a
                  href={DownloadLink}
                  className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
                  download="customers_data.csv"
                  target="_blank"
                >
                  <i className="flaticon2-download"></i> Click Here to Download
                </a>
              ) : (
                <span className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3">
                  <CiExport className="mr-2" size={18} strokeWidth={1.4} />
                  Export
                </span>
              )}
              <span className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3">
                <i className="flaticon2-download"></i> Download PDF
              </span>
              <Button
                className="ml-3"
                style={buttonStyle}
                onClick={toggleNextServiceToday}
              >
                <CircleNotificationsIcon style={{ fontSize: 28 }} />
                <span style={countStyle}>{todayServiceCount}</span>
                {nextServiceToday ? "Today's Service" : "All Service"}
              </Button>
              <FormGroup className="mb-0 ml-3">
                <Input
                  type="select"
                  name="statusFilter"
                  id="statusFilter"
                  value={statusFilter}
                  onChange={handleStatusChange}
                >
                  <option value="All">All</option>
                  <option value="Due">Due</option>
                  <option value="Pending...">Pending...</option>
                  <option value="OverDue">OverDue</option>
                  <option value="Reject">Reject</option>
                </Input>
              </FormGroup>
              <div className="ml-3">
                <ServiceAuto
                  count_serv={todayInterestYes}
                  from_date={dashboardShowDate.startDate}
                  end_date={dashboardShowDate.endDate}
                />
              </div>
              <i
                className="fa fa-close pointerShow ml-3"
                onClick={() => {
                  toggleService();
                }}
              ></i>
            </div>
          </div>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "500px", overflow: "hidden" }}>
          <div className="table-responsive">
            <ReactDatatable
              config={config}
              records={filteredCustomerService}
              columns={columns_cust_service}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* -----------------------PointModal-------------------------- */}
      <Modal
        isOpen={pointModal}
        zIndex="999999"
        size="lg"
        backdrop="static"
        centered="true"
      >
        <ModalHeader>
          <Row style={{ marginBottom: "10px" }}>
            <Col sm="6">Customer Point</Col>

            <Col sm="6">
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={togglePoint}
              ></i>
            </Col>
          </Row>
        </ModalHeader>

        <ModalBody style={{ maxHeight: "400px", overflow: "hidden" }}>
          <ReactDatatable
            ref={ref}
            config={config}
            records={customerPoint}
            columns={columns_cust_Point}
          />
        </ModalBody>
      </Modal>

      {/* ---------Add outsider Service---------------- */}

      <Modal
        isOpen={modalUpdateService}
        zIndex="999999"
        size="xl"
        backdrop="static"
        centered={true}
      >
        <ModalHeader>
          <Row style={{ marginBottom: "10px" }}>
            <Col sm="6">
              <div className="card-title">
                <h3 className="card-label">Customer</h3>
              </div>
            </Col>

            <Col sm="6">
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={toggleUpdateService}
              ></i>
            </Col>
          </Row>
          <Row>
            <Card
              className="shadow ml-4"
              style={{ width: "54rem", marginBottom: "-1%" }}
            >
              <CardHeader className="d-flex align-items-center justify-content-between font-weight-bold">
                <Col>
                  <i>{vichleDetails.full_name || ""}</i>
                </Col>
                <Col>
                  <i>{vichleDetails.mobile || ""}</i>
                </Col>
                <Col>
                  <h5 color="red">Date : </h5>
                </Col>
                <Col>
                  <Input
                    type="text"
                    value={getServiceDateFormat(vichleDetails.date)}
                    readOnly
                  ></Input>
                </Col>
              </CardHeader>
            </Card>
          </Row>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "450px", overflow: "auto" }}>
          <div className="table-responsive">
            {/* ------------------------------------------------------------------------------------------ */}
            <Row>
              <Col sm="8">
                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="category">Category</Label>
                      <Input
                        type="text"
                        placeholder="Category"
                        name="category"
                        id="category"
                        value={vichleDetails.category || ""}
                        onChange={handleUploadService}
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="model">Modal</Label>
                      <Input
                        type="text"
                        placeholder="Modal"
                        name="model"
                        id="model"
                        value={vichleDetails.model || ""}
                        onChange={handleUploadService}
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="color">Color</Label>
                      <Input
                        type="text"
                        placeholder="Color"
                        name="color"
                        id="color"
                        value={vichleDetails.color || ""}
                        onChange={handleUploadService}
                      ></Input>{" "}
                    </FormGroup>
                  </Col>
                </Row>
                <br />

                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="vichle_number">Vichle Number</Label>
                      <Input
                        type="text"
                        placeholder="Vichle Number"
                        name="vichle_number"
                        id="vichle_number"
                        value={vichleDetails.vichle_number || ""}
                        onChange={handleUploadService}
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="kms">KMS</Label>
                      <Input
                        type="number"
                        placeholder="KMS"
                        id="kms"
                        name="kms"
                        value={vichleDetails.kms || ""}
                        onChange={handleIntegerForm}
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="last_service">Last Service</Label>
                      <Input
                        type="date"
                        placeholder="Last Service"
                        name="last_service"
                        id="last_service"
                        value={
                          getServiceDateFormat(vichleDetails.last_service) || ""
                        }
                        onChange={handleUploadService}
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <br />

                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="staff">Staff</Label>
                      <Input
                        type="text"
                        placeholder="staff"
                        id="staff"
                        name="staff"
                        value={vichleDetails.staff || ""}
                        onChange={handleUploadService}
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="payment">Payment</Label>
                      <Input
                        type="number"
                        placeholder="Payment"
                        name="payment"
                        id="payment"
                        value={vichleDetails.payment || ""}
                        onChange={handleIntegerForm}
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="next_service">Next Service</Label>
                      <Input
                        type="date"
                        placeholder="Next Service"
                        name="next_service"
                        id="next_service"
                        value={
                          getServiceDateFormat1(vichleDetails.next_service) ||
                          ""
                        }
                        onChange={handleUploadService}
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="status">Status</Label>
                      <Input
                        type="select"
                        name="status"
                        id="status"
                        value={vichleDetails.status || ""}
                        onChange={handleUploadService}
                      >
                        <option value="Pending...">Pending...</option>
                        <option value="Due">Due</option>
                        <option value="OverDue">OverDue</option>
                        <option value="Done">Done</option>
                        <option value="Reject">Reject</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="remark">Remark</Label>
                      <Input
                        type="textarea"
                        placeholder="Remark"
                        name="remark"
                        id="remark"
                        value={vichleDetails.remark || ""}
                        onChange={handleUploadService}
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <br />
              </Col>

              <Col sm="3">
                <Row>
                  <Input
                    id="imageInput"
                    className="image-cart"
                    type="file"
                    name="Choose Image"
                    onChange={handleImageChange}
                  />

                  {serviceImage ? (
                    <img
                      style={{
                        width: "230px",
                        height: "230px",
                        borderRadius: "4px",
                        marginTop: "4px",
                      }}
                      src={serviceImgPreview}
                      alt="Image"
                      className="mr-10"
                    />
                  ) : (
                    <img
                      style={{
                        width: "230px",
                        height: "230px",
                        borderRadius: "4px",
                        marginTop: "4px",
                      }}
                      src={
                        API_BASE_URL + "CustomerUploads/" + vichleDetails.image
                      }
                      alt="Image"
                    />
                  )}
                </Row>
              </Col>

            </Row>
            <Row className="justify-content-end">
              <Col md="auto">
                <Button
                  size="xl"
                  className="btn btn-success"
                  onClick={handleFormUpdateService}
                >
                  Save
                </Button>
              </Col>
            </Row>
            <hr style={{ border: "2px solid blue" }} />
            {/* --------------------------------------------------------------------- */}
          </div>
        </ModalBody>
      </Modal>
      {/* -------------------------------------------------------------------------------- */}
      <Modal
        isOpen={modalAddMoreService}
        zIndex="999999"
        size="xl"
        backdrop="static"
        centered={true}
      >
        <ModalHeader>
          <Row style={{ marginBottom: "10px" }}>
            <Col sm="6">
              <h4>Add Service</h4>
            </Col>
            <Col sm="6">
              <CloseIcon
                style={{ float: "right" }}
                onClick={toggleAddMoreService}
              />
            </Col>
          </Row>
          <Row>
            <Card
              className="shadow ml-4"
              style={{ width: "60rem", marginBottom: "-1%" }}
            >
              <CardHeader className="d-flex align-items-center justify-content-between font-weight-bold">
                <Col>
                  <i>{customerData.name || ""}</i>
                </Col>
                <Col>
                  <i>{customerData.mobile || ""}</i>
                </Col>
                <Col>
                  <h5 color="red">Date : </h5>
                </Col>
                <Col>
                  <Input
                    type="text"
                    value={moment(customerData.date).format("DD/MM/YYYY")}
                    readOnly
                  ></Input>
                </Col>
              </CardHeader>
            </Card>
          </Row>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "480px", overflowY: "auto" }}>
          <div className="table-responsive" id="data_list_table">
            <Row>
              <Col sm="9">
                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="category">Category</Label>
                      <Input
                        type="text"
                        placeholder="Category"
                        value={customerData.category || ""}
                        readOnly
                        id="category"
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="modal">Model</Label>
                      <Input
                        type="text"
                        id="modal"
                        placeholder="Modal"
                        value={customerData.modal || ""}
                        readOnly
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="color">Color</Label>
                      <Input
                        type="text"
                        placeholder="Color"
                        value={customerData.color || ""}
                        readOnly
                        id="color"
                      ></Input>{" "}
                    </FormGroup>
                  </Col>
                </Row>
                <br />

                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="staff">Staff</Label>
                      <Input
                        type="text"
                        id="staff"
                        placeholder="Staff"
                        value={customerData.staff || ""}
                        readOnly
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="payment">Payment</Label>
                      <Input
                        type="text"
                        placeholder="Payment"
                        value={customerData.payment || ""}
                        readOnly
                        id="payment"
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="next_service">Service Due</Label>
                      <Input
                        type="date"
                        placeholder="Next Service"
                        value={
                          getServiceDateFormat1(
                            customerData.next_service_date
                          ) || ""
                        }
                        readonly
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="remark">Remark</Label>
                      <Input
                        type="textarea"
                        placeholder="Remark"
                        id="remark"
                        value={customerData.remark || ""}
                        readOnly
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <br />
              </Col>

              <Col sm="3">
                <img
                  style={{
                    width: "230px",
                    height: "230px",
                    backgroundColor: "black",

                  }}
                  src={`${API_BASE_URL}CustomerUploads/${customerData.image}`}
                />
              </Col>

            </Row>

            <hr style={{ border: "2px solid blue" }} />
            {/* ------------------part 2  */}
            <SubService
              nxt={getServiceDateFormat1(customerData.next_service_date)}
              customerData={customerData}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* --------Service Due Notification ------------------ */}

      <Modal
        isOpen={modalServiceNoti}
        zIndex="999999"
        size="lg"
        backdrop="static"
        centered="true"
      >
        <ModalHeader>
          <Row style={{ marginBottom: "10px" }}>
            <Col sm="6">Notification</Col>

            <Col sm="6">
              <i
                className="fa fa-close pull-right pointerShow"
                onClick={toggleServiceNoti}
              ></i>
            </Col>
          </Row>
        </ModalHeader>

        <ModalBody style={{ maxHeight: "400px", overflow: "hidden" }}>
          <ReactDatatable
            ref={ref}
            config={config}
            records={serviceNoti}
            columns={columns_service_noti}
          />
        </ModalBody>
      </Modal>

      {/* ----------------- */}

      {/* Modal */}
      <Modal
        isOpen={showSaleDetails}
        size="xl"
        zIndex="999999"
        centered
        backdrop="static"
        fullscreen={true}
        className={className}
      >
        <ModalHeader>
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
            <div className="d-flex align-items-center flex-wrap">
              <span className="font-weight-bold mr-3">Sales Details</span>
              <div
                className="input-group input-group-sm ml-2"
                style={{ width: "300px" }}
              >
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search sales..."
                  value={salesDetailSearch}
                  onChange={(e) => setSalesDetailSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
                <div className="input-group-append">
                  <button
                    type="button"
                    className="btn btn-outline-theme"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <button
                type="button"
                onClick={downloadSalesPdf}
                disabled={salesPdfDownloading}
                className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3 ml-3"
              >
                {salesPdfDownloading ? (
                  <>
                    <span className="spinner-border spinner-border-sm mr-2"></span>
                    Downloading...
                  </>
                ) : (
                  <>
                    <i className="flaticon2-download"></i> Download PDF
                  </>
                )}
              </button>
              <i
                className="fa fa-close pointerShow ml-3"
                onClick={toggleShowSaleDetails}
              ></i>
            </div>
          </div>
        </ModalHeader>

        <ModalBody
          className="table-responsive"
          style={{ maxHeight: "450px", overflowY: "auto" }}
        >

          {/* <div className="mb-3">
          <label className="mb-0">
            <b>
              Date Range:{" "}
              {moment(dashboardShowDate.startDate).format("DD/MM/YYYY")} -{" "}
              {moment(dashboardShowDate.endDate).format("DD/MM/YYYY")}
            </b>
          </label>
        </div> */}
          <div
            className="row total-cart-card-grid"
            id="data_list_table_new"
            ref={ImageBoxContainer}
          >
            {salesDetailFilteredGrid.map((item, index) => {
              if (item.image_path) {
                return (
                  <SalesCard
                    item={item}
                    index={index}
                    key={index + "Item"}
                  />
                );
              }
              return null; // Skip items without an image_path
            })}
          </div>




        </ModalBody>
      </Modal>

      {/* ----------------- */}
    </div>
  );
}
